import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import qs from "query-string";

import ConfirmationModal from "../common/components/ConfirmationModal";
import Portal from "../common/components/Portal";
import initativeAction from "../initiatives/actions";

import CommonActions, { getTableConfig, saveTableConfig } from "../common/actions";
import regionActions from "../region/actions";
import projectAction from "../project/actions";
import ViewExportModal from "./components/ExportSettingsModal";
import ViewModal from "../common/components/ViewModal";
import AssignClientUserModal from "./components/AssignClientUserModal";
import AssignConsultancyUserModal from "./components/AssignConsultancyUserModal";
import recommendationsActions from "./actions";
import softCostActions from "../softCosts/actions";
import { getReviewGateStatus } from "./utils/qaGateValidation";
import siteActions from "../site/actions";
import buildingActions from "../building/actions";
import _, { cloneDeep } from "lodash";
import RecommendationsMain from "./components/RecommendationsMain";
import Form from "./components/Form";
import Loader from "../common/components/Loader";
import { recommendationsTableData } from "../../config/tableData";
import RecommendationsInfo from "./components/RecommendationsInfo";
import RecommendationsOtto from "./RecommendationsOtto";
import { createTableController } from "../filterAssistant/capabilities/tableView/tableController";
import {
    addToBreadCrumpData,
    findPrevPathFromBreadCrumpData,
    findPrevPathFromBreadCrumpRecData,
    popBreadCrumpRecData,
    checkPermission,
    popBreadCrumpOnPageClose,
    findPrevPathFromBreadCrump,
    getTableSliderData,
    addTableSliderDataToBreadcrumb,
    updateBreadCrumpData,
    AppliedQueryFilters,
    removeAllTags,
    convertToXML,
    showAlert as showAlertUtil
} from "../../config/utils";
import { validateFirstWord, isVerbValidationEnabled } from "../../utils/recommendationVerbs";
import "../../assets/css/add-recommendation.css";
import MultiSelectFormModal from "./components/MultiSelectFormModal";
import { energy_fields } from "./components/Bands/EnergyBand";
import { water_fields } from "./components/Bands/WaterBand";
import { lockRecommendation, normalRecomGrouping } from "./services";
import { getPinnedColumnLeftPositions, insertFields, removeFields } from "../../utils/tableUtils";
import { DYNAMIC_FIELD_TYPES, entities, LOCK_STATUS, RECOMMENDATION_SOURCE_TYPES, RECOMMENDATION_TYPES } from "../common/constants";
import { DynamicColumnModal } from "../common/DynamicColumnModal";
import { MyFilters } from "../dashboard/components/FilterModal/MyFilters";
import { ShiftCspModal } from "./components/ShiftCspModal";
import LinkRecommendationToCRModal from "./components/LinkRecommendationToCRModal";
import { AppliedFilters } from "../common/AppliedFilters";
import { getAppliedFiltersCount, reverseDynamicFieldParams } from "../../utils/filtersUtils";
import { permissions } from "../../config/permissions";
import { canUseOtto } from "../filterAssistant/core/ottoAccess";
import { getUpdatedCommonFilters, getUpdatedSortFilters, getUpdatedWildCardFilters } from "./components/GroupingFunctions";
import smartChartAction from "../smartCharts/actions";
import RecommendationLog from "./components/RecommendationLog";
import { QueriesModal } from "../dashboard/components/QueriesModal";
import dashboardActions from "../dashboard/actions";
import assetActions from "../assets/actions";
import "../dashboard/dashboard.css";
import "./recommendation.css";
import statusAction from "../Status/action";
import imageAction from "../images/actions";
import { computeTableConfig } from "../../utils/tableUtils";
import { formatCapitalRequestSourceValue, getCapitalRequestLabel } from "../../utils/capitalRequestLabel";
import SearchAndReplace from "../assetSurveyProject/components/SearchAndReplace";
import ProgressBarModal from "../common/ProgressBarModal";
import { SEARCH_AND_REPLACE_REMOVED_FIELDS } from "./constants";
import { ERROR_COPY } from "../../config/errorMessages";

const getTableDataWithStickyColumnLeft = (tableData, columnKey) => {
    const columnConfig = tableData?.config?.[columnKey];
    if (!columnConfig) return tableData;

    return {
        ...tableData,
        config: {
            ...tableData.config,
            [columnKey]: {
                ...columnConfig,
                style: {
                    ...columnConfig.style,
                    "--sticky-column-left": columnConfig?.style?.left || "54px"
                }
            }
        }
    };
};

class index extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.pinnedColumnsRef = {};
        const {
            match: {
                params: { section }
            },
            location
        } = this.props;
        const { filterValues = {}, tempChartFilters = {}, tempQueryChartFilters = {} } = this.props.dashboardReducer;
        this.exportTableXl = this.exportTableXl.bind(this);
        this.isDashboardFiltered = false;
        let bcData = findPrevPathFromBreadCrumpRecData();
        if (bcData && bcData[0]) {
            this.isDashboardFiltered = bcData[0].name === "Dashboard" ? true : false;
        }
        const gaugeFilters = location?.state?.gaugeFilters;
        if (gaugeFilters) {
            this.isDashboardFiltered = true;
        }
        this.gaugeFilterTags = location?.state?.gaugeFilterTags || [];
        this.state = {
            isLoading: true,
            errorMessage: "",
            recommendationsList: [],
            exportWordLoading: false,
            paginationParams: this.props.recommendationsReducer.entityParams[section]?.paginationParams || {
                totalPages: 0,
                perPage: 40,
                currentPage: 0,
                totalCount: 0
            },
            currentViewAllUsers: null,
            currentActions: null,
            tableLoading: false,
            exportAllTradesLoading: false,
            showViewModal: false,
            showViewModalExport: { show: false, type: "" },
            showWildCardFilter: false,
            showSearchAndReplaceModal: false,
            showAssignConsultancyUsers: false,
            showNewOrExistingConfirmModal: false,
            showMergeOrReplaceModal: false,
            recommendationsData: {},
            clients: [],
            regionList: [],
            consultancy_users: [],
            openRecommendationExportTrigger: 0,
            confirmUnAssign: false,
            selectedRowId: this.props.recommendationsReducer.entityParams[section]?.selectedRowId,
            initiative_ids: this.props.recommendationsReducer.entityParams[section]?.initiative_ids,
            params: this.props.recommendationsReducer.entityParams[section]?.params || {
                limit: 40,
                offset: 0,
                search: "",
                filters: null,
                list: null,
                year: [],
                index: [],
                priority_elements: null,
                unlocked: true,
                surveyor: null,
                requestor: null,
                image_or_not: null,
                review_status: null,
                qa_qc_status: null,
                opinions_cost_vs_project_total: null,
                infrastructure_request: null,
                water: null,
                caption_missing: null,
                energy: null,
                facility_master_plan: null,
                recommendation_type: null,
                budget_priority: null,
                findParams: null,
                dynamic_joins: []
            },
            capital_type: this.props.recommendationsReducer.entityParams[section]?.capital_type,
            dashboard: this.props.recommendationsReducer.entityParams[section]?.dashboard,
            start_year: this.props.recommendationsReducer.entityParams[section]?.start_year,
            end_year: this.props.recommendationsReducer.entityParams[section]?.end_year,
            infrastructure_requests: this.props.recommendationsReducer.entityParams[section]?.infrastructure_requests,
            year: this.props.recommendationsReducer.entityParams[section]?.year,
            selectedClient: {},
            selectedRecommendations: this.props.projectIdDashboard
                ? this.props.projectIdDashboard
                : this.props.match.params.id || this.props.recommendationsReducer.entityParams[section]?.selectedEntity,
            tableData: {
                keys: _.cloneDeep(recommendationsTableData.keys),
                config: this.props.recommendationsReducer.entityParams[section]?.tableConfig || _.cloneDeep(recommendationsTableData.config)
            },
            initialTableConfig: _.cloneDeep(recommendationsTableData.config),
            wildCardFilterParams: this.props.recommendationsReducer.entityParams[section]?.wildCardFilterParams,
            filterParams: this.props.recommendationsReducer.entityParams[section]?.filterParams,
            building_ids: this.props.recommendationsReducer.entityParams[section]?.building_ids,
            selectedYear: "",
            maintenance_years: [],
            summaryRowData: {
                crv_total: "",
                year_totals: {}
            },
            showRestoreConfirmModal: false,
            isDeleted: false,
            showConfirmCopyPasteModal: false,
            target_year: "",
            historyPaginationParams: this.props.recommendationsReducer.entityParams[section]?.historyPaginationParams || {
                totalPages: 0,
                perPage: 40,
                currentPage: 0,
                totalCount: 0
            },
            historyParams: this.props.recommendationsReducer.entityParams[section]?.historyParams || {
                limit: 40,
                offset: 0,
                search: ""
            },
            logData: {
                count: "",
                data: []
            },
            showConfirmModalLog: false,
            selectedLog: "",
            isRestoreOrDelete: "",
            selectedMainItem: "",
            selectedDropdown: this.props.recommendationsReducer.entityParams[section]?.selectedDropdown || "unlocked",
            selectedDropdownInitiaive: this.props.recommendationsReducer.entityParams[section]?.selectedDropdownInitiaive || "assigned",
            alertMessage: "",
            permissions: {},
            logPermission: {},
            imageResponse: [],
            selectedRecomIds: this.props?.isCrLinkPicker ? [] : (this.props.recommendationsReducer.entityParams[section]?.selectedRecomIds ?? []),
            tempRecommendationsList: this.props?.isCrLinkPicker
                ? []
                : this.props.recommendationsReducer?.entityParams[section]?.recommendationList || [],
            showMultiSelectEditForm: false,
            currentFilterParams: {},
            exportLoader: false,
            multiExportPdfLoader: false,
            multiExportWordLoader: false,
            showHardDeleteConfirmationModal: false,
            dashboardFilterParams: gaugeFilters
                ? { ...gaugeFilters, dashboard: true }
                : this.isDashboardFiltered
                  ? { ...filterValues, ...tempChartFilters, ...tempQueryChartFilters, dashboard: true }
                  : {},
            parentSectionId: this.props.recommendationsReducer.entityParams[section]?.parentSectionId || this.props.match.params.id,
            tableDataExportFilters: this.props.recommendationsReducer?.entityParams[section]?.tableDataExportFilters || {},
            isInputMode: {
                rowIndex: "",
                keyItem: ""
            },
            lineEditingEnabled: this.props.recommendationsReducer?.entityParams[section]?.lineEditingEnabled ?? false,
            initialFiltersSetForSmartChart: false,
            showFiltersPopup: false,
            myFilters: this.props.recommendationsReducer.entityParams[section]?.myFilters || {},
            showShiftCspModal: false,
            showLinkRecommendationModal: false,
            linkRecommendationLoader: false,
            crLinkSelectedRecoms: [],
            showCrUnlinkConfirmModal: false,
            showAppliedFilters: false,
            isTableResetting: false,
            showAssignConfirmationModal: false,
            normalRecomGrouping: {},
            isNormalRecomGroupingLoading: false,
            tableConfigChanged: false,
            lineEditDropdownValue: null,
            lineEditSuggestionValue: [],
            isDropdownLoading: null,
            openRecommendationLog: false,
            showQueriesModal: false,
            showSavedViews: false,
            queries: this.props.recommendationsReducer.entityParams[section]?.queries || [],
            selectedPreviewId: this.props.recommendationsReducer.entityParams[section]?.selectedPreviewId,
            paneViewEnabled: this.props.recommendationsReducer.entityParams[section]?.paneViewEnabled,
            dropdownCache: {},
            showForceUpdateConfirmModal: false,
            confirmRowIndex: null,
            confirmParams: null,
            appliedTableView: this.props.recommendationsReducer.entityParams[section]?.appliedTableView || [],
            setSearchField: "",
            setHighlightSearchField: "",
            searchReplaceTaskIds: [],
            pendingFindParams: null,
            progressBarModal: false
        };
    }
    handleKeyDown = event => {
        const { tableData, selectedPreviewId, paneViewEnabled, selectedRowId } = this.state;

        if (this.props?.match?.params?.tab !== "recommendations") return;

        if (!tableData?.data?.length) return;
        const selectedRecommendationIndex = tableData?.data?.findIndex(e => e?.id === selectedRowId);
        if (["ArrowUp", "ArrowDown"]?.includes(event?.key)) {
            const isArrowUp = event.key === "ArrowUp";
            const newIndex = isArrowUp
                ? Math.max(selectedRecommendationIndex - 1, 0)
                : Math.min(selectedRecommendationIndex + 1, tableData.data.length - 1);

            const newPreviewId = tableData.data[newIndex]?.id;

            const updatedState = { selectedRowId: newPreviewId };
            if (paneViewEnabled && selectedPreviewId && newIndex !== selectedRecommendationIndex) {
                this.getAllImageList(newPreviewId, { limit: 100, offset: 1 });
                updatedState.selectedPreviewId = newPreviewId;
            }

            this.setState(updatedState, () => this.scrollToSelectedRow(newIndex));
        }

        // if (event.key === "Enter") {
        //     this.updateSelectedRow(selectedRowId, paneViewEnabled);
        //     if (!paneViewEnabled) this.showInfoPage(selectedRowId, null, null, false, false);
        // }
    };

    scrollToSelectedRow = index => {
        const rows = this.tableRef.current?.querySelectorAll("tr");
        if (rows && rows[index]) {
            rows[index].scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }
    };
    componentWillUnmount() {
        if (this.props.match.params.tab === "recommendations") {
            window.removeEventListener("keydown", this.handleKeyDown);
        }
        clearInterval(this.backgroundTaskProgressInterval);
        this.backgroundTaskProgressInterval = null;
        this.props.resetRecomGroupEditReducer();
    }
    componentDidMount = async () => {
        const {
            match: {
                params: { section }
            },
            location
        } = this.props;

        if (this.props?.isCrLinkPicker && Object.keys(this.props?.defaultList || {}).length) {
            await this.setState(prevState => ({
                params: { ...prevState.params, list: { ...(prevState.params.list || {}), ...this.props.defaultList } }
            }));
        }

        const {
            location: { search, state }
        } = this.props;
        const query = qs.parse(search);
        const isCrRecommendationsView = this.isCrLinkedTab();
        const projectId =
            this.props.projectIdDashboard ||
            this.props?.projectIdForSmartChart ||
            query.pid ||
            this.props?.projectIdMobile ||
            (isCrRecommendationsView ? "" : this.props.match.params.id) ||
            "";
        if (
            projectId &&
            (isCrRecommendationsView ||
                (this.props.match.path !== "/recommendations/:section/:id/:tab" &&
                    this.props.match.path !== "/recommendations/:section/:id"))
        ) {
            this.setState({ isTableResetting: true });
            await Promise.all([
                this.props.getProjectById(projectId),
                this.props.getPriorityElementDropDownData(projectId),
                this.props.getDynamicFields({ project_id: projectId }),
                isVerbValidationEnabled() ? this.props.getRecommendationAcceptableVerbsByProject(projectId) : Promise.resolve()
            ]);

            await this.setTableDataConfigBasedOnProject();
            await this.setDynamicJoinParam();
            this.setState({ isTableResetting: false });
        }
        if (this.state.paneViewEnabled && this.state.selectedPreviewId) {
            this.getAllImageList(this.state.selectedPreviewId, { limit: 100, offset: 1 });
        }
        if (this.props.match.params.tab === "recommendation") {
            if (this.state.parentSectionId !== this.props.match.params.id || state?.from === "dashboard") {
                await this.resetEntityParams();
                this.props.setRecommendationScrollPosition(1);
            }
            this.setState(
                {
                    selectedDropdownInitiaive: "assigned",
                    selectedDropdown: "unlocked",
                    params: {
                        ...this.state.params,
                        view: "assigned",
                        locked: null,
                        unlocked: true
                    },
                    parentSectionId: this.props.match.params.id
                },
                async () => {
                    await this.updateEntityParams();
                    await this.refreshRecommendationsList(true);
                }
            );
        }
        // -----------------------------------
        else if (
            this.props.match.params.tab === "recommendations" ||
            this.props.match.params.tab === "linked-recommendations" ||
            this.props.match.params.tab === "linked-cr-recommendations"
        ) {
            if (this.state.parentSectionId !== this.props.match.params.id || state?.from === "dashboard") {
                const CrDataupdatedchanges =
                    this.state.tableData.config &&
                    Object.keys(this.state?.tableData?.config)?.reduce((acc, key) => {
                        acc[key] = { ...this.state?.tableData?.config?.[key], pinned: false };
                        return acc;
                    }, {});

                await this.resetEntityParams(this.props.match.params.tab === "linked-cr-recommendations" ? CrDataupdatedchanges : "");
                this.props.setRecommendationScrollPosition(1);
            }
            this.setState(
                {
                    selectedDropdown: this.props.recommendationsReducer.entityParams[this.props.match.params.section]?.selectedDropdown || "unlocked",
                    params: {
                        ...this.state.params,
                        view: null
                    },
                    parentSectionId: this.props.match.params.id
                },
                async () => {
                    await this.updateEntityParams();
                    await this.refreshRecommendationsList();

                    if (this.props.match.params.tab === "recommendations") {
                        const savedScrollPosition = this.props.recommendationsReducer.scrollPosition;
                        if (savedScrollPosition !== null && this.tableRef.current) {
                            if (this?.tableRef?.current) {
                                this.tableRef.current.scrollLeft = savedScrollPosition;
                            }
                        }
                    } else {
                        if (this?.tableRef?.current) {
                            this.tableRef.current.scrollLeft = 1;
                        }
                    }
                }
            );
            if (this.props.match.params.tab === "recommendations") {
                window.addEventListener("keydown", this?.handleKeyDown);
            }
        } else if (
            this.props.match.path === "/recommendations/:section/:id/:tab" ||
            this.props.match.path === "/recommendations/:section/:id" ||
            section === "add"
        ) {
            this.setState({ isLoading: false });
        } else {
            //setting initial filters for smart chart recom tiles
            if (this.props?.isSmartChartView) {
                let selectedWildCardFilters = null;
                let tempSelectedRecomIds = [];
                let selectedCommonFilters = null;
                let selectedTableDataExportFilters = {};
                let selectedGlobalSearchValue = "";
                let selectedOrderFilter = null;
                let selectedMaintenanceYear = [];
                let selectedsurveyorValue = "";
                let selectedImageValue = "";
                let selectedinfrastructureValue = "";
                let selectedWaterValue = "";
                let selectedCaptionValue = "";
                let selectedBudgetValue = "";
                let selectedEnergyValue = "";
                let selectedFacilityValue = "";
                let selectedRecommendationValue = "";
                let selectedRecommendationIds = [];
                let priority_elements_sort = [];
                let priority_elements_index = [];

                tempSelectedRecomIds = this.props?.selectedRecomIdList?.map(recomId => {
                    return {
                        id: recomId
                    };
                });
                if (this.props?.smartChartTileConfig?.band1?.config_filter || this.props?.smartChartTileConfig?.config_filter) {
                    let configFilterData =
                        this.props?.smartChartTileConfig?.band1?.config_filter || this.props?.smartChartTileConfig?.config_filter || {};
                    let configFilterDataFilters =
                        this.props?.smartChartTileConfig?.band1?.config_filter_names || this.props?.smartChartTileConfig?.config_filter_names || {};
                    const {
                        wildcard_filters = {},
                        global_search = "",
                        sort_by_order = {},
                        surveyor = null,
                        image_or_not = null,
                        infrastructure_request = null,
                        water = null,
                        caption_missing = null,
                        energy = null,
                        facility_master_plan = null,
                        recommendation_type = null,
                        budget_priority = null,
                        recommendation_ids = [],
                        priority_elements = [],
                        ...common_filters
                    } = configFilterData;
                    if (recommendation_ids?.length > 0) {
                        selectedRecommendationIds = recommendation_ids;
                    }
                    if (Object.keys(wildcard_filters).length) {
                        selectedWildCardFilters = configFilterDataFilters?.filters || null;
                    }
                    if (Object.keys(common_filters || {}).length) {
                        selectedCommonFilters = configFilterDataFilters?.list || null;
                    }
                    if (
                        Object.keys(
                            this.props?.smartChartTileConfig?.band1?.config_filter_names?.tableDataExportFilters ??
                                this.props?.smartChartTileConfig?.config_filter_names?.tableDataExportFilters ??
                                {}
                        )?.length
                    ) {
                        selectedTableDataExportFilters =
                            configFilterDataFilters?.tableDataExportFilters ?? configFilterDataFilters?.tableDataExportFilters ?? {};
                    }
                    if (global_search) {
                        selectedGlobalSearchValue = global_search;
                    }
                    if (surveyor) {
                        selectedsurveyorValue = surveyor;
                    }
                    if (image_or_not) {
                        selectedImageValue = image_or_not;
                    }
                    if (infrastructure_request) {
                        selectedinfrastructureValue = infrastructure_request;
                    }
                    if (water) {
                        selectedWaterValue = water;
                    }
                    if (caption_missing) {
                        selectedCaptionValue = caption_missing;
                    }
                    if (energy) {
                        selectedEnergyValue = energy;
                    }
                    if (facility_master_plan) {
                        selectedFacilityValue = facility_master_plan;
                    }
                    if (recommendation_type) {
                        selectedRecommendationValue = recommendation_type;
                    }
                    if (budget_priority) {
                        selectedBudgetValue = budget_priority;
                    }
                    if (Object.keys(sort_by_order).length) {
                        selectedOrderFilter = configFilterDataFilters?.order || null;
                        selectedMaintenanceYear = configFilterDataFilters?.maintenance_year || [];
                    }
                    if (priority_elements?.length) {
                        priority_elements_sort = priority_elements || [];
                        priority_elements_index = configFilterData?.index;
                    }
                }
                await this.setState({
                    selectedRecomIds: tempSelectedRecomIds,
                    params: {
                        ...this.state.params,
                        // ...this.props?.smartChartTileConfig?.config_filter,
                        filters: selectedWildCardFilters ? { ...selectedWildCardFilters } : null,
                        list: selectedCommonFilters ? { ...selectedCommonFilters } : null,
                        search: selectedGlobalSearchValue,
                        water: selectedWaterValue,
                        caption_missing: selectedCaptionValue,
                        energy: selectedEnergyValue,
                        infrastructure_request: selectedinfrastructureValue,
                        budget_priority: selectedBudgetValue,
                        recommendation_type: selectedRecommendationValue,
                        facility_master_plan: selectedFacilityValue,
                        surveyor: selectedsurveyorValue,
                        image_or_not: selectedImageValue,
                        order: selectedOrderFilter,
                        maintenance_year: selectedMaintenanceYear,
                        recommendation_ids: selectedRecommendationIds,
                        priority_elements: priority_elements_sort,
                        index: priority_elements_index
                    },
                    tableDataExportFilters: selectedTableDataExportFilters,
                    initialFiltersSetForSmartChart: true
                });
                this.updateEntityParams();
            }
            await this.refreshRecommendationsList();
        }
        if (this.props.match.params.tab !== "recommendations" && this?.tableRef?.current) {
            this.tableRef.current.scrollLeft = 1;
        }
        if (state?.openRecommendationExport) {
            this.openRecommendationExportFromRoute();
        }
    };
    // handleScroll = () => {
    //     if (this.tableRef.current && this.props.match.params.tab === "recommendations") {
    //         if (this.tableRef.current.scrollLeft) {
    //             this.props.setRecommendationScrollPosition(this.tableRef.current.scrollLeft);
    //         }
    //     }
    // };

    componentDidUpdate = async (prevProps, prevState) => {
        if (this.props?.isCrLinkPicker && this.state.selectedRecomIds !== prevState.selectedRecomIds) {
            this.props.handleSurveyAssign?.(this.state.selectedRecomIds.map(elem => elem.id));
        }
        if (this.props.location.state?.openRecommendationExport && this.props.location.key !== prevProps.location.key) {
            this.openRecommendationExportFromRoute();
        }
        if (this.props.recommendationsReducer?.getGroupEditProgressResponse !== prevProps.recommendationsReducer?.getGroupEditProgressResponse) {
            this.handleBackgroundTaskProgressResponse();
        }
        if (this.props.recommendationsReducer?.getAllRecommendationsResponse !== prevProps.recommendationsReducer?.getAllRecommendationsResponse) {
            this.trackBackgroundTaskFromList();
        }
        if (
            (this.props.match.params.tab !== prevProps.match.params.tab || this.props.match.params.id !== prevProps.match.params.id) &&
            this?.tableRef?.current
        ) {
            this.tableRef.current.scrollLeft = 1;
        }
        if (
            // this.props.location.search !== prevProps.location.search ||
            (this.props.match.params.id !== prevProps.match.params.id || this.props.match.params.tab !== prevProps.match.params.tab) &&
            (["linked-recommendations", "linked-cr-recommendations"].includes(this.props.match.params.tab) ||
                (this.props.match.path !== "/recommendations/:section/:id/:tab" &&
                    this.props.match.path !== "/recommendations/:section/:id"))
        ) {
            this.setState({ isTableResetting: true, isLoading: true, tableConfigChanged: false });
            if (this.props.match.params.section === "projectinfo") {
                await this.resetEntityParams();
            }

            await this.setTableDataConfigBasedOnProject();
            await this.setDynamicJoinParam();
            this.setState({ isTableResetting: false });
            await this.refreshRecommendationsList();
        }
        if (prevProps.submitAssign !== this.props.submitAssign) {
            if (this.props.submitAssign) {
                await this.refreshRecommendationsList();
            }
        }
        if (this.props.isBudgetPriority && prevProps.getDashboardValue !== this.props.getDashboardValue) {
            await this.refreshRecommendationsList();
        }

        if (
            this.props.match.params.subTab === "assigned-recommendations" &&
            (prevProps.projectId !== this.props.projectId || this.props.match.params?.templateId !== prevProps.match.params?.templateId)
        ) {
            const {
                match: {
                    params: { section, tab }
                },
                location: { search }
            } = this.props;
            const query = qs.parse(search);
            this.setState({ isTableResetting: true, isLoading: true, tableConfigChanged: false });
            await this.resetEntityParams();
            await Promise.all([
                this.props.getProjectById(this.props?.projectId ?? query?.pid),
                this.props.getPriorityElementDropDownData(this.props?.projectId ?? query?.pid),
                this.props.getDynamicFields({ project_id: this.props?.projectId ?? query?.pid })
            ]);
            await this.setTableDataConfigBasedOnProject();
            await this.setDynamicJoinParam();
            this.setState({ isTableResetting: false });
            await this.refreshRecommendationsList();
        }
        const { isAssignRecomView = false } = this.props;
        if (
            ((this.props.match.params.id !== prevProps.match.params.id &&
                (this.props.match.params.tab === "linked-cr-recommendations" || this.props.match.params.tab === "linked-recommendations")) ||
                (this.props.match.params.mrId !== prevProps.match.params.mrId && this.props.match.params.tab === "mr-recommendations")) &&
            !isAssignRecomView
        ) {
            this.refreshRecommendationsList();
        }
    };

    openRecommendationExportFromRoute = () => {
        this.setState(prevState => ({ openRecommendationExportTrigger: (prevState.openRecommendationExportTrigger || 0) + 1 }));
        const { openRecommendationExport, ...restState } = this.props.location.state || {};
        this.props.history.replace({
            pathname: this.props.location.pathname,
            search: this.props.location.search,
            state: restState
        });
    };

    handleScrollPosition = () => {
        const scrollPosition = this.props.recommendationsReducer.scrollPosition;
        if (scrollPosition && this.tableRef?.current) {
            this.tableRef.current.scrollTo(0, parseInt(scrollPosition));
            this.props.setRecommendationScrollPosition(0);
        }
    };

    getCrLabel = () => getCapitalRequestLabel(this.props.projectReducer?.getProjectByIdResponse?.miscellaneous);

    refreshRecommendationsList = async (isRecom, noLoading = false) => {
        const {
            match: {
                params: { section, tab }
            },
            location: { search }
        } = this.props;
        if (section === "add" || section === "edit") {
            !noLoading && this.setState({ isLoading: false });
            return;
        }

        !noLoading && this.setState({ isLoading: true });
        const { params, paginationParams, myFilters, dashboardFilterParams } = this.state;
        let recommendationsList = [];
        let totalCount = 0;
        let crv_total = "";
        let options_cost = "";
        let total_opinions_of_cost = "";
        let project_total = "";
        let project_costs = "";
        let year_totals = {};
        let tempKeys = [...this.state.tableData.keys];
        let tempConfig = { ...this.state.tableData.config };
        const query = qs.parse(search);
        let updatedParams = { ...params };
        const projectTotalFilter = updatedParams?.filters?.["recommendations.project_total"] || {};
        if (projectTotalFilter?.filters?.[0] === "top_n" && projectTotalFilter?.key < updatedParams.limit) {
            updatedParams.limit = projectTotalFilter?.key;
        }
        const result = AppliedQueryFilters(myFilters, this.state?.queries);
        let clonedQueryFilters = _.cloneDeep(result);

        updatedParams = _.merge({}, updatedParams, dashboardFilterParams, clonedQueryFilters);
        let tempSelectedRecomIds = this.props?.isCrLinkPicker
            ? this.state.selectedRecomIds || []
            : this.props.recommendationsReducer.entityParams[section]?.selectedRecomIds || [];

        if (updatedParams.list) {
            Object.keys(updatedParams.list).forEach(key => {
                if (key.startsWith("dynamic_fields.")) {
                    let newKey = `recommendation_dynamic_field__${key.split("dynamic_fields.")[1]}`;
                    updatedParams[newKey] = updatedParams.list[key];
                    delete updatedParams.list[key];
                }
            });
        }
        if (this?.props?.surveyFilters) {
            const surveyFilters = this.props.surveyFilters;
            updatedParams = {
                ...updatedParams,
                ...(surveyFilters?.region?.length && { region_ids: surveyFilters.region }),
                ...(surveyFilters?.site?.length && { site_ids: surveyFilters.site }),
                ...(surveyFilters?.building?.length && { building_ids: surveyFilters.building }),
                ...(surveyFilters?.floor?.length && { floor_ids: surveyFilters.floor }),
                ...(surveyFilters?.addition?.length && { addition_ids: surveyFilters.addition })
            };
        }
        updatedParams = this.applyFindParamsToRecommendationParams(updatedParams);
        // Getting All Recommendations by Id
        if (this.props.isChartView) {
            await this.props.getProjectById(this.props.projectIdDashboard);
            if (this.props.dataView === "building") {
                let chartParams = {
                    buildingId: this.props.buildingIdDashboard,
                    projectId: this.props.projectIdDashboard,
                    building_ids: (this.isDashboardFiltered ? this.state.building_ids : null) || null
                };
                await this.props.getChartsBuilding(chartParams, updatedParams);
                this.props.handleFilterValues(updatedParams);
                recommendationsList = this.props.buildingReducer.graphDetails.recommendations;
                totalCount = this.props.buildingReducer.graphDetails.count;
                crv_total = this.props.buildingReducer.graphDetails.crv_total;
                options_cost = this.props.buildingReducer.graphDetails.options_cost;
                total_opinions_of_cost = this.props.buildingReducer.graphDetails.total_opinions_of_cost;
                year_totals = this.props.buildingReducer.graphDetails.year_totals;
                project_total = this.props.buildingReducer.graphDetails.project_total;
                project_costs = this.props.buildingReducer.graphDetails.project_costs;
            } else if (this.props.dataView === "region") {
                let chartParams = {
                    regionId: this.props.regionId
                };
                let tempParams = {
                    ...updatedParams,
                    project_id: this.props.projectIdDashboard
                };
                await this.props.getChartsByRegion(chartParams, tempParams);
                this.props.handleFilterValues(updatedParams);
                recommendationsList = this.props.regionReducer.graphDetails.recommendations;
                totalCount = this.props.regionReducer.graphDetails.count;
                crv_total = this.props.regionReducer.graphDetails.crv_total;
                options_cost = this.props.regionReducer.graphDetails.options_cost;
                total_opinions_of_cost = this.props.regionReducer.graphDetails.total_opinions_of_cost;
                year_totals = this.props.regionReducer.graphDetails.year_totals;
                project_total = this.props.regionReducer.graphDetails.project_total;
                project_costs = this.props.regionReducer.graphDetails.project_costs;
            } else if (this.props.dataView === "project") {
                let chartParams = {
                    projectId: this.props.projectIdChart
                };
                let tempParams = {
                    ...updatedParams,
                    project_id: this.props.projectIdDashboard,
                    building_ids: (this.isDashboardFiltered ? this.state.building_ids : null) || null,
                    capital_type: (this.isDashboardFiltered ? this.state.capital_type : null) || null,
                    start_year: (this.isDashboardFiltered ? this.state.start_year : null) || null,
                    end_year: (this.isDashboardFiltered ? this.state.end_year : null) || null,
                    infrastructure_requests: (this.isDashboardFiltered ? this.state.infrastructure_requests : null) || null,
                    dashboard: (this.isDashboardFiltered ? this.state.dashboard : null) || null,
                    year: (this.isDashboardFiltered ? this.state.year : null) || null
                };

                await this.props.getChartByProject(chartParams, tempParams);
                this.props.handleFilterValues(updatedParams);
                recommendationsList = this.props.projectReducer.graphDetails.recommendations;
                totalCount = this.props.projectReducer.graphDetails.count;
                crv_total = this.props.projectReducer.graphDetails.crv_total;
                options_cost = this.props.projectReducer.graphDetails.options_cost;
                total_opinions_of_cost = this.props.projectReducer.graphDetails.total_opinions_of_cost;
                year_totals = this.props.projectReducer.graphDetails.year_totals;
                project_total = this.props.projectReducer.graphDetails.project_total;
                project_costs = this.props.projectReducer.graphDetails.project_costs;
            } else {
                let chartParams = {
                    siteId: this.props.siteId,
                    projectId: this.props.projectIdDashboard
                };
                await this.props.getChartData(chartParams, updatedParams);

                this.props.handleFilterValues(updatedParams);
                recommendationsList = this.props.siteReducer.graphDetails.recommendations;
                totalCount = this.props.siteReducer.graphDetails.count;
                crv_total = this.props.siteReducer.graphDetails.crv_total;
                options_cost = this.props.siteReducer.graphDetails.options_cost;
                total_opinions_of_cost = this.props.siteReducer.graphDetails.total_opinions_of_cost;
                year_totals = this.props.siteReducer.graphDetails.year_totals;
                project_total = this.props.siteReducer.graphDetails.project_total;
                project_costs = this.props.siteReducer.graphDetails.project_costs;
            }
        } else {
            if (section === "regioninfo") {
                let regionParam = {
                    region_id: this.props.match.params.id,
                    project_id: query.pid,
                    ...updatedParams
                };
                await this.props.getAllRecommendationsRegion(regionParam);
            } else if (section === "buildinginfo") {
                let buildingParam = {
                    building_id: this.props.match.params.id || null,
                    project_id: query.pid,
                    ...updatedParams
                };
                await this.props.getAllRecommendationsRegion(buildingParam);
            } else if (section === "siteinfo") {
                let siteParam = {
                    site_id: this.props.match.params.id,
                    project_id: query.pid,
                    ...updatedParams
                };
                await this.props.getAllRecommendationsRegion(siteParam);
            } else if (section === "initiativeInfo") {
                const { view } = updatedParams || {};
                let params = {
                    initiative_id: this.props.match.params.id,
                    project_id: view !== "assigned" ? query.pid : null,
                    initiative_ids:
                        view === "assigned" && this.props.match.params.tab === "recommendations"
                            ? this.props.recommendationsReducer.entityParams[this.props.match.params.section]?.initiative_ids
                            : [],
                    ...updatedParams
                };
                await this.props.getAllRecommendationsRegion(params);
            } else if (section === "imageInfo") {
                let imageRecomParams = {
                    image_id: this.props.match.params.id,
                    ...updatedParams
                };
                await this.props.getAllRecommendationsRegion(imageRecomParams);
            } else if (section === "assetInfo") {
                let imageRecomParams = {
                    ...updatedParams,
                    asset_id: this.props.match.params.id
                };
                await this.props.getAllRecommendationsRegion(imageRecomParams);
            } else if (this.props.isBudgetPriority) {
                let recomParams = {
                    ...updatedParams,
                    ...this.props.dashboardFilterParams
                };
                await this.props.getAllBudgetPriorityRecommendations(recomParams);
            } else if (this.props.isSmartChartView || this?.props?.isAssignRecomView) {
                const { smartChartFilters = {} } = this.props;
                await this.props.getAllRecommendations(
                    {
                        ...updatedParams,
                        ...smartChartFilters,
                        ...(this.props?.isAssignRecomView ? { survey_recommendation_project_id: this.props?.survey_recommendation_project_id } : {})
                    },
                    this.props?.isSurveyView || this.props?.isAssignRecomView ? this.props?.projectId : this.props?.projectIdForSmartChart
                );
            } else if (section === "recommendationsinfo" && tab === "linked-recommendations") {
                let params = {
                    ...updatedParams,

                    capital_request_id: this.props.match.params.id
                };
                let project_id = this.props.recommendationDetails?.project?.id;

                await this.props.getAllRecommendations(params, project_id);
            } else if (section === "recommendationsinfo" && tab === "linked-cr-recommendations") {
                let recommendationsData = await this.getDataById(this.props.match.params.id);
                let params = {
                    ...updatedParams,

                    child_cr_recommendation_id: this.props.match.params.id,
                    is_cr: true
                };
                let project_id = recommendationsData?.project?.id;

                await this.props.getAllRecommendations(params, project_id);
            } else if (tab === "mr-recommendations") {
                let params = {
                    ...updatedParams,

                    survey_recommendation_id: this.props.match.params.mrId
                };
                await this.props.getAllRecommendations(params, this.props.match.params.id);
            } else {
                let params = {
                    ...updatedParams
                };
                if (this.props.isCapitalRequest) {
                    params.is_cr = true;
                }
                await this.props.getAllRecommendations(params, this.props.match.params.id);
            }
            recommendationsList = this.props.recommendationsReducer.getAllRecommendationsResponse.recommendations;
            totalCount = this.props.recommendationsReducer.getAllRecommendationsResponse.count;
            crv_total = this.props.recommendationsReducer.getAllRecommendationsResponse.crv_total;
            options_cost = this.props.recommendationsReducer.getAllRecommendationsResponse.options_cost;
            total_opinions_of_cost = this.props.recommendationsReducer.getAllRecommendationsResponse.total_opinions_of_cost;
            year_totals = this.props.recommendationsReducer.getAllRecommendationsResponse.year_totals;
            project_total = this.props.recommendationsReducer.getAllRecommendationsResponse.project_total;
            project_costs = this.props.recommendationsReducer.getAllRecommendationsResponse.project_costs;
        }

        let tempRecommendationsList = recommendationsList;
        // For creating dynamic keys and config data for recommendation table data
        if (recommendationsList && recommendationsList.length) {
            // setting maintenance years
            // Year totals
            if (year_totals && Object.keys(year_totals)?.length) {
                const validYearKeys = new Set();

                Object.keys(year_totals).forEach(item => {
                    const yearKey = `year_${item}`;
                    const indexToInsertBefore = tempKeys.length > 1 ? tempKeys.length - 2 : 0;

                    if (!tempKeys.includes(yearKey)) {
                        tempKeys.splice(indexToInsertBefore, 0, yearKey);
                    }

                    tempConfig[yearKey] = {
                        isVisible: tempConfig[yearKey]?.isVisible ?? true,
                        label: item,
                        class: "width-160px txt-box-table",
                        searchKey: `maintenance_years.${item}`,
                        type: "number",
                        hasWildCardSearch: true,
                        hasCommonSearch: false,
                        getListTable: "maintenance_year",
                        commonSearchKey: "maintenance_years",
                        commonSearchObjectKey: `${item}`,
                        isYear: true,
                        hasLineEdit: true,
                        pinned: tempConfig?.[yearKey]?.pinned,
                        style: tempConfig?.[yearKey]?.style
                    };

                    // Add the key to the valid set
                    validYearKeys.add(yearKey);
                });

                // Remove any year keys from tempKeys that are not in validYearKeys
                tempKeys = tempKeys.filter(key => {
                    if (key.startsWith("year_")) {
                        return validYearKeys.has(key);
                    }
                    return true;
                });

                // Remove any year keys from tempConfig that are not in validYearKeys
                Object.keys(tempConfig).forEach(key => {
                    if (key.startsWith("year_") && !validYearKeys.has(key)) {
                        delete tempConfig[key];
                    }
                });
            } else {
                // If year_totals is absent or empty, remove all year-related keys from tempKeys and tempConfig
                tempKeys = tempKeys.filter(key => !key.startsWith("year_"));

                Object.keys(tempConfig).forEach(key => {
                    if (key.startsWith("year_")) {
                        delete tempConfig[key];
                    }
                });
            }
            //setting recommendation id selection for smart chart tiles
            if (
                this.props?.isSmartChartView &&
                ((this.props?.smartChartTileConfig?.band1?.config_filter &&
                    Object.keys(this.props?.smartChartTileConfig?.band1?.config_filter).length > 0) ||
                    (this.props?.smartChartTileConfig?.config_filter && Object.keys(this.props?.smartChartTileConfig?.config_filter).length > 0) ||
                    this.props?.smartChartTileConfig?.band1?.mfilter?.recommendations?.length === 0 ||
                    this.props?.smartChartTileConfig?.recommendations?.length === 0) &&
                this.state.initialFiltersSetForSmartChart
            ) {
                this.selectWholeRecommendation();
            }
        }

        // go to previous page is the last record of the current page is deleted
        if (recommendationsList && !recommendationsList.length && paginationParams.currentPage) {
            this.setState({
                params: {
                    ...params
                    // offset: (paginationParams.currentPage - 1) * paginationParams.perPage
                }
            });
            await this.props.getAllRecommendations({
                ...this.state.params,
                year: this.state.year || null,
                capital_type: (this.isDashboardFiltered ? this.state.capital_type : null) || null,
                start_year: (this.isDashboardFiltered ? this.state.start_year : null) || null,
                end_year: (this.isDashboardFiltered ? this.state.end_year : null) || null,
                infrastructure_requests: (this.isDashboardFiltered ? this.state.infrastructure_requests : null) || null,
                dashboard: (this.isDashboardFiltered ? this.state.dashboard : null) || null,
                building_ids: (this.isDashboardFiltered ? this.state.building_ids : null) || null
            });
        }
        if (
            (!Array.isArray(recommendationsList) || !recommendationsList.length) &&
            this.props.recommendationsReducer?.getAllRecommendationsResponse?.error
        ) {
            await this.setState({ alertMessage: this.props.recommendationsReducer.getAllRecommendationsResponse.error });
            this.showAlert();
        }

        if (!this.props?.isCrLinkPicker && !this.props?.isCapitalRequest) {
            if (!tempKeys.includes("cr_link_type")) {
                const firstYearIndex = tempKeys.findIndex(key => key.startsWith("year_"));
                const insertAt = firstYearIndex !== -1 ? firstYearIndex : Math.max(tempKeys.length - 2, 0);
                tempKeys.splice(insertAt, 0, "cr_link_type");
            }
            tempConfig["cr_link_type"] = {
                isVisible: tempConfig["cr_link_type"]?.isVisible ?? true,
                label: "Link Type",
                class: "width-160px",
                searchKey: "link_type",
                type: "string",
                hasWildCardSearch: false,
                hasCommonSearch: true,
                getListTable: ["recommendations.link_type"],
                commonSearchKey: "recommendations",
                commonSearchObjectKey: "link_type",
                smartChartCommonSearchKey: "link_type",
                pinned: tempConfig?.["cr_link_type"]?.pinned,
                style: tempConfig?.["cr_link_type"]?.style
            };
            tempRecommendationsList?.forEach(item => {
                if (item.link_type === "linked") item.cr_link_type = "Linked";
                else if (item.link_type === "converted" || item.capital_request_id) item.cr_link_type = "Converted";
                else item.cr_link_type = "";
            });
        } else {
            tempKeys = tempKeys.filter(key => key !== "cr_link_type");
            delete tempConfig["cr_link_type"];
        }

        recommendationsList?.forEach((item, i) => {
            if (item.priority_elements && item.priority_elements.length) {
                item.priority_elements.forEach(yearItem => {
                    tempRecommendationsList[i][`priority_element${yearItem.index}`] = yearItem.option_id || yearItem.element || null;
                });
            }
            if (item.maintenance_years && item.maintenance_years.length) {
                item.maintenance_years.forEach(yearItem => {
                    tempRecommendationsList[i][`year_${yearItem.year}`] = parseInt(yearItem.amount) ?? "";
                });
            }
        });

        tempKeys = _.uniq(tempKeys);
        this.setState({
            tableData: {
                ...this.state.tableData,
                keys: tempKeys,
                config: tempConfig,
                data: tempRecommendationsList
            },
            maintenance_years: year_totals ? Object.keys(year_totals) : [],
            tempRecommendationsList,
            paginationParams: {
                ...paginationParams,
                totalCount: totalCount,
                totalPages: Math.ceil(totalCount / paginationParams.perPage)
            },
            summaryRowData: {
                ...this.state.summaryRowData,
                crv_total: crv_total,
                options_cost: options_cost,
                total_opinions_of_cost: total_opinions_of_cost,
                year_totals: year_totals,
                project_total: project_total,
                project_costs: project_costs
            },
            showWildCardFilter: this.state.params.filters ? true : false,
            isLoading: false,
            selectedRecomIds: tempSelectedRecomIds,
            initialFiltersSetForSmartChart: false
        });

        // opinion cost
        // const filterParams = {
        //     field: ["project_total", "opinions_cost"],
        //     searchKey: "opinions_cost_vs_project_total"
        // };
        // this.getListForCommonFilter(filterParams);

        if (!isRecom) this.updateEntityParams();
        return true;
    };

    updateWildCardFilter = async newFilter => {
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                filters: newFilter,
                recommendation_ids: null
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            },
            selectedRecomIds: []
        });
        this.updateEntityParams();
        await this.refreshRecommendationsList();
    };

    updateEntityParams = async value => {
        if (this.props?.isCrLinkPicker) return;
        let entityParams = {};
        if (this.props?.isSmartChartView) {
            entityParams = {
                selectedRecomIds: this.state.selectedRecomIds,
                params: this.state.params,
                tableConfig: this.state.tableData.config,
                tableDataExportFilters: this.state.tableDataExportFilters
            };
        } else {
            entityParams = {
                entity: "Recommendation",
                selectedEntity: this.state.selectedRegion,
                paginationParams: this.state.paginationParams,
                params: this.state.params,
                wildCardFilterParams: this.state.wildCardFilterParams,
                filterParams: this.state.filterParams,
                tableConfig: value || this.state.tableData.config,
                selectedRowId: this.state.selectedRowId,
                historyPaginationParams: this.state.historyPaginationParams,
                historyParams: this.state.historyParams,
                selectedDropdown: this.state.selectedDropdown,
                selectedDropdownInitiaive: this.state.selectedDropdownInitiaive,
                building_ids: this.isDashboardFiltered ? this.state.building_ids : null,
                dashboard: this.isDashboardFiltered ? this.state.dashboard : null,
                capital_type: this.isDashboardFiltered ? this.state.capital_type : null,
                start_year: this.state.start_year || null,
                end_year: this.state.end_year || null,
                infrastructure_requests: this.state.infrastructure_requests || null,
                year: this.isDashboardFiltered ? this.state.year : null,
                initiative_ids: this.state.initiative_ids,
                recommendationList: this.state.tempRecommendationsList,
                initialTableConfig: this.state.initialTableConfig,
                selectedRecomIds: this.state.selectedRecomIds,
                dashboardFilterParams: this.state.dashboardFilterParams,
                parentSectionId: this.state.parentSectionId,
                tableDataExportFilters: this.state.tableDataExportFilters,
                myFilters: this.state.myFilters,
                queries: this.state.queries,
                appliedTableView: this.state.appliedTableView,
                selectedPreviewId: this.state.selectedPreviewId,
                paneViewEnabled: this.state.paneViewEnabled,
                lineEditingEnabled: this.state.lineEditingEnabled
            };
        }
        await this.props.updateRecommendationEntityParams(entityParams, this.props.match.params.section);
    };

    getListForCommonFilter = async params => {
        if (this.props.isBudgetPriority) {
            await this.getListForBudgetPriorityFilter(params);
        } else {
            const listParams = { ...params, ...this.getListParams() };
            if (params.searchKey === "opinions_cost_vs_project_total") {
                delete listParams.opinions_cost_vs_project_total;
            }
            if (params.searchKey === "recommendation_images.description") {
                if ("caption_missing" in listParams) {
                    delete listParams.caption_missing;
                }
            }
            if (params.searchKey === "lock_status") {
                delete listParams?.locked;
                delete listParams?.unlocked;
            }
            if (["image_or_not", "surveyor", "requestor", "review_status", "qa_qc_status"].includes(params.searchKey)) {
                delete listParams?.[params?.searchKey];
            }
            if (params?.searchKey?.startsWith("dynamic_fields.")) {
                const fieldName = params.searchKey.split("dynamic_fields.")[1];
                const listDynamicKey = `dynamic_fields.${fieldName}`;
                const dynamicFieldKey = `recommendation_dynamic_field__${fieldName}`;

                listParams.searchKey = `recommendation__${fieldName}`;
                listParams.is_dynamic = true;

                if (listDynamicKey in (this.state.params?.list || {})) {
                    const { dashboardFilterParams = {}, myFilters, queries } = this.state;
                    const queryFilterResult = AppliedQueryFilters(myFilters, queries);
                    const dashboardDynamicValue = dashboardFilterParams[dynamicFieldKey] ?? queryFilterResult[dynamicFieldKey];

                    if (dashboardDynamicValue?.length) {
                        listParams[dynamicFieldKey] = dashboardDynamicValue;
                    } else {
                        delete listParams[dynamicFieldKey];
                    }
                }
            }
            listParams.list = listParams?.list
                ? Object.fromEntries(Object.entries(listParams?.list)?.filter(([key, value]) => !params.searchKey?.includes(key)))
                : null;
            await this.props.getListForCommonFilterrecommendation(listParams);
        }
        return this.props.recommendationsReducer.getListForCommonFilterResponse || [];
    };

    getListForBudgetPriorityFilter = async params => {
        const {
            search,
            filters,
            list,
            view,
            deleted,
            on_hold,
            completed,
            locked,
            unlocked,
            active,
            surveyor,
            image_or_not,
            qa_qc_status,
            opinions_cost_vs_project_total,
            review_status,
            infrastructure_request,
            water,
            caption_missing,
            energy,
            facility_master_plan,
            recommendation_type,
            budget_priority
        } = this.state.params;
        params.search = search;
        params.filters = filters;
        params.list = list ? Object.fromEntries(Object.entries(list)?.filter(([key, value]) => key !== params?.field)) : null;
        params.view = view;
        params.deleted = deleted;
        params.on_hold = on_hold;
        params.completed = completed;
        params.locked = locked;
        params.unlocked = unlocked;
        params.active = active;
        params.surveyor = surveyor;
        params.image_or_not = image_or_not;
        params.qa_qc_status = qa_qc_status;
        params.opinions_cost_vs_project_total = opinions_cost_vs_project_total;
        params.review_status = review_status;
        params.infrastructure_request = infrastructure_request;
        params.water = water;
        params.caption_missing = caption_missing;
        params.energy = energy;
        params.facility_master_plan = facility_master_plan;
        params.recommendation_type = recommendation_type;
        params.budget_priority = budget_priority;
        await this.props.getListForBudgetPriorityFilter(
            this.applyCurrentFindParamsToRecommendationParams({ ...params, ...this.props.dashboardFilterParams })
        );
    };

    resetAllFilters = async () => {
        this.setState({ isLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));
        await this.setState({
            selectedRegion: null,
            paginationParams: {
                totalPages: 0,
                perPage: 40,
                currentPage: 0,
                totalCount: 0
            },
            params: {
                ...this.state.params,
                limit: 40,
                offset: 0,
                search: "",
                project_id: null,
                filters: null,
                list: null,
                view: this.props.match.params.tab === "recommendation" ? "assigned" : null,
                locked: null,
                unlocked: true,
                image_or_not: null,
                infrastructure_request: null,
                water: null,
                caption_missing: null,
                energy: null,
                facility_master_plan: null,
                recommendation_type: null,
                budget_priority: null,
                recommendation_ids: null,
                surveyor: null,
                requestor: null,
                review_status: null,
                qa_qc_status: null,
                opinions_cost_vs_project_total: null,
                findParams: null
            },
            wildCardFilterParams: {},
            filterParams: {},
            selectedRowId: null,
            selectedDropdown: "unlocked",
            selectedDropdownInitiaive: "assigned",
            tableDataExportFilters: {},
            myFilters: {},
            queries: [],
            selectedPreviewId: null,
            selectedRecomIds: [],
        });
        this.updateEntityParams();
        await this.refreshRecommendationsList();
        this.setState({ isLoading: false });
    };

    resetSort = async () => {
        this.setState({ isLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));
        await this.setState({
            params: {
                ...this.state.params,
                order: null,
                index: [],
                year: [],
                maintenance_year: [],
                priority_elements: null,
                recommendation_ids: null
            },
            selectedRecomIds: []
        });
        this.updateEntityParams();
        await this.refreshRecommendationsList();
        this.setState({ isLoading: false });
    };

    updateCommonFilter = async (commonFilters, exportFilters) => {
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                list: commonFilters,
                recommendation_ids: null
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            },
            tableDataExportFilters: exportFilters,
            selectedRecomIds: []
        });
        this.updateEntityParams();
        await this.refreshRecommendationsList();
    };

    updateTableSortFilters = async (searchKey, val, config) => {
        let tempYear = [];
        let tempIndex = [];
        let main_key = searchKey.split(".")[0];
        if (main_key === "maintenance_years") {
            if (!tempYear.includes(val)) {
                tempYear.push(val);
            }
            if (this.state.params.order) {
                await this.setState({
                    params: {
                        ...this.state.params,
                        order: {
                            ...this.state.params.order,
                            ["maintenance_years.amount"]: this.state.params.order["maintenance_years.amount"] === "desc" ? "asc" : "desc"
                        },
                        maintenance_year: tempYear
                    }
                });
            } else {
                await this.setState({
                    params: {
                        ...this.state.params,
                        order: { ["maintenance_years.amount"]: "asc" },
                        maintenance_year: tempYear
                    }
                });
            }
        } else if (main_key === "priority_elements") {
            const priorityId = searchKey?.replace(/^priority_elements\./, "");
            const prevPriorityElements = this.state?.params?.priority_elements || [];
            const prevIndex = this.state?.params?.index || [];

            const existing = prevPriorityElements?.find(p => p?.id === priorityId);
            const nextOrder = existing?.order === "asc" ? "desc" : "asc";

            const updatedIndex = prevIndex?.includes(config?.priorityIndex) ? prevIndex : [...prevIndex, config?.priorityIndex];

            const updatedPriorityElements = existing
                ? prevPriorityElements?.map(p => (p?.id === priorityId ? { ...p, order: nextOrder } : p))
                : [...prevPriorityElements, { id: priorityId, order: nextOrder }];

            await this.setState({
                params: {
                    ...this.state?.params,
                    priority_elements: updatedPriorityElements,
                    index: updatedIndex
                }
            });
        } else {
            if (this.state.params.order) {
                if (searchKey === "recommendations.usefull_life_remaining") {
                    await this.setState({
                        params: {
                            ...this.state.params,
                            order: {
                                ...this.state.params.order,
                                [searchKey]: this.state.params.order[searchKey] === "desc" ? "asc" : "desc",
                                "assets.usefull_life_remaining": this.state.params.order[searchKey] === "desc" ? "asc" : "desc"
                            }
                        }
                    });
                } else {
                    await this.setState({
                        params: {
                            ...this.state.params,
                            order: {
                                ...this.state.params.order,
                                [searchKey]: this.state.params.order[searchKey] === "desc" ? "asc" : "desc"
                            }
                        }
                    });
                }
            } else {
                if (searchKey === "recommendations.usefull_life_remaining") {
                    await this.setState({
                        params: {
                            ...this.state.params,
                            order: { [searchKey]: "asc", "assets.usefull_life_remaining": "asc" }
                        }
                    });
                } else {
                    await this.setState({
                        params: {
                            ...this.state.params,
                            order: { [searchKey]: "asc" }
                        }
                    });
                }
            }
        }
        this.setState({ params: { ...this.state.params, recommendation_ids: null }, selectedRecomIds: [] }, () => {
            this.updateEntityParams();
            this.refreshRecommendationsList();
        });
    };

    updateLastSortFilter = async (searchKey, val) => {
        if (this.state.params.order && this.state.params?.order[searchKey]) {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: {
                        [searchKey]: this.state.params.order[searchKey] === "asc" ? "desc" : "asc"
                    }
                }
            });
        } else {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: { [searchKey]: "desc" }
                }
            });
        }
        await this.setState({ params: { ...this.state.params, recommendation_ids: null }, selectedRecomIds: [] });
        this.updateEntityParams();
        await this.refreshRecommendationsList();
    };

    handleHideColumn = async (tableConfig, actionType = "") => {
        this.setState({ isLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));
        //unpin hidden columns
        const { keys, config } = tableConfig;

        // Always use labels from the master (computed) config so stale labels in saved views don't show
        if (this.masterTableConfig) {
            Object.keys(config).forEach(key => {
                if (this.masterTableConfig[key]?.label !== undefined) {
                    config[key] = { ...config[key], label: this.masterTableConfig[key].label };
                }
            });
        }
        Object.keys(config)
            .filter(key => !config[key]?.isVisible && config[key]?.pinned)
            .forEach(key => {
                const { left, ...remainingStyles } = config[key]?.style || {};
                config[key] = {
                    ...config[key],
                    pinned: false,
                    style: remainingStyles
                };
            });
        const pinnedColumns = keys.filter(key => config[key]?.isVisible && config[key]?.pinned);
        const columnLeftValues = getPinnedColumnLeftPositions(pinnedColumns, this.pinnedColumnsRef);

        pinnedColumns.forEach(key => {
            config[key] = {
                ...config[key],
                style: {
                    ...config[key]?.style,
                    left: columnLeftValues[key] || "auto"
                }
            };
        });
        await this.setState({
            tableData: {
                ...this.state.tableData,
                keys,
                config
            }
        });

        await this.setDynamicJoinParam();
        await this.updateEntityParams();
        if (!this.props?.isSmartChartView && actionType !== "temp") {
            this.saveUserTableConfig();
        }
        this.refreshRecommendationsList();
        this.setState({ isLoading: false });
    };

    updateSelectedRow = async (rowId, isSingleClick = false) => {
        const { paneViewEnabled } = this.state;
        if (isSingleClick && paneViewEnabled && this.props.match.params.tab === "recommendations" && this.state.selectedPreviewId !== rowId) {
            this.getAllImageList(rowId, { limit: 100, offset: 1 });
        }
        this.setState(prevState => ({
            selectedRowId: rowId,
            selectedPreviewId:
                isSingleClick && paneViewEnabled && this.props.match.params.tab === "recommendations" ? rowId : this.state.selectedPreviewId
        }));
        await this.updateEntityParams();
    };
    onPaneViewClick = () => {
        this.setState(
            prevState => ({
                paneViewEnabled: !prevState.paneViewEnabled,
                selectedPreviewId: !prevState.paneViewEnabled ? this.state?.selectedRowId : null
            }),
            () => {
                if (this.state.paneViewEnabled && this.state.selectedPreviewId) {
                    this.getAllImageList(this.state.selectedPreviewId, { limit: 100, offset: 1 });
                }
                if (!this.props?.isSmartChartView) {
                    this.saveUserTableConfig();
                }
                this.updateEntityParams();
            }
        );
    };
    onPaneViewClose = () => {
        this.setState({ selectedPreviewId: null }, () => {
            this.updateEntityParams();
        });
    };
    deleteImage = async imageId => {
        await this.deleteImages(imageId);
        await this.getAllImageList(this.state?.selectedPreviewId, { limit: 100, offset: 1 });
    };
    updateImage = async imageData => {
        await this.props.updateImage(imageData);
        const { success, message, error = ERROR_COPY.GENERIC } = this.props.imageReducer.imageUpdateResponse || {};
        if (success) {
            await this.setState({
                alertMessage: message
            });
            this.showAlert();
        } else {
            await this.setState({
                alertMessage: error
            });
            this.showAlert();
        }
        await this.getAllImageList(this.state?.selectedPreviewId, { limit: 100, offset: 1 });
    };
    handlePerPageChange = async e => {
        const { paginationParams } = this.state;
        await this.setState({
            paginationParams: {
                ...paginationParams,
                perPage: e.target.value,
                currentPage: 0
            },
            params: {
                ...this.state.params,
                offset: 0,
                limit: e.target.value
            }
        });
        await this.refreshRecommendationsList();
    };

    handlePageClick = async page => {
        this.setState({ isLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));
        const { paginationParams, params, paneViewEnabled, selectedPreviewId } = this.state;
        await this.setState({
            paginationParams: {
                ...paginationParams,
                currentPage: page.selected
            },
            params: {
                ...params,
                // offset: page.selected * paginationParams.perPage
                offset: page.selected + 1
            }
        });
        await this.refreshRecommendationsList();
        if (paneViewEnabled && selectedPreviewId && this.props.match.params.tab === "recommendations") {
            this?.updateSelectedRow(this.props.recommendationsReducer.getAllRecommendationsResponse.recommendations?.[0]?.id, true);
            this.tableRef.current.scrollTop = 1;
        }
        this.setState({ isLoading: false });
    };

    updateCurrentActions = async key => {
        const { currentActions } = this.state;
        await this.setState({
            currentActions: currentActions === key ? null : key
        });
        return true;
    };

    updateCurrentViewAllUsers = async key => {
        const { currentViewAllUsers } = this.state;
        await this.setState({
            currentViewAllUsers: currentViewAllUsers === key ? null : key
        });
        return true;
    };

    showEditPage = recommendationsId => {
        if (this?.tableRef?.current?.scrollLeft || this?.tableRef?.current?.scrollLeft === 0) {
            this.props.setRecommendationScrollPosition(this?.tableRef?.current?.scrollLeft === 0 ? 1 : this?.tableRef?.current?.scrollLeft);
        }
        // if (this.tableRef?.current?.scrollTop) {
        //     this.props.setRecommendationScrollPosition(this.tableRef.current.scrollTop);
        // }

        const {
            history,
            location: { search = "" },
            match: {
                params: { section, id: matchId, tab }
            },
            isCapitalRequest,
            projectIdDashboard,
            projectReducer,
            recommendationsReducer,
            isBudgetPriority,
            recommendationDetails,
            isMobileRequest = false
        } = this.props;
        this.setState({
            selectedRecommendations: recommendationsId
        });

        const project_id = projectIdDashboard || matchId;
        const client_id = projectReducer?.getProjectByIdResponse?.client?.id || "";

        let projectid_budget = recommendationsReducer.getAllRecommendationsResponse.recommendations
            ?.filter(item => item.id === recommendationsId)
            .map(item => item.project_id);
        let clientid_budget = recommendationsReducer.getAllRecommendationsResponse.recommendations
            ?.filter(item => item.id === recommendationsId)
            .map(item => item.client?.id);

        const currentParams = qs.parse(search);
        const newParams = { ...currentParams };

        if (isCapitalRequest) {
            newParams.is_cr = true;
        } else if (isMobileRequest) {
            newParams.is_mr = true;
            newParams.s_id = this.props.match.params.mrId;
        }

        let newPath;
        if (section === "initiativeInfo") {
            newPath = `/recommendations/edit/${recommendationsId}`;
        } else if (projectid_budget && clientid_budget && isBudgetPriority) {
            newParams.p_id = projectid_budget[0] ? projectid_budget[0] : matchId;
            newParams.c_id = clientid_budget[0] ? clientid_budget[0] : "";
            newPath = `/recommendations/edit/${recommendationsId}?${qs.stringify(newParams)}`;
        } else if (tab === "linked-recommendations") {
            const { project, client } = recommendationDetails || {};
            newParams.is_cr = false;
            newParams.p_id = project?.id;
            newParams.c_id = client?.id;
            newPath = `/recommendations/edit/${recommendationsId}?${qs.stringify(newParams)}`;
        } else {
            newParams.p_id = project_id;
            newParams.c_id = client_id;
            newPath = `/recommendations/edit/${recommendationsId}?${qs.stringify(newParams)}`;
        }

        addToBreadCrumpData({
            key: "edit",
            name: `Edit ${isCapitalRequest ? this.getCrLabel() : "Recommendations"}`,
            path: newPath
        });

        history.push(newPath);
    };

    showAddForm = () => {
        const project_id = this.props.projectIdDashboard || this.props?.projectIdMobile || this.props.match.params.id;
        const client_id = this.props.projectReducer?.getProjectByIdResponse?.client?.id;
        if (this?.tableRef?.current?.scrollLeft || this?.tableRef?.current?.scrollLeft === 0) {
            this.props.setRecommendationScrollPosition(this?.tableRef?.current?.scrollLeft === 0 ? 1 : this?.tableRef?.current?.scrollLeft);
        }
        if (project_id && client_id) {
            const {
                history,
                location: { search = "" },
                isCapitalRequest,
                isMobileRequest = false
            } = this.props;

            this.setState({
                selectedRecommendations: null
            });

            const currentParams = qs.parse(search);
            let newParams = {
                ...currentParams,
                p_id: project_id,
                c_id: client_id,
                type: "Regular"
            };
            if (isCapitalRequest) {
                newParams.is_cr = true;
            } else if (isMobileRequest) {
                newParams.is_mr = true;
                newParams.s_id = this.props.match.params.mrId;
            }

            const newPath = `/recommendations/add?${qs.stringify(newParams)}`;
            addToBreadCrumpData({
                key: "add",
                name: `Add ${isCapitalRequest ? this.getCrLabel() : "Recommendation"}`,
                path: newPath
            });
            history.push(newPath);
        }
    };

    showViewModal = () => {
        if (this.props.isSmartChartView && this.props?.recomType === "normal") {
            this.showViewModalExport();
        } else {
            this.setState({
                showViewModal: true
            });
        }
    };

    // showViewImport = () => {
    //     this.setState({
    //         showViewImport: true
    //     });
    // };

    showViewModalExport = type => {
        this.setState({
            showViewModalExport: { show: true, type: type }
        });
    };

    getSiteListBasedOnRegion = async (recommendationsId, params) => {
        await this.props.getSitesBasedOnRegion(recommendationsId, params);
        const siteList = this.props.buildingReducer.getSitesBasedOnRegionResponse?.sites || [];
        return siteList;
    };

    getDepartmentByProject = async projectId => {
        const department = await this.props.getDepartmentByProject(projectId);
    };

    getSystemBasedOnProject = async projectId => {
        const system = await this.props.getSystemBasedOnProject(projectId);
        return system;
    };

    getFloorBasedOnBuilding = async buildingId => {
        const system = await this.props.getFloorBasedOnBuilding(buildingId);
        return system;
    };
    getSubSystemBasedOnProject = async (projectId, systemId) => {
        const system = await this.props.getSubSystemBasedOnProject(projectId, systemId);
    };
    getTradeBasedOnProject = async projectId => {
        const system = await this.props.getTradeBasedOnProject(projectId);
    };

    getCategoryBasedOnProject = async projectId => {
        const department = await this.props.getCategoryBasedOnProject(projectId);
        const {
            buildingReducer: {
                getSitesBasedOnRegionResponse: { sites: siteList }
            }
        } = this.props;
        return siteList;
    };

    getRegionListBasedOnClient = async clientId => {
        await this.props.getRegionsBasedOnClient(clientId);
        const {
            recommendationsReducer: {
                getRegionsBasedOnClientResponse: { regions: regionList }
            }
        } = this.props;
        return regionList;
    };

    toggleWildCardFilter = () => {
        const { showWildCardFilter } = this.state;
        this.setState({
            showWildCardFilter: !showWildCardFilter
        });
    };

    handleAssignConsultancyUsersModal = async recommendationsData => {
        this.setState({
            showAssignConsultancyUsers: true
        });
    };

    handleAssignClientUsersModal = async recommendationsData => {
        this.setState({
            showAssignClientUsers: true
        });
    };

    handleAddRecommendations = async recommendation => {
        const { history } = this.props;
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        await this.props.addRecommendation(recommendation?.is_mr ? { ...recommendation, survey_recommendation_id: query?.s_id } : recommendation);
        const { success, recommendation_code, recommendation_id, error, message, is_duplicate_value } =
            this.props.recommendationsReducer.addRecommendationResponse || {};
        if (!success || error) {
            if (is_duplicate_value) {
                const match = message ? message.match(/detected for '([^']+)'/) : null;
                const fieldName = match ? match[1] : "a field";
                this.setState({
                    showForceUpdateConfirmModal: true,
                    forceUpdateFieldName: fieldName,
                    confirmParams: recommendation,
                    confirmAction: "add"
                });
            } else {
                await this.setState({
                    alertMessage: error || message || "Failed to create recommendation"
                });
                this.showAlert();
            }
        } else {
            if (!recommendation?.is_mr && !recommendation?.capital_request_id)
                this.props.sendRecomEmailNotification(
                    recommendation_id,
                    recommendation?.is_cr ? { type: "map-request" } : { type: "recommendation" }
                );
            await this.setState({
                alertMessage: message
            });
            this.showAlert();
            if (findPrevPathFromBreadCrumpData()?.split("/")[2] === "recommendationsinfo" && !recommendation?.recommendation_capital_type_id) {
                popBreadCrumpOnPageClose();
            }
            let currentBreadCrumpData = JSON.parse(sessionStorage.getItem("bc-data"));
            const lastInfoIndex = currentBreadCrumpData.reduceRight((acc, item) => {
                if (acc === null && item.key === "Name") {
                    return item;
                }
                return acc;
            }, null);
            if (lastInfoIndex) {
                const isCrInPath = lastInfoIndex?.path.includes("is_cr=true");
                if (
                    ((!isCrInPath && !recommendation?.is_cr) || (recommendation?.is_cr && isCrInPath)) &&
                    lastInfoIndex?.path?.startsWith("/recommendations/recommendationsinfo/")
                ) {
                    updateBreadCrumpData(lastInfoIndex?.index);
                }
            }
            const currentParams = qs.parse(search);
            const newParams = { ...currentParams };
            if (recommendation?.is_mr) {
                newParams.is_mr = true;
            }
            addToBreadCrumpData({
                key: "Name",
                name: recommendation_code,
                path: `/recommendations/recommendationsinfo/${recommendation_id}/maindetails${
                    recommendation?.is_mr ? `?${qs.stringify(newParams)}` : recommendation?.is_cr ? "?is_cr=true" : ""
                }`
            });
            addToBreadCrumpData({
                key: "info",
                name: "Main Details",
                path: `/recommendations/recommendationsinfo/${recommendation_id}/maindetails${
                    recommendation?.is_mr ? `?${qs.stringify(newParams)}` : recommendation?.is_cr ? "?is_cr=true" : ""
                }`,
                ...(qs.parse(search)?.is_assignedRecom === "true" ? { innerTab: true } : "")
            });
            sessionStorage.removeItem("currentRecommendationData");
            await this.props.syncProjectCost({ recommendation_ids: [recommendation_id] });
            this.showInfoPage(recommendation_id, null, null, recommendation?.is_cr, recommendation?.is_mr);
        }
    };

    handleUpdateRecommendations = async (recommendation, selectedImage, recId = null) => {
        const { history } = this.props;
        const { selectedRecommendations } = this.state;
        await this.props.updateRecommendation(recommendation, recId ? recId : selectedRecommendations, selectedImage);
        const { success, error, message, is_duplicate_value } = this.props.recommendationsReducer.updateRecommendationResponse;
        if (!success || error) {
            if (is_duplicate_value) {
                const match = message ? message.match(/detected for '([^']+)'/) : null;
                const fieldName = match ? match[1] : "a field";
                this.setState({
                    showForceUpdateConfirmModal: true,
                    forceUpdateFieldName: fieldName,
                    confirmParams: recommendation,
                    confirmRecId: recId,
                    confirmSelectedImage: selectedImage,
                    confirmAction: "edit"
                });
            } else {
                await this.setState({
                    alertMessage: message || error || "Failed to update Recommendation!"
                });
                this.showAlert();
            }
        } else {
            this.setState({
                currentActions: null
            });
            await this.setState({
                alertMessage: this.props.recommendationsReducer.updateRecommendationResponse?.message
            });
            this.showAlert();
            if (recommendation?.year || recommendation?.maintenance_years) {
                await this.props.syncProjectCost({ recommendation_ids: [recId || selectedRecommendations] });
            }
            this.props.history.push(findPrevPathFromBreadCrump() || "/recommendations");
            popBreadCrumpOnPageClose();
        }
    };

    handleDeleteRecommendations = async (id, isDeleted) => {
        const entity = this.props.isCapitalRequest ? permissions.CR_RECOMMENDATIONS : permissions.RECOMMENDATIONS;
        if (!checkPermission("forms", entity, "hard_delete") && isDeleted) {
            await this.setState({
                alertMessage: "You are not authorised to perform the Hard Delete !"
            });
            this.showAlert();
        } else {
            await this.setState({
                showConfirmModal: true,
                selectedRecommendations: id,
                isDeleted: isDeleted
            });
        }
    };

    renderConfirmationModal = () => {
        const { showConfirmModal, isDeleted } = this.state;
        if (!showConfirmModal) return null;
        const entity = this.props.isCapitalRequest ? permissions.CR_RECOMMENDATIONS : permissions.RECOMMENDATIONS;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Do you want to delete this ${this.props.isCapitalRequest ? this.getCrLabel() : "Recommendation"}?`}
                        message={""}
                        onNo={() => this.setState({ showConfirmModal: false })}
                        onYes={ishardDelete => {
                            ishardDelete
                                ? this.setState({ showHardDeleteConfirmationModal: true })
                                : this.deleteRecommendationOnConfirm(ishardDelete);
                        }}
                        onHardDelete={this.deleteRecommendationOnConfirm}
                        isHard={checkPermission("forms", entity, "hard_delete")}
                        isDeleted={isDeleted}
                    />
                }
                onCancel={() => this.setState({ showConfirmModal: false })}
            />
        );
    };
    renderHardDeleteConfirmationModal = () => {
        const { showHardDeleteConfirmationModal } = this.state;
        if (!showHardDeleteConfirmationModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Are you sure you want to permanently (Hard) delete this ${
                            this.props.isCapitalRequest ? this.getCrLabel() : "Recommendation"
                        }?`}
                        type="cancel"
                        onNo={() => this.setState({ showHardDeleteConfirmationModal: false })}
                        onYes={() => {
                            this.setState({ showHardDeleteConfirmationModal: false });
                            this.deleteRecommendationOnConfirm(true);
                        }}
                    />
                }
                onCancel={() => this.setState({ showHardDeleteConfirmationModal: false })}
            />
        );
    };

    deleteRecommendationOnConfirm = async (ishardDelete = false) => {
        const { selectedRecommendations } = this.state;
        const {
            match: {
                params: { tab }
            }
        } = this.props;

        const idToBeDeleted = tab === "maindetails" ? this.props.match.params.id : selectedRecommendations;

        if (ishardDelete) {
            this.setState({
                showConfirmModal: false,
                isLoading: true
            });
            await this.props.deleteRecommendation(idToBeDeleted, true);
        } else {
            this.setState({
                showConfirmModal: false,
                isLoading: true
            });
            await this.props.deleteRecommendation(idToBeDeleted);
        }
        const { error = "", message = "" } = this.props.recommendationsReducer?.deleteRecommendationResponse || {};
        if (error) {
            this.setState(
                {
                    alertMessage: error,
                    showConfirmModal: false,
                    isRedirectionOnDelete: false,
                    selectedRecommendations: null,
                    isLoading: false
                },
                () => this.showAlert()
            );
        } else {
            this.setState(
                prevState => ({
                    alertMessage: message || `${this.props.isCapitalRequest ? this.getCrLabel() : "Recommendation"} deleted successfully`,
                    showConfirmModal: false,
                    selectedRecommendations: null,
                    selectedRecomIds: prevState.selectedRecomIds.filter(elem => elem.id !== idToBeDeleted),
                    params: {
                        ...prevState.params,
                        recommendation_ids: prevState.params?.recommendation_ids?.length
                            ? prevState.params.recommendation_ids.filter(elem => elem !== idToBeDeleted)
                            : null
                    },
                    tableData: {
                        ...prevState.tableData,
                        data: prevState.tableData?.data?.filter(item => item.id !== idToBeDeleted)
                    }
                }),
                () => {
                    this.showAlert();
                    this.refreshRecommendationsList();
                    if (this.state.isRedirectionOnDelete) {
                        popBreadCrumpRecData();
                        this.props.history.push(findPrevPathFromBreadCrumpData() || "/recommendations");
                        this.setState({ isRedirectionOnDelete: false });
                    }
                }
            );
        }

        this.setState({
            isLoading: false
        });
    };

    handleGlobalSearch = async search => {
        const { params } = this.state;
        await this.setState({
            params: {
                ...params,
                offset: 0,
                search,
                recommendation_ids: null
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            },
            selectedRecomIds: []
        });
        await this.refreshRecommendationsList();
    };

    showInfoPage = (recommendationsId, omit, rowData, isCR = false, isMR = false) => {
        const {
            history,
            location: { search = "" },
            match: {
                params: { tab }
            },
            isCapitalRequest,
            isMobileRequest
        } = this.props;
        if (this?.tableRef?.current?.scrollLeft || this?.tableRef?.current?.scrollLeft === 0) {
            this.props.setRecommendationScrollPosition(this?.tableRef?.current?.scrollLeft === 0 ? 1 : this?.tableRef?.current?.scrollLeft);
        }
        // if (this.tableRef?.current?.scrollTop) {
        //     this.props.setRecommendationScrollPosition(this.tableRef.current.scrollTop);
        // }
        this.setState({
            selectedRecommendations: recommendationsId
        });
        let tabKeyList = [
            "maindetails",
            "additionaldetails",
            "infoimages",
            "assetdetails",
            "checklists",
            "documents",
            "capitalrequest",
            "linked-recommendations",
            "linked-cr-recommendations",
            "softCosts",
            "qaqc"
        ];
        let selectedTab =
            (tab === "linked-recommendations" || tab === "linked-cr-recommendations") && rowData?.id
                ? "maindetails"
                : tabKeyList.includes(tab)
                  ? tab
                  : "maindetails";
        const currentParams = qs.parse(search);
        const newParams = { ...currentParams };
        if (isCapitalRequest || isCR) {
            newParams.is_cr = true;
        } else {
            delete newParams.is_cr;
        }
        if (isMobileRequest || isMR) {
            newParams.is_mr = true;
        } else {
            delete newParams.is_mr;
        }

        if (rowData?.id) {
            addTableSliderDataToBreadcrumb(this.state.tableData?.data || []);
        }
        const newPath = `/recommendations/recommendationsinfo/${recommendationsId}/${selectedTab}?${qs.stringify(newParams)}`;
        history.push(newPath);
    };

    getDataById = async recommendationsId => {
        await this.props.getRecommendationById(recommendationsId);
        return this.props.recommendationsReducer.getRecommendationByIdResponse || {};
    };

    qaqcPendingStatus = () => {
        // Drives the QA/QC tab indicator color (maps to /img/<qa status>.svg).
        return getReviewGateStatus(this.props.recommendationsReducer.getRecommendationByIdResponse);
    };
    getQaQcData = async params => {
        // if (localStorage.getItem("role") === "client_user") return null;
        await this.props.getAllRecommendationReviews(params);
        return this.props.recommendationsReducer.getAllRecommendationReviewsResponse || {};
    };

    isProjectReviewer = async params => {
        // if (localStorage.getItem("role") === "client_user") return null;
        const projectId = params.project_id;
        // const reviewProjcts = sessionStorage.getItem("reviewProjcts") ? JSON.parse(sessionStorage.getItem("reviewProjcts")) : [];
        // if (reviewProjcts?.includes(projectId)) return true;
        await this.props.getReviewersByProject(params);
        if (!!this.props.projectReducer.getReviewersByProjectData?.reviewer?.length) {
            // sessionStorage.setItem("reviewProjcts", JSON.stringify([...reviewProjcts, projectId]));
            return true;
        }
        return false;
    };
    uploadImages = async (imageData = {}) => {
        const { selectedRecommendations } = this.state;
        await this.props.uploadRecommendationImage(imageData, selectedRecommendations || this.props.match.params.id);
        // await this.getAllImageList(selectedRecommendations);
        return true;
    };

    deleteImages = async imageId => {
        const { selectedRecommendations } = this.state;
        await this.props.deleteRecommendationImage(imageId);
        const { success, message, error = ERROR_COPY.GENERIC } = this.props.recommendationsReducer.deleteImagesResponse || {};
        if (success) {
            await this.setState({
                alertMessage: message
            });
            this.showAlert();
        } else {
            await this.setState({
                alertMessage: error
            });
            this.showAlert();
        }
        // await this.getAllImageList(selectedRecommendations);
        return true;
    };

    getAllImageList = async (recommendationsId, params) => {
        await this.props.getAllRecommendationImages(recommendationsId, params);
        const {
            recommendationsReducer: { getAllImagesResponse }
        } = this.props;
        await this.setState({
            imageResponse: getAllImagesResponse
        });
        return true;
    };

    updateRecommendationImageComment = async imageData => {
        const { selectedRecommendations } = this.state;
        await this.props.updateRecommendationImageComment(imageData);
        // await this.getAllImageList(selectedRecommendations);
        return true;
    };

    openDeleteBox = (isDeleted = false) => {
        this.setState({
            showConfirmModal: true,
            isRedirectionOnDelete: true,
            isDeleted: isDeleted
        });
    };
    openRestoreBox = () => {
        this.setState({
            showRestoreConfirmModal: true,
            isRedirectionOnDelete: true
        });
    };

    exportTableXl = async (type, exportParams) => {
        if (type === "crossWalk") {
            this.exportCrossWalkExcel(exportParams);
            return;
        } else {
            this.handleDownloadRegularExcel(exportParams);
        }
    };

    exportAllTrades = async (export_type = "Building") => {
        const {
            tableData: { keys, config }
        } = this.state;
        await this.setState({ exportAllTradesLoading: true });
        let hide_columns = [""];
        keys.map((keyItem, i) => {
            if (config && !config[keyItem]?.isVisible) {
                hide_columns.push(config[keyItem]?.label);
            }
        });
        const listParams = this.getListParams();
        const tempParams = {
            hide_columns,
            export_type,
            ...listParams
        };
        await this.props.exportAllTrades(tempParams);
        this.setState({ exportAllTradesLoading: false });
        if (this.props.recommendationsReducer.exportAllTradesResponse && this.props.recommendationsReducer.exportAllTradesResponse.error) {
            await this.setState({ alertMessage: this.props.recommendationsReducer.exportAllTradesResponse.error });
            this.showAlert();
        }
    };

    showRestoreModal = async id => {
        await this.setState({
            showRestoreConfirmModal: true,
            selectedRecommendations: id
        });
    };

    renderRestoreConfirmationModal = () => {
        const { showRestoreConfirmModal } = this.state;
        if (!showRestoreConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Do you want to restore this ${this.props.isCapitalRequest ? this.getCrLabel() : "Recommendation"}?`}
                        message={""}
                        onNo={() => this.setState({ showRestoreConfirmModal: false })}
                        onYes={this.restoreRecommendationOnConfirm}
                        type={"restore"}
                        isRestore={true}
                    />
                }
                onCancel={() => this.setState({ showRestoreConfirmModal: false })}
            />
        );
    };

    restoreRecommendationOnConfirm = async () => {
        const { selectedRecommendations } = this.state;
        this.setState({
            isLoading: true,
            showRestoreConfirmModal: false
        });
        await this.props.getRestoreRecommendation(selectedRecommendations);
        if (
            this.props.recommendationsReducer.recoverRecommendationResponse &&
            this.props.recommendationsReducer.recoverRecommendationResponse.error
        ) {
            await this.setState({
                alertMessage: this.props.recommendationsReducer.recoverRecommendationResponse.error,
                showRestoreConfirmModal: false
            });
            this.showAlert();
        } else {
            await this.refreshRecommendationsList();
            // await this.props.getMenuItems();
            this.setState(
                {
                    alertMessage: this.props.recommendationsReducer.recoverRecommendationResponse?.message
                },
                () => this.showAlert()
            );
            if (this.state.isRedirectionOnDelete) {
                popBreadCrumpRecData();
                const redirectionurl = findPrevPathFromBreadCrumpRecData();
                this.props.history.push(findPrevPathFromBreadCrumpData() || "/recommendations");
                // this.props.history.push(redirectionurl[2].path || "/recommendations");
            }
            this.setState({
                showRestoreConfirmModal: false,
                isRedirectionOnDelete: false
            });
        }
        this.setState({
            isLoading: false
        });
    };

    getLogData = async buildingId => {
        const { historyParams } = this.state;
        this.setTableDataConfigBasedOnProject();
        await this.props.getAllRecommendationLogs(buildingId, historyParams);
        const {
            recommendationsReducer: {
                getAllRecommendationLogsResponse: { logs, count }
            }
        } = this.props;
        if (
            this.props.recommendationsReducer.getAllRecommendationLogsResponse &&
            this.props.recommendationsReducer.getAllRecommendationLogsResponse.error
        ) {
            await this.setState({ alertMessage: this.props.recommendationsReducer.getAllRecommendationLogsResponse.error });
            this.showAlert();
        } else {
            await this.setState({
                logData: {
                    ...this.state.logData,
                    data: logs
                },
                historyPaginationParams: {
                    ...this.state.historyPaginationParams,
                    totalCount: count,
                    totalPages: this.state.historyPaginationParams && Math.ceil(count / this.state.historyPaginationParams.perPage)
                }
            });
        }
    };

    handlePerPageChangeHistory = async e => {
        const { historyPaginationParams } = this.state;
        await this.setState({
            historyPaginationParams: {
                ...historyPaginationParams,
                perPage: e.target.value,
                currentPage: 0
            },
            historyParams: {
                ...this.state.historyParams,
                offset: 0,
                limit: e.target.value
            }
        });
        await this.getLogData(this.props.match.params.id);
    };

    handlePageClickHistory = async page => {
        const { historyPaginationParams, historyParams } = this.state;
        await this.setState({
            historyPaginationParams: {
                ...historyPaginationParams,
                currentPage: page.selected
            },
            historyParams: {
                ...historyParams,
                // offset: page.selected + 1
                offset: page.selected + 1
            }
        });
        await this.getLogData(this.props.match.params.id);
    };

    handleGlobalSearchHistory = async search => {
        const { historyParams, historyPaginationParams } = this.state;
        await this.setState({
            historyParams: {
                ...historyParams,
                offset: 0,
                search
            },
            historyPaginationParams: {
                ...historyPaginationParams,
                currentPage: 0
            }
        });
        await this.getLogData(this.props.match.params.id);
    };

    handleDeleteLog = async (id, choice = "delete") => {
        await this.setState({
            showConfirmModalLog: true,
            selectedLog: id,
            isRestoreOrDelete: choice
        });
    };

    renderConfirmationModalLog = () => {
        const { showConfirmModalLog, isRestoreOrDelete } = this.state;
        if (!showConfirmModalLog) return null;
        if (isRestoreOrDelete === "delete") {
            return (
                <Portal
                    body={
                        <ConfirmationModal
                            heading={"Do you want to delete this log?"}
                            message={"This action cannot be reverted, are you sure that you need to delete this item?"}
                            onNo={() => this.setState({ showConfirmModalLog: false })}
                            onYes={this.deleteLogOnConfirm}
                        />
                    }
                    onCancel={() => this.setState({ showConfirmModalLog: false })}
                />
            );
        } else {
            return (
                <Portal
                    body={
                        <ConfirmationModal
                            heading={"Do you want to restore this log?"}
                            message={"This action cannot be reverted, are you sure that you need to restore this item?"}
                            onNo={() => this.setState({ showConfirmModalLog: false })}
                            onYes={this.restoreLogOnConfirm}
                            isRestore={true}
                            type={"restore"}
                        />
                    }
                    onCancel={() => this.setState({ showConfirmModalLog: false })}
                />
            );
        }
    };

    deleteLogOnConfirm = async () => {
        const { selectedLog } = this.state;
        await this.props.deleteRecommendationLog(selectedLog);
        if (
            this.props.recommendationsReducer.deleteRecommendationLogResponse &&
            this.props.recommendationsReducer.deleteRecommendationLogResponse.error
        ) {
            await this.setState({ alertMessage: this.props.recommendationsReducer.deleteRecommendationLogResponse.error });
            this.showAlert();
        }
        await this.getLogData(this.props.match.params.id);
        // await this.props.getMenuItems();
        this.setState({
            showConfirmModalLog: false,
            selectedLog: null
        });
    };

    HandleRestoreRegionLog = async id => {
        this.setState({ isLoading: true });
        await this.props.restoreRecommendationLog(id);
        if (
            this.props.recommendationsReducer.restoreRecommendationLogResponse &&
            this.props.recommendationsReducer.restoreRecommendationLogResponse.error
        ) {
            await this.setState({ alertMessage: this.props.recommendationsReducer.restoreRecommendationLogResponse.error, isLoading: false });
            this.showAlert();
        } else {
            await this.refreshRecommendationsList();
            await this.setState({ alertMessage: this.props.recommendationsReducer.restoreRecommendationLogResponse.message, isLoading: false });
            this.showAlert();
        }
    };

    updateLogSortFilters = async searchKey => {
        if (this.state.historyParams.order) {
            await this.setState({
                historyParams: {
                    ...this.state.historyParams,
                    order: {
                        ...this.state.historyParams.order,
                        [searchKey]: this.state.historyParams.order[searchKey] === "desc" ? "asc" : "desc"
                    }
                }
            });
        } else {
            await this.setState({
                historyParams: {
                    ...this.state.historyParams,
                    order: { [searchKey]: "asc" }
                }
            });
        }
        this.updateEntityParams();
        await this.getLogData(this.props.match.params.id);
    };
    selectFilterHandler = async e => {
        switch (e.target.value) {
            case "locked":
                await this.setState({
                    params: {
                        ...this.state.params,
                        locked: true,
                        unlocked: null,
                        deleted: null,
                        active: null,
                        view: null,
                        on_hold: null,
                        completed: null
                    },
                    selectedDropdown: e.target.value,
                    selectedRecomIds: []
                });
                break;
            case "unlocked":
                await this.setState({
                    params: {
                        ...this.state.params,
                        unlocked: true,
                        deleted: null,
                        active: null,
                        locked: null,
                        view: null,
                        on_hold: null,
                        completed: null
                    },
                    selectedDropdown: e.target.value,
                    selectedRecomIds: []
                });
                break;
            case "assigned":
                await this.setState({
                    params: {
                        ...this.state.params,
                        view: "assigned",
                        unlocked: null,
                        deleted: null,
                        active: null,
                        locked: null,
                        on_hold: null,
                        completed: null
                    },
                    selectedDropdown: e.target.value,
                    selectedRecomIds: []
                });
                break;
            case "unassigned":
                await this.setState({
                    params: {
                        ...this.state.params,
                        view: "unassigned",
                        unlocked: null,
                        deleted: null,
                        active: null,
                        locked: null,
                        on_hold: null,
                        completed: null
                    },
                    selectedDropdown: e.target.value,
                    selectedRecomIds: []
                });
                break;
            case "all":
                await this.setState({
                    params: {
                        ...this.state.params,
                        deleted: null,
                        active: null,
                        locked: null,
                        unlocked: null,
                        view: null,
                        on_hold: null,
                        completed: null
                    },
                    selectedDropdown: e.target.value,
                    selectedRecomIds: []
                });
                break;
            default:
                break;
        }
        await this.updateEntityParams();
        await this.refreshRecommendationsList();
    };

    selectFilterHandlerInitiative = async e => {
        switch (e.target.value) {
            case "locked":
                await this.setState({
                    params: {
                        ...this.state.params,
                        locked: true,
                        unlocked: null,
                        deleted: null,
                        active: null,
                        on_hold: null,
                        completed: null
                    },
                    selectedDropdown: e.target.value,
                    selectedRecomIds: []
                });
                break;
            case "unlocked":
                await this.setState({
                    params: {
                        ...this.state.params,
                        unlocked: true,
                        deleted: null,
                        active: null,
                        locked: null,
                        on_hold: null,
                        completed: null
                    },
                    selectedDropdown: e.target.value,
                    selectedRecomIds: []
                });
                break;
            case "assigned":
                await this.setState({
                    params: {
                        ...this.state.params,
                        view: "assigned"
                    },
                    selectedDropdownInitiaive: e.target.value,
                    selectedRecomIds: []
                });
                break;
            case "unassigned":
                await this.setState({
                    params: {
                        ...this.state.params,
                        view: "unassigned"
                    },
                    selectedDropdownInitiaive: e.target.value,
                    selectedRecomIds: []
                });
                break;
            case "all":
                await this.setState({
                    params: {
                        ...this.state.params,
                        view: null
                    },
                    selectedDropdownInitiaive: e.target.value,
                    selectedRecomIds: []
                });
                break;
            case "allInitiative":
                await this.setState({
                    params: {
                        ...this.state.params,
                        deleted: null,
                        active: null,
                        locked: null,
                        unlocked: null,
                        on_hold: null,
                        completed: null
                    },
                    selectedRecomIds: [],
                    selectedDropdown: e.target.value
                });
                break;
            default:
                break;
        }
        await this.updateEntityParams();
        await this.refreshRecommendationsList();
    };

    showAlert = () => showAlertUtil(this.state.alertMessage);

    renderConfirmationModalUnassign = () => {
        const { confirmUnAssign, selectedRecomIds } = this.state;
        if (!confirmUnAssign) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Do you want to unassign ${selectedRecomIds?.length > 1 ? "these" : "this"} ${
                            selectedRecomIds?.length > 1 ? "Recommendations" : "Recommendation"
                        }?`}
                        message={""}
                        onNo={() => this.setState({ confirmUnAssign: false })}
                        onYes={this.handleUnassign}
                        type={"unassign"}
                        isUnAssign={true}
                    />
                }
                onCancel={() => this.setState({ confirmUnAssign: false })}
            />
        );
    };

    handleUnassign = async () => {
        const { selectedRecomIds } = this.state;
        this.setState({
            confirmUnAssign: false,
            isLoading: true
        });
        if (this.props.match.params.section === "imageInfo") {
            let params = {
                id: this.props.match.params.id,
                recommendation_ids: selectedRecomIds.map(elem => elem.id)
            };
            await this.props.unAssignImage(params);
            const { unAssignImageResponse } = this.props.recommendationsReducer;
            if (unAssignImageResponse.error) {
                this.setState(
                    {
                        alertMessage: unAssignImageResponse.error,
                        isLoading: false
                    },
                    () => this.showAlert()
                );
            } else if (unAssignImageResponse.success) {
                await this.refreshRecommendationsList();
                this.setState(
                    {
                        alertMessage: unAssignImageResponse.message
                    },
                    () => this.showAlert()
                );
            }
        } else {
            let data = {
                recommendation_ids: selectedRecomIds.map(elem => elem.id)
            };
            this.setState({
                confirmUnAssign: false,
                isLoading: true
            });
            await this.props.unAssignProject(data, this.props.match.params.id);
            const { success, error, message } = this.props.initativeReducer.unAssignProject || {};
            if (success) {
                this.props.refreshInitiativeDetails();
                await this.refreshRecommendationsList();
                this.setState(
                    {
                        alertMessage: message,
                        selectedRecomIds: []
                    },
                    () => {
                        this.updateEntityParams();
                        this.showAlert();
                    }
                );
            } else {
                this.setState(
                    {
                        alertMessage: error,
                        isLoading: false
                    },
                    () => this.showAlert()
                );
            }
        }
    };

    unAassignContent = async () => {
        this.setState({
            confirmUnAssign: true
        });
    };
    renderAssingConfirmationModal = () => {
        const { showAssignConfirmationModal, selectedRecomIds } = this.state;
        if (!showAssignConfirmationModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Do you want to assign ${selectedRecomIds?.length > 1 ? "these" : "this"} ${
                            selectedRecomIds?.length > 1 ? "recommendations" : "recommendation"
                        } to the Initiative?`}
                        message={"Are you sure?"}
                        onNo={() => this.setState({ showAssignConfirmationModal: false })}
                        onYes={this.handleAssignRecommendation}
                        type={"unassign"}
                        isUnAssign={true}
                    />
                }
                onCancel={() => this.setState({ showAssignConfirmationModal: false })}
            />
        );
    };

    handleAssignRecommendation = async () => {
        this.setState({ showAssignConfirmationModal: false, isLoading: true });
        const { selectedRecomIds } = this.state;
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        let data = {
            recommendation_ids: selectedRecomIds.map(elem => elem.id),
            process: "false",
            initiative_id: this.props.match.params.id,
            project_id: query.pid
        };

        await this.props.assignProject(data, this.props.match.params.id);
        const { success, message, error = ERROR_COPY.GENERIC } = this.props.initativeReducer.assignProject || {};
        if (success) {
            this.props.refreshInitiativeDetails();
            await this.refreshRecommendationsList();
            this.setState(
                {
                    alertMessage: message,
                    selectedRecomIds: []
                },
                () => {
                    this.updateEntityParams();
                    this.showAlert();
                }
            );
        } else {
            this.setState(
                {
                    alertMessage: error,
                    isLoading: false
                },
                () => this.showAlert()
            );
        }
    };

    assignInitiative = async () => {
        this.setState({
            showAssignConfirmationModal: true
        });
    };

    downloadPdfReport = async params => {
        this.setState({ isLoading: true });
        await this.props.downloadPdfReport(params);
        await this.props.addUserActivityLog({ text: "Downloaded pdf report." });
        this.setState({ isLoading: false });
        const { success, PDF_URL } = this.props.recommendationsReducer.pdfReportResponse || {};
        if (!success) {
            this.setState(
                {
                    alertMessage: "Narrative Report Not Found"
                },
                () => this.showAlert()
            );
            return false;
        }
        const link = document.createElement("a");
        link.href = PDF_URL;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    assignImagesToRecom = async imageData => {
        const { selectedRecommendations } = this.state;
        await this.props.assignImagesToRecom(imageData, selectedRecommendations || this.props.match.params.id);
        return this.props.recommendationsReducer.assignImageResponse;
    };

    handleSelectRecom = async (data, isChecked) => {
        this.setState({
            isLoading: true
        });
        await new Promise(resolve => setTimeout(resolve, 1));
        const {
            tempRecommendationsList,
            selectedRecomIds,
            paginationParams: { currentPage, perPage }
        } = this.state;
        const { id, lock_status } = data;
        const page = currentPage * perPage;
        const index = page + (tempRecommendationsList.findIndex(elem => elem.id === id) + 1);
        await this.setState({
            selectedRecomIds: isChecked
                ? [...selectedRecomIds, { id, index, locked: lock_status === LOCK_STATUS.LOCKED || data?.is_survey_lock }]
                : selectedRecomIds.filter(t => t.id !== id),
            isLoading: false
        });
        this.updateEntityParams();
    };

    handleSelectAllRecom = async isChecked => {
        this.setState({
            isLoading: true
        });
        await new Promise(resolve => setTimeout(resolve, 1));
        const {
            tempRecommendationsList,
            selectedRecomIds,
            paginationParams: { currentPage, perPage }
        } = this.state;
        let tempSelected = [...this.state.selectedRecomIds];
        const page = currentPage * perPage;
        if (isChecked) {
            tempRecommendationsList.forEach((item, idx) => {
                if (!tempSelected.some(t => t.id === item.id)) {
                    tempSelected.push({
                        id: item.id,
                        locked: item?.lock_status === LOCK_STATUS.LOCKED || item?.is_survey_lock === true,
                        index: page + (idx + 1)
                    });
                }
            });
        } else {
            tempSelected = selectedRecomIds;
            tempRecommendationsList.forEach((item, idx) => {
                tempSelected = tempSelected.filter(t => t.id !== item.id);
            });
        }
        await this.setState({ selectedRecomIds: tempSelected, isLoading: false });
        this.updateEntityParams();
    };

    selectWholeRecommendation = async () => {
        this.setState({ isLoading: true });
        const { isSmartChartView = false, smartChartFilters = {}, surveyFilters = {} } = this.props;
        let params = this.getListParams();
        await this.props.getAllRecommendationIds({
            ...(isSmartChartView && { ...smartChartFilters }),
            ...(surveyFilters
                ? {
                      ...surveyFilters,
                      ...(surveyFilters?.region?.length && { region_ids: surveyFilters.region }),
                      ...(surveyFilters?.site?.length && { site_ids: surveyFilters.site }),
                      ...(surveyFilters?.building?.length && { building_ids: surveyFilters.building }),
                      ...(surveyFilters?.floor?.length && { floor_ids: surveyFilters.floor }),
                      ...(surveyFilters?.addition?.length && { addition_ids: surveyFilters.addition })
                  }
                : {}),
            ...params
        });
        const { recommendation_ids } = this.props.recommendationsReducer.getWholeRecommendationIdsResponse;
        let tempSelected = [];
        recommendation_ids?.length &&
            recommendation_ids.forEach((id, index) => {
                tempSelected.push({ id, index });
            });
        await this.setState({ selectedRecomIds: [] });
        await this.setState({ selectedRecomIds: tempSelected, isLoading: false });
        this.updateEntityParams();
    };

    clearSelection = async () => {
        await this.setState({ selectedRecomIds: [] });
        this.updateEntityParams();
        if (this.state.params?.recommendation_ids) {
            await this.setState({
                params: {
                    ...this.state.params,
                    offset: 0,
                    recommendation_ids: null
                },
                paginationParams: {
                    ...this.state.paginationParams,
                    currentPage: 0
                }
            });
            await this.refreshRecommendationsList();
        }
    };

    filterBySurveyor = async val => {
        const filterKey = this.props.isCapitalRequest ? "requestor" : "surveyor";
        const otherFilterKey = filterKey === "requestor" ? "surveyor" : "requestor";
        const printedName = localStorage.getItem("printed_name");

        if (val === null || val === undefined) {
            await this.setState({
                params: {
                    ...this.state.params,
                    offset: 0,
                    recommendation_ids: null,
                    [filterKey]: null,
                    [otherFilterKey]: null
                },
                paginationParams: {
                    ...this.state.paginationParams,
                    currentPage: 0
                },
                selectedRecomIds: []
            });
            this.updateEntityParams();
            await this.refreshRecommendationsList();
            return;
        }

        if (printedName && printedName !== "undefined" && printedName !== null && printedName !== "null") {
            await this.setState({
                params: {
                    ...this.state.params,
                    offset: 0,
                    recommendation_ids: null,
                    [filterKey]: printedName,
                    [otherFilterKey]: null
                },
                paginationParams: {
                    ...this.state.paginationParams,
                    currentPage: 0
                },
                selectedRecomIds: []
            });
            this.updateEntityParams();
            await this.refreshRecommendationsList();
        } else {
            this.setState(
                {
                    alertMessage: "You don't have a printed name. please provide a printed name"
                },
                () => this.showAlert()
            );
        }
    };
    filterByImages = async () => {
        const { image_or_not } = this.state.params;
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                image_or_not: image_or_not === "true" ? "false" : image_or_not === "false" ? null : "true",
                recommendation_ids: null
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            },
            selectedRecomIds: []
        });
        this.updateEntityParams();
        await this.refreshRecommendationsList();
    };
    filterByReviews = async value => {
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                review_status: value,
                recommendation_ids: null
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            },
            selectedRecomIds: []
        });
        this.updateEntityParams();
        await this.refreshRecommendationsList();
    };
    filterByQaStatus = async value => {
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                qa_qc_status: value,
                recommendation_ids: null
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            },
            selectedRecomIds: []
        });
        this.updateEntityParams();
        await this.refreshRecommendationsList();
    };

    filterByAnyKey = async (key, value) => {
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                recommendation_ids: null,
                [key]: value
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            },
            selectedRecomIds: []
        });
        this.updateEntityParams();
        await this.refreshRecommendationsList();
    };

    resetEntityParams = async CrUpdatedData => {
        await this.setState({
            selectedRegion: null,
            paginationParams: {
                totalPages: 0,
                perPage: 40,
                currentPage: 0,
                totalCount: 0
            },
            params: {
                ...this.state.params,
                limit: 40,
                offset: 0,
                search: "",
                order: null,
                index: [],
                maintenance_year: [],
                priority_elements: null,
                filters: null,
                list: null,
                view: this.props.match.params.tab === "recommendation" ? "assigned" : null,
                locked: null,
                unlocked: true,
                image_or_not: null,
                infrastructure_request: null,
                surveyor: null,
                requestor: null,
                recommendation_ids: null,
                water: null,
                caption_missing: null,
                energy: null,
                facility_master_plan: null,
                recommendation_type: null,
                budget_priority: null,
                review_status: null,
                qa_qc_status: null,
                opinions_cost_vs_project_total: null,
                findParams: null,
            },
            tableData: {
                ...this.state.tableData,
                data: []
            },
            wildCardFilterParams: {},
            filterParams: {},
            tableConfig: null,
            selectedRowId: null,
            selectedDropdown: "unlocked",
            selectedDropdownInitiaive: "assigned",
            selectedRecomIds: [],
            parentSectionId: null,
            tableDataExportFilters: {},
            myFilters: {},
            queries: [],
            selectedPreviewId: null,
            normalRecomGrouping: {}
        });
        this.updateEntityParams();
    };

    resetAll = async () => {
        this.setState({ isLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));
        await this.resetEntityParams();
        await this.refreshRecommendationsList();
        this.setState({ isLoading: false });
    };

    isColunmVisibleChanged = () => {
        let flag = false;
        const {
            tableData: { keys, config },
            initialTableConfig,
            tableConfigChanged
        } = this.state;
        keys.forEach(key => {
            if (initialTableConfig[key] && !_.isEqual(config[key]?.isVisible, initialTableConfig[key]?.isVisible)) {
                flag = true;
            }
        });
        return flag || tableConfigChanged;
    };

    toggleMultiSelectEditForm = async () => {
        //if locked selected
        const hasLockRecom = this.state.selectedRecomIds.some(elem => elem.locked || elem.is_survey_lock);
        if (hasLockRecom) {
            await this.setState({
                alertMessage: "Locked recommendations cannot be edited!"
            });
            this.showAlert();
        } else {
            this.setState({ showMultiSelectEditForm: !this.state.showMultiSelectEditForm });
        }
    };

    renderMultiSelectEditForm = () => {
        const { showMultiSelectEditForm, selectedRecomIds } = this.state;
        if (!showMultiSelectEditForm) return null;
        const {
            match: {
                params: { section, tab }
            }
        } = this.props;
        return (
            <Portal
                body={
                    <MultiSelectFormModal
                        handleUpdateRecommendations={this.handleUpdateMultiRecommendations}
                        getSiteListBasedOnRegion={this.getSiteListBasedOnRegion}
                        getRegionListBasedOnClient={this.getRegionListBasedOnClient}
                        clientId={this.props.projectReducer?.getProjectByIdResponse?.client?.id}
                        projectId={this.props.projectIdDashboard ? this.props.projectIdDashboard : this.props.match.params.id}
                        onCancel={this.toggleMultiSelectEditForm}
                        selectedRecomIds={selectedRecomIds.map(elem => elem.id)}
                        isCapitalRequest={(section === "recommendationsinfo" && tab === "linked-cr-recommendations") || this.props.isCapitalRequest}
                    />
                }
                onCancel={this.toggleMultiSelectEditForm}
            />
        );
    };

    handleBulkQaCompleted = async () => {
        await this.setState({
            selectedRecomIds: [],
            params: { ...this.state.params, offset: 0 },
            paginationParams: { ...this.state.paginationParams, currentPage: 0 }
        });
        this.updateEntityParams();
        await this.refreshRecommendationsList();
    };

    handleUpdateMultiRecommendations = async recommendation => {
        const { selectedRecomIds } = this.state;
        const {
            match: {
                params: { section, tab }
            },
            isCapitalRequest
        } = this.props;
        const isCR = (section === "recommendationsinfo" && tab === "linked-cr-recommendations") || isCapitalRequest;
        await this.props.updateMultipleRecommendations(
            recommendation,
            selectedRecomIds.map(elem => elem.id),
            { is_cr: isCR }
        );
        if (
            this.props.recommendationsReducer.updateMultipleRecommendationsResponse &&
            this.props.recommendationsReducer.updateMultipleRecommendationsResponse.error
        ) {
            await this.setState({
                alertMessage: this.props.recommendationsReducer.updateMultipleRecommendationsResponse.error
            });
            this.showAlert();
        } else {
            this.toggleMultiSelectEditForm();
            if (recommendation?.year || recommendation?.maintenance_years) {
                await this.props.syncProjectCost({
                    project_id: this.getProjectId(),
                    recommendation_ids: selectedRecomIds.map(elem => elem.id)
                });
            }
            await this.setState({
                selectedRecomIds: [],
                params: {
                    ...this.state.params,
                    offset: 0
                },
                paginationParams: {
                    ...this.state.paginationParams,
                    currentPage: 0
                }
            });
            this.updateEntityParams();
            await this.refreshRecommendationsList();
            await this.setState({
                alertMessage: this.props.recommendationsReducer.updateMultipleRecommendationsResponse?.message
            });
            this.showAlert();
        }
    };

    filterByOpinions_cost = async value => {
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                opinions_cost_vs_project_total: value,
                recommendation_ids: null
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            },
            selectedRecomIds: []
        });
        this.updateEntityParams();
        await this.refreshRecommendationsList();
    };

    showSelectedRecom = async () => {
        if (this.state.params.recommendation_ids?.length) {
            await this.setState({
                params: {
                    ...this.state.params,
                    offset: 0,
                    recommendation_ids: null
                },
                paginationParams: {
                    ...this.state.paginationParams,
                    currentPage: 0
                }
            });
        } else {
            await this.setState({
                params: {
                    ...this.state.params,
                    offset: 0,
                    recommendation_ids: this.state.selectedRecomIds.map(elem => elem.id)
                },
                paginationParams: {
                    ...this.state.paginationParams,
                    currentPage: 0
                }
            });
        }
        this.updateEntityParams();
        await this.refreshRecommendationsList();
    };

    exportSelectedRecom = async (type, RecomData) => {
        const {
            selectedRecomIds,
            params: {
                list,
                infrastructure_request,
                image_or_not,
                water,
                caption_missing,
                energy,
                facility_master_plan,
                recommendation_type,
                budget_priority
            },
            tableData: { keys, config }
        } = this.state;

        const {
            match: {
                params: { section, id }
            },
            location: { search },
            isCapitalRequest
        } = this.props;

        const query = qs.parse(search);
        const project_id = section === "projectinfo" ? id : query.pid;

        const sortedRecommendationIds = selectedRecomIds.sort((a, b) => a.index - b.index).map(elem => elem.id);

        let key_name = {};

        if (list && Object.keys(list).length) {
            keys.forEach(item => {
                Object.entries(list).forEach(([key, value]) => {
                    if (config[item]?.searchKey === key) {
                        key_name[config[item].label] = value;
                    }
                });
            });
        }

        const extraFilters = {
            ...(infrastructure_request && { "Infrastructure Request": [infrastructure_request] }),
            ...(water && { Water: [water] }),
            ...(caption_missing && { "Caption Missing": [caption_missing] }),
            ...(energy && { Energy: [energy] }),
            ...(facility_master_plan && { FMP: [facility_master_plan] }),
            ...(recommendation_type && { "Recommendation Type": [recommendation_type] }),
            ...(budget_priority && { "Budget Priority": [budget_priority] }),
            ...(image_or_not && { Images: [image_or_not === "true" ? "yes" : "no"] })
        };

        key_name = { ...key_name, ...extraFilters };
        if (!Object.keys(key_name).length) key_name = null;

        const commonParams = {
            recommendations: sortedRecommendationIds,
            key_name,
            username: localStorage.getItem("user"),
            project_id,
            notes: RecomData?.isChecked,
            notes_in_cell: RecomData?.isSimpleNarrativeText,
            user_id: localStorage.getItem("userId"),
            ...(isCapitalRequest && { is_cr: true })
        };

        if (type === "word") {
            this.setState({ multiExportWordLoader: true });
            await this.props.exportSelectedRecomWord(commonParams);
            this.setState({ multiExportWordLoader: false });
        } else if (type === "pdf") {
            this.setState({ multiExportPdfLoader: true });
            await this.props.exportSelectedRecomPDF(commonParams);
            this.setState({ multiExportPdfLoader: false });
        }
    };

    getPriorityElementDropDownData = async projectId => {
        await this.props.getPriorityElementDropDownData(projectId);
        return this.props.recommendationsReducer.priorityElementsDropDownResponse || {};
    };

    postExport = async (params, exportType) => {
        this.setState({ exportLoader: true });
        await this.props.exportReportPdf(params, exportType);
        this.setState({ exportLoader: false });
    };

    // get sorted recom export params (word/excel)
    getExportParams = () => {
        const {
            match: {
                params: { section, tab }
            },
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        const project_id =
            this.props.projectIdDashboard ||
            this.props?.projectIdForSmartChart ||
            query.pid ||
            this.props?.projectIdMobile ||
            this.props.match.params.id ||
            "";
        const userId = localStorage.getItem("userId");
        const user_name = localStorage.getItem("user");
        const scope = section.substring(0, section.length - 4);
        const { tableDataExportFilters, myFilters, dashboardFilterParams, queries } = this.state;
        const result = AppliedQueryFilters(myFilters, queries, "for_export");
        let clonedQueryFilters = _.cloneDeep(result);
        let finalFilters = _.merge({}, reverseDynamicFieldParams(dashboardFilterParams), clonedQueryFilters);
        const updatedTableDataExportFilters = Object.keys(tableDataExportFilters)?.reduce((newFilters, key) => {
            const value = tableDataExportFilters[key];
            if (key === "buildings_descriptions") {
                newFilters[key] = (this.state?.params?.list && this.state?.params?.list["buildings.description"]) || value;
            } else {
                newFilters[key] = value;
            }
            return newFilters;
        }, {});
        let params = {
            project_id,
            user_id: userId,
            export_from: scope,
            user_name,
            filters: finalFilters?.filters,
            exclude_filters: finalFilters?.exclude_filters,
            dynamic_filters: finalFilters?.dynamic_filters,
            top_n: finalFilters?.top_n,
            config_filter: {
                ...this.state?.params,
                ...getUpdatedCommonFilters(
                    this.state?.tableDataExportFilters || {},
                    this.state?.params?.list,
                    Object.entries(this.props.recommendationsReducer.entityParams[this.props.match.params.section]?.tableConfig || {})
                ),
                wildcard_filters: {
                    ...getUpdatedWildCardFilters(
                        this.state.params?.filters || {},
                        Object.entries(this.props.recommendationsReducer.entityParams[this.props.match.params.section]?.tableConfig || {}),
                        this.props.recommendationsReducer.priorityElementsDropDownResponse
                    )
                },
                global_search: this?.state?.params?.search || "",
                sort_by_order: {
                    ...getUpdatedSortFilters(
                        this.state?.params?.order || {},
                        Object.entries(this.props.recommendationsReducer.entityParams[this.props.match.params.section]?.tableConfig || {}),
                        this.state?.params
                    )
                },
                ...(this?.state?.params?.priority_elements ? { priority_elements: this?.state?.params?.priority_elements } : {}),
                list: this.state.params.list,
                order: this.state.params.order,
                capital_type: this.state.capital_type,
                start_year: this.state.start_year || null,
                end_year: this.state.end_year || null,
                infrastructure_requests: this.state.infrastructure_requests || null,
                year: this.state.year,
                dashboard: this.state.dashboard,
                recommendation_ids: this.state?.selectedRecomIds?.map(item => item.id)
            },
            config_filter_names: {
                list: this.state?.params?.list || null,
                filters: this.state?.params?.filters,
                tableDataExportFilters: this.state?.tableDataExportFilters,
                order: this.state?.params?.order || null,
                maintenance_year: this.state?.params?.maintenance_year || []
            },
            ...updatedTableDataExportFilters
        };
        if (finalFilters?.start_year) {
            params.start_year = finalFilters?.start_year;
        }
        if (finalFilters?.end_year) {
            params.end_year = finalFilters?.end_year;
        }
        if (section === "buildinginfo") {
            params.building_id = [this.props.match.params.id];
        } else if (section === "siteinfo") {
            params.site_id = [this.props.match.params.id];
        } else if (section === "regioninfo") {
            params.region_id = [this.props.match.params.id];
        } else if (section === "imageInfo") {
            params.image_id = [this.props.match.params.id];
        } else if (section === "assetInfo") {
            params.asset_id = [this.props.match.params.id];
        } else if (section === "recommendationsinfo" && tab === "linked-recommendations") {
            params.capital_request_id = this.props.match.params.id;
        } else if (section === "recommendationsinfo" && tab === "linked-cr-recommendations") {
            params.child_cr_recommendation_id = this.props.match.params.id;
            params.is_cr = true;
        } else if (tab === "mr-recommendations") {
            params.survey_recommendation_id = this.props.match.params.mrId;
        } else if (this.props.isCapitalRequest) {
            params.is_cr = true;
        } else if (this.props?.isAssignRecomView) {
            const {
                location: { search }
            } = this.props;
            const query = qs.parse(search);
            params.project_id = query?.pid;
            params.survey_recommendation_project_id = this.props?.survey_recommendation_project_id;
        }

        //if dashboard filtered
        const { masterFilterList, filterFields } = this.props.dashboardReducer;
        if (filterFields?.length) {
            filterFields.forEach(fil => {
                if (fil.exportFilterKey === "building_type_id" && finalFilters?.[fil.paramKey]?.length) {
                    const building_type_ids =
                        masterFilterList?.building_types
                            ?.filter(item => finalFilters?.building_types?.some(elm => elm === item.name))
                            .map(item => item.id) || [];
                    if (building_type_ids?.length) {
                        params[fil.exportFilterKey] = building_type_ids;
                    } else if (fil?.paramKey === "building_types") {
                        params.building_type_id = finalFilters?.[fil?.paramKey];
                    }
                } else if (fil.exportFilterKey && finalFilters?.[fil.paramKey]?.length && fil.paramKey !== "project_ids") {
                    params[fil.exportFilterKey] = finalFilters?.[fil.paramKey];
                }
            });
            if (query.DM_ID) {
                params.recommendation_capital_type_id = [query.DM_ID];
            }
            if (finalFilters.year) {
                params.year = finalFilters.year;
            }
            if (finalFilters.recommendation_conditions) {
                params.recommendation_conditions = finalFilters.recommendation_conditions;
            }
        }
        return this.applyCurrentFindParamsToRecommendationParams(params);
    };

    exportCrossWalkExcel = async exportParams => {
        this.setState({ exportWordLoading: "crossWalk" });
        let params = this.getExportParams();
        params.is_soft_cost = exportParams?.includeSoftCost;
        const outcome = await this.props.exportToExcelFile(params, "crossWalk");
        this.setState({ exportWordLoading: false });
        const res = this.props.recommendationsReducer.exportExcelDataResponse;
        await this.setState({
            alertMessage: res?.message_status ? res.message_status : res?.message
        });
        this.showAlert();
        return outcome;
    };

    exportToWord = async (sort_type, exportParam) => {
        this.setState({ exportWordLoading: "sortedWord" });
        let params = this.getExportParams();
        params.sort_type = sort_type;
        params.is_soft_cost = exportParam?.includeSoftCost;
        params.number_of_recom = this.state?.selectedRecomIds?.length || this.state?.paginationParams.totalCount;
        const outcome = await this.props.exportToWord(params);
        this.setState({ exportWordLoading: false });
        const res = this.props.recommendationsReducer.exportWordDataResponse;
        await this.setState({
            alertMessage: res?.message_status ? res.message_status : res?.message
        });
        this.showAlert();
        return outcome;
    };
    exportToExcel = async (sort_type, exportParam) => {
        this.setState({ exportWordLoading: "sortedExcel" });
        let params = this.getExportParams();
        params.sort_type = sort_type;
        params.is_soft_cost = exportParam?.includeSoftCost;
        params.number_of_recom = this.state?.selectedRecomIds?.length || this.state?.paginationParams.totalCount;
        const outcome = await this.props.exportToExcelFile(params, "sortedExcel");
        this.setState({ exportWordLoading: false });
        const res = this.props.recommendationsReducer.exportExcelDataResponse;
        await this.setState({
            alertMessage: res?.message_status ? res.message_status : res?.message
        });
        this.showAlert();
        return outcome;
    };

    lockRecommendation = flag => {
        lockRecommendation(this.props.match.params.id, { lock: flag });
    };

    modifyDashboardFilterParams = () => {
        let { dashboardFilterParams } = this.state;
        const { chart_type, horizontal_chart_type } = this.state?.dashboardFilterParams || {};
        const trade_id =
            chart_type?.split("_")[0] === "system"
                ? chart_type?.split("_")[1]
                : horizontal_chart_type?.split("_")[0] === "system"
                  ? horizontal_chart_type?.split("_")[1]
                  : null;
        if (trade_id) {
            delete dashboardFilterParams.chart_type;
            dashboardFilterParams.trade_id = trade_id;
        }
        this.setState({ dashboardFilterParams });
    };
    toggleLineEditing = async () => {
        this.setState({ isLoading: true });

        await new Promise(resolve => setTimeout(resolve, 100));
        this.setState(
            prevState => ({
                lineEditingEnabled: !prevState.lineEditingEnabled,
                isLoading: false
            }),
            () => this.updateEntityParams()
        );
    };

    isCrLinkedTab = () =>
        this.props?.isCrLinkPicker ||
        ["linked-recommendations", "linked-cr-recommendations"].includes(this.props.match.params.tab);

    getProjectId = () =>
        this.props.projectIdDashboard ||
        this.props.projectIdForSmartChart ||
        (this.isCrLinkedTab() ? "" : this.props.match.params.id) ||
        "";

    getDropdownOptions = async (keyItem, projectId, rowData, search) => {
        const cellConfig = this.state.tableData?.config?.[keyItem] || {};
        const configuredOptions = Array.isArray(cellConfig?.options) ? cellConfig.options : [];

        if (cellConfig?.isDropdownLineEdit && cellConfig?.isDynamicField && configuredOptions.length) {
            return configuredOptions;
        }

        switch (keyItem) {
            case "criticality":
                await this.props.getCriticalityData({ project_id: projectId });
                return this.props.projectReducer.criticalityData?.criticalities || [];

            case "category":
                await this.props.getCategoryBasedOnProject(projectId);
                return this.props.recommendationsReducer.getCategoryByProject?.categories || [];

            case "status":
                await this.props.statusDropdown(projectId);
                const raw = (this.props.recommendationStatusReducer.getStatusDropdwnResponse?.recommendation_status_data || []).filter(
                    item => item.key !== "deleted"
                );
                return raw.reduce((groups, item) => {
                    const label = item.group_name || "Others";
                    let grp = groups.find(g => g.label === label);
                    if (!grp) {
                        grp = { label, options: [] };
                        groups.push(grp);
                    }
                    grp.options.push({
                        label: item.name,
                        value: item.id,
                        description: item.description,
                        key: item.key
                    });
                    return groups;
                }, []);

            case "funding_source":
                await this.props.getFundingSourceByProject(projectId);
                return this.props.recommendationsReducer.getFundingSourceByProject?.funding_sources || [];

            case "recommendation_space_type":
                await this.props.getSpaceType({ project_id: projectId });
                return this.props.recommendationsReducer.getSpaceTypeResponse?.space_types_list || [];

            case "department":
                await this.props.getDepartmentByProject(projectId);
                return (this.props.recommendationsReducer.getDepaartmentsByProject?.departments || []).filter(d => d.name !== null);

            case "condition":
                if (rowData.recommendation_type === RECOMMENDATION_TYPES.ASSET) {
                    await this.props.getDropdownList("asset_conditions", { client_id: this.props.projectReducer.getProjectByIdResponse?.client?.id });
                    return this.props.assetDropdownList?.asset_conditions || [];
                } else {
                    await this.props.getConditionBasedOnProject(projectId);
                    return this.props.recommendationsReducer.getConditionBasedOnProject?.asset_conditions || [];
                }

            case "capital_type_display_name":
                await this.props.getCapitalTypeDropDownData(projectId);
                return (this.props.recommendationsReducer.capitalTypeDropDownResponse?.capital_types || []).map(item => ({
                    ...item,
                    name: item?.display_name || item?.name || ""
                }));

            case "responsibility":
                await this.props.getResponsibilityByProject(projectId);
                return this.props.recommendationsReducer.getResponsibilityByProject?.responsibilities || [];

            case "initiative":
                await this.props.getInitiativeDropdown({
                    project_id: projectId,
                    client_id: this.props.projectReducer.getProjectByIdResponse?.client?.id
                });
                return this.props.recommendationsReducer.getInitiativeDropdown?.projects || [];

            case "addition":
            case "floor": {
                const bId = rowData?.building?.id;
                if (!bId) return [];
                if (keyItem === "addition") {
                    await this.props.getAdditionBasedOnBuilding(bId);
                    return this.props.recommendationsReducer.getAdditionByBuilding?.additions || [];
                } else {
                    await this.props.getFloorBasedOnBuilding(bId);
                    return this.props.recommendationsReducer.getFloorByBuilding?.floors || [];
                }
            }
            case "manufacturer":
                await this.props.getDropdownList("manufacturers", {
                    current_manufacturer: rowData?.asset?.manufacturer?.id,
                    client_id: this.props.projectReducer.getProjectByIdResponse?.client?.id,
                    ...(search ? { search } : {})
                });
                return this.props.assetDropdownList?.manufacturers || [];

            default:
                if (keyItem.startsWith("priority_element")) {
                    await this.props.getPriorityElementDropDownData(projectId);
                    const all = this.props.recommendationsReducer.priorityElementsDropDownResponse?.priority_elements;
                    const displayName = this.state.tableData.config[keyItem].label;
                    const found = all?.find(e => e.display_name === displayName);
                    await this.props.getCriticalityData({ project_id: projectId });
                    return found?.options || [];
                }
                return [];
        }
    };

    handleCellFocus = async (keyItem, rowIndex, rowId = "", isDropdownLineEdit = false, rowData, search = "") => {
        const projectId = this.getProjectId();

        if (isDropdownLineEdit) {
            const cacheKey =
                keyItem === "addition" || keyItem === "floor"
                    ? `${keyItem}::${rowData?.building?.id}`
                    : keyItem === "condition" || keyItem === "manufacturer"
                      ? `${keyItem}::${rowData?.recommendation_type}::${search}`
                      : keyItem;

            const loadingKey = `${rowIndex}::${keyItem}`;
            const cachedOptions = this.state.dropdownCache[cacheKey];
            const hasCachedOptions = Array.isArray(cachedOptions) ? cachedOptions.length > 0 : !!cachedOptions;

            if (hasCachedOptions) {
                this.setState({
                    lineEditDropdownValue: cachedOptions,
                    isDropdownLoading: null
                });
            } else {
                this.setState({ isDropdownLoading: loadingKey });
                const options = await this.getDropdownOptions(keyItem, projectId, rowData, search);
                this.setState(prev => ({
                    dropdownCache: {
                        ...prev.dropdownCache,
                        [cacheKey]: options
                    },
                    lineEditDropdownValue: options,
                    isDropdownLoading: null
                }));
            }
        }

        this.setState({
            isInputMode: { keyItem, rowIndex, rowId },
            lineEditSuggestionValue:
                keyItem === "description"
                    ? (
                          this.props.recommendationsReducer?.getRecommendationAcceptableVerbsByProject?.recommendation_acceptable_verbs || []
                      ).map(verb => verb?.name)
                    : []
        });
    };

    handleCellValueChange = (data, keyItem, rowIndex, filterIdKey, isDropdownLineEdit = false, name, fieldConfig) => {
        const value = data[keyItem];
        if (keyItem === "description") {
            const verbError = validateFirstWord(
                value,
                this.props.recommendationsReducer?.getRecommendationAcceptableVerbsByProject?.recommendation_acceptable_verbs || []
            );
            if (verbError) {
                showAlertUtil(verbError.replace(/^\*\s*/, ""), true);
                return;
            }
        }
        const isDynamicField = this.state?.tableData?.config[keyItem]?.isDynamicField;
        const isBooleanDynamicField = isDynamicField && fieldConfig?.type === "boolean";
        const normalizeRecommendationBooleanValue = booleanValue => {
            if (booleanValue === "" || booleanValue == null) return booleanValue;
            if (
                booleanValue === true ||
                booleanValue === "true" ||
                booleanValue === "yes" ||
                booleanValue === "Yes" ||
                booleanValue === 1 ||
                booleanValue === "1"
            )
                return "Yes";
            if (
                booleanValue === false ||
                booleanValue === "false" ||
                booleanValue === "no" ||
                booleanValue === "No" ||
                booleanValue === 0 ||
                booleanValue === "0"
            )
                return "No";
            return booleanValue;
        };
        const dynamicFieldValue = isBooleanDynamicField ? normalizeRecommendationBooleanValue(value) : value;
        const costCalculationKeys = ["cost_per_unit", "quantity", "occurrence"];
        const getCostNumber = fieldValue => {
            if (fieldValue === "" || fieldValue === null || fieldValue === undefined) return null;
            const sanitizedValue = typeof fieldValue === "string" ? fieldValue.replace(/,/g, "") : fieldValue;
            const parsedValue = parseFloat(sanitizedValue);
            return Number.isFinite(parsedValue) ? parsedValue : null;
        };
        const tableData = [...this.state.tableData.data];
        const row = { ...tableData[rowIndex] };
        const year = keyItem?.split("year_")?.[1] ? parseInt(keyItem?.split("year_")?.[1]) : null;

        if (year) {
            const updatedMaintenance = row.maintenance_years.map(m => (m.year === year ? { ...m, amount: parseInt(value) || 0 } : m));
            row.maintenance_years = updatedMaintenance;
        }

        const statusList = this.props?.recommendationStatusReducer?.getStatusDropdwnResponse?.recommendation_status_data;
        const selectedStatusValue = statusList?.find(status => status.id === value)?.name;

        const assetKeys = ["asset_name", "asset_tag", "serial_number", "model_number", "manufacturer", "capacity", "capacity_unit", "refrigerant"];
        if (assetKeys.includes(keyItem)) {
            row.asset = {
                ...(row.asset || {}),
                [keyItem]: keyItem === "manufacturer" && isDropdownLineEdit ? { id: value, name: name } || "-" : value || null
            };
        } else if (isDynamicField) {
            const isNumericDynamicField =
                [DYNAMIC_FIELD_TYPES.NUMBER, DYNAMIC_FIELD_TYPES.CURRENCY].includes(fieldConfig?.type);
            const storedDynamicValue =
                isBooleanDynamicField || fieldConfig?.type === "date"
                    ? dynamicFieldValue
                    : isNumericDynamicField
                      ? parseFloat(value) || value || null
                      : value ?? null;
            row.dynamic_fields = {
                ...(row.dynamic_fields || {}),
                [keyItem]: {
                    ...(row.dynamic_fields?.[keyItem] || {}),
                    value: storedDynamicValue
                }
            };
        } else if (keyItem === "notes") {
            const note_xml = convertToXML([value], 1);
            const removedAllTags = removeAllTags(value);
            row.notes = removedAllTags;
            row.note_xml = note_xml;
            row.note_html = value;
        } else {
            row[keyItem] = isDropdownLineEdit
                ? keyItem === "status"
                    ? selectedStatusValue || name
                    : name || "-"
                : parseFloat(value) || value || null;
        }
        const dynamicFields = Object.entries(data?.dynamic_fields || {}).map(([k, v]) => ({ [k]: v.value }));

        if (isDynamicField) {
            const existing = dynamicFields.find(df => df.hasOwnProperty(keyItem));
            if (existing) existing[keyItem] = dynamicFieldValue;
            else dynamicFields.push({ [keyItem]: dynamicFieldValue });
        }

        const params = { dynamic_fields: dynamicFields };

        if (!isDynamicField) {
            if (keyItem?.includes("year_")) {
                params.maintenance_years = row.maintenance_years;
            } else if (filterIdKey) {
                params[filterIdKey] = value;
            }

            if (keyItem?.startsWith("priority_element")) {
                const priorityData = this.props.recommendationsReducer.priorityElementsDropDownResponse?.priority_elements || [];
                const label = this.state?.tableData.config[keyItem].label;
                const priority = priorityData.find(e => e?.display_name === label);
                const priorityIndex = keyItem?.split("priority_element")?.[1];

                let selectedPriority = priorityData.find(p => p.id === priority?.id);
                let selectedOption = selectedPriority?.options?.find(o => o.id === value);

                let pelement = [...(data?.priority_elements || [])];
                pelement = pelement.map(i => {
                    if (i.index == priorityIndex) {
                        return selectedOption
                            ? {
                                  ...i,
                                  recommendation_priority_id: priority?.id,
                                  option_id: value,
                                  element: parseInt(selectedOption.value)
                              }
                            : {
                                  ...i,
                                  recommendation_priority_id: priority?.id,
                                  option_id: "",
                                  element: value ? parseInt(value) : ""
                              };
                    }
                    return i;
                });

                const total = pelement.reduce((sum, i) => sum + Number(i.element), 0);
                params["priority_elements"] = pelement;

                const critList = this.props.projectReducer.criticalityData?.criticalities || [];
                const useScore = this.props.projectReducer.getProjectByIdResponse?.miscellaneous?.criticality_score !== "year";
                const selectedCriticality = useScore
                    ? critList.find(c => total >= parseFloat(c.start_range) && total <= parseFloat(c.end_range))
                    : "";

                if (selectedCriticality) {
                    params["criticality_id"] = selectedCriticality.id;
                }
            }

            if (keyItem === "condition") {
                if (row.recommendation_type === RECOMMENDATION_TYPES.ASSET) {
                    params["client_asset_condition_id"] = value;
                } else {
                    params["asset_condition_id"] = value;
                }
            } else if (keyItem === "manufacturer") {
                params["manufacturer_id"] = value;
                params["manufacturer"] = name;
            } else if (keyItem === "capital_type_display_name") {
                const selectedCapital = this.props.recommendationsReducer.capitalTypeDropDownResponse?.capital_types?.find(c => c.id === value);
                if (!selectedCapital?.id) return;
                params["recommendation_capital_type_id"] = selectedCapital?.id || value;
                params["capital_type"] = selectedCapital?.name;
            } else if (keyItem === "initiative") {
                params["initiative_id"] = value;
            } else if (keyItem === "status") {
                params["recommendation_status_id"] = value;
                params[keyItem] = name;
            } else if (keyItem === "occurrence") {
                params[keyItem] = value;
            } else if (keyItem === "notes") {
                const note_xml = convertToXML([value], 1);
                const removedAllTags = removeAllTags(value);
                params.notes = removedAllTags;
                params.note_xml = note_xml;
                params.note_html = value;
            } else if (keyItem === "recommendation_space_type") {
                params["recommendation_space_type_id"] = value;
            } else {
                params[keyItem] = value;
            }

            if (costCalculationKeys.includes(keyItem)) {
                const normalizedCostValue = getCostNumber(value);
                row[keyItem] = normalizedCostValue !== null ? normalizedCostValue : value || null;
                const costPerUnit = getCostNumber(keyItem === "cost_per_unit" ? value : row.cost_per_unit);
                const quantity = getCostNumber(keyItem === "quantity" ? value : row.quantity);
                const occurrence = getCostNumber(keyItem === "occurrence" ? value : row.occurrence);
                const currentOptionsCost = getCostNumber(row.options_cost);
                const optionsCost = costPerUnit !== null && quantity !== null ? costPerUnit * quantity : currentOptionsCost || 0;
                const totalOpinionsOfCost = occurrence !== null ? optionsCost * occurrence : 0;

                row.options_cost = optionsCost;
                row.total_opinions_of_cost = totalOpinionsOfCost;
                params.options_cost = optionsCost;
                params.total_opinions_of_cost = totalOpinionsOfCost;
            }
        }

        tableData[rowIndex] = row;
        this.setState(
            {
                tableData: {
                    ...this.state.tableData,
                    data: tableData
                },
                summaryRowData: {
                    ...this.state.summaryRowData,
                    project_total: year ? "isLoading" : this.state.summaryRowData.project_total,
                    year_totals: {
                        ...this.state.summaryRowData.year_totals,
                        [year]: year ? "isLoading" : this.state.summaryRowData.year_totals?.[year]
                    }
                }
            },
            () => this.debouncedSaveTableValue(rowIndex, params)
        );
    };

    debouncedSaveTableValue = async (rowIndex, params) => {
        const { id, building, recommendation_type } = this.state.tableData?.data[rowIndex] || {};
        const basePayload = {
            building_id: building?.id,
            recommendation_type,
            ...params
        };

        await this.props.updateRecommendation(basePayload, id);
        const { success, error, message, is_duplicate_value } = this.props.recommendationsReducer.updateRecommendationResponse;

        if (!success || error) {
            if (is_duplicate_value) {
                const match = message ? message.match(/detected for '([^']+)'/) : null;
                const fieldName = match ? match[1] : "a field";
                this.setState({
                    showForceUpdateConfirmModal: true,
                    forceUpdateFieldName: fieldName,
                    confirmRowIndex: rowIndex,
                    confirmParams: basePayload
                });
            } else {
                this.setState({ alertMessage: message || error || "Failed to update Recommendation!" }, this.showAlert);
            }
        } else {
            if (params?.maintenance_years?.length || params.installed_year || params.service_life || params.asset_condition_id) {
                await this.props.syncProjectCost({ project_id: this.getProjectId(), recommendation_ids: [id] });
                this.refreshRecommendationsList(false, true);
            }
        }
    };

    getRecommendationFieldLabel = fieldKey => {
        if (!fieldKey || fieldKey === "a field") return fieldKey;
        const customFields = this.props.recommendationsReducer?.dynamicFields?.recommendation_custom_fields || {};
        const field = Object.values(customFields)
            .flat()
            .find(f => f.field_name === fieldKey);
        return field?.label || fieldKey;
    };

    renderForceUpdateConfirmationModal = () => {
        const { showForceUpdateConfirmModal, forceUpdateFieldName } = this.state;
        if (!showForceUpdateConfirmModal) return null;
        const fieldLabel = this.getRecommendationFieldLabel(forceUpdateFieldName);

        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`The value you entered in ${fieldLabel} already exists in the sort-order hierarchy. Do you want to force update and push the rest?`}
                        type="cancel"
                        message="Forcing this update will shift other items down to make room. This action cannot be undone. Continue?"
                        onNo={this.onConfirmNo}
                        onYes={this.onConfirmYes}
                    />
                }
                onCancel={this.onConfirmNo}
            />
        );
    };

    onConfirmYes = async () => {
        const { confirmRowIndex, confirmParams, confirmAction, confirmRecId, confirmSelectedImage } = this.state;

        this.setState({
            showForceUpdateConfirmModal: false,
            confirmParams: null,
            confirmRowIndex: null,
            confirmAction: null,
            confirmRecId: null,
            confirmSelectedImage: null,
            isLoading: true
        });

        try {
            if (confirmAction === "add") {
                await this.handleAddRecommendations({ ...confirmParams, force_insert: true });
            } else if (confirmAction === "edit") {
                await this.handleUpdateRecommendations({ ...confirmParams, force_insert: true }, confirmSelectedImage, confirmRecId);
            } else {
                const { id } = this.state.tableData.data[confirmRowIndex];

                await this.props.updateRecommendation({ ...confirmParams, force_insert: true }, id);
                const { success, error, message } = this.props.recommendationsReducer.updateRecommendationResponse;

                if (!success || error) {
                    this.setState({ alertMessage: message || "Failed to overwrite!" }, this.showAlert);
                } else {
                    this.refreshRecommendationsList(false, true);
                }
            }
        } finally {
            this.setState({ isLoading: false });
        }
    };

    onConfirmNo = () => {
        const { confirmAction } = this.state;
        this.setState({
            showForceUpdateConfirmModal: false,
            confirmParams: null,
            confirmRowIndex: null,
            confirmAction: null,
            confirmRecId: null,
            confirmSelectedImage: null
        });
        if (!confirmAction) {
            this.refreshRecommendationsList(false, true);
        }
    };

    handleColumnPin = async keyItem => {
        const { config, keys } = this.state.tableData;
        this.setState({
            isLoading: true
        });
        await new Promise(resolve => setTimeout(resolve, 1));
        const { left, ...remainingStyles } = config[keyItem]?.style || {};

        const updatedConfig = {
            ...config,
            [keyItem]: {
                ...config[keyItem],
                pinned: !config[keyItem]?.pinned,
                style: config[keyItem]?.pinned
                ? remainingStyles
                : {
                      ...remainingStyles,
                      left: config[keyItem]?.style?.left || "auto"
                  }
            }
        };

        const pinnedColumns = keys.filter(key => updatedConfig[key]?.pinned);
        const columnLeftValues = getPinnedColumnLeftPositions(pinnedColumns, this.pinnedColumnsRef);

        pinnedColumns.forEach(key => {
            updatedConfig[key] = {
                ...updatedConfig[key],
                style: {
                    ...config[key]?.style,
                    left: columnLeftValues[key] || "auto"
                }
            };
        });
        this.setState({
            tableData: {
                ...this.state.tableData,
                config: updatedConfig
            },
            isLoading: false
        });
        if (!this.props?.isSmartChartView) {
            this.saveUserTableConfig(updatedConfig);
        }
        this.updateEntityParams(updatedConfig);
    };

    updateColumnWidthInConfig = (columnKey, style) => {
        const { keys, config } = this.state.tableData;

        const pinnedColumns = keys.filter(key => config[key]?.isVisible && config[key]?.pinned);
        const columnLeftValues = getPinnedColumnLeftPositions(pinnedColumns, this.pinnedColumnsRef);

        pinnedColumns.forEach(key => {
            config[key] = {
                ...config[key],
                style: {
                    ...config[key]?.style,
                    left: columnLeftValues[key] || "auto"
                }
            };
        });

        const updatedConfig = {
            ...config,
            [columnKey]: {
                ...config[columnKey],
                style: {
                    ...config[columnKey]?.style,
                    ...style
                }
            }
        };
        this.setState({
            tableData: {
                ...this.state.tableData,
                config: updatedConfig
            }
        });
        if (!this.props?.isSmartChartView) {
            this.saveUserTableConfig(updatedConfig);
        }
        this.updateEntityParams(updatedConfig);
    };

    unPinAllColumn = async () => {
        const { config, keys } = this.state.tableData;
        const updatedConfig = { ...config };
        keys.forEach(key => {
            updatedConfig[key] = {
                ...updatedConfig[key],
                pinned: false,
                style: {
                    ...config[key]?.style,
                    left: "auto"
                }
            };
        });
        await this.setState({
            tableData: {
                ...this.state.tableData,
                config: updatedConfig
            }
        });
    };

    setDynamicJoinParam = async () => {
        const { params, tableData } = this.state;
        let additionalJoins = ["building"];

        if (tableData.keys.some(key => key.includes("water_band") && tableData?.config?.[key]?.isVisible)) {
            additionalJoins.push("water_band");
        }
        if (tableData.keys.some(key => key.includes("energy_band") && tableData?.config?.[key]?.isVisible)) {
            additionalJoins.push("energy_band");
        }
        if (tableData.keys.some(key => key.includes("priority_element") && tableData?.config?.[key]?.isVisible)) {
            additionalJoins.push("priority_elements");
        }
        if (tableData.keys.some(key => key.includes("year_") && tableData?.config?.[key]?.isVisible)) {
            additionalJoins.push("maintenance_years");
        }
        const dynamicFields = tableData.keys
            .filter(key => tableData?.config?.[key]?.dynamicField && tableData?.config?.[key]?.isVisible)
            .map(key => tableData?.config?.[key]?.dynamicFieldKey || key);

        let newJoins = [...new Set([...dynamicFields, ...additionalJoins])].join(",");
        await this.setState({
            params: {
                ...params,
                dynamic_joins: newJoins
            }
        });
    };

    setTableDataConfigBasedOnProject = async () => {
        const {
            location: { search },
            projectReducer,
            recommendationsReducer,
            isCapitalRequest,
            match
        } = this.props;

        const query = qs.parse(search);
        const tableSettings =
            (
                await getTableConfig({
                    user_id: localStorage.getItem("userId"),
                    project_id: this.props.projectIdDashboard || match.params.id,
                    client_id: projectReducer?.getProjectByIdResponse?.client?.id,
                    table_type: isCapitalRequest || query.is_cr === "true" ? entities.CAPITAL_REQUESTS : entities.RECOMMENDATIONS
                })
            )?.data?.table_settings || null;

        const project = projectReducer.getProjectByIdResponse || {};
        const capitalRequestLabel = getCapitalRequestLabel(project.miscellaneous);
        const {
            config: computedConfig,
            keys: computedKeys,
            paneViewEnabled
        } = computeTableConfig({
            defaultConfig: recommendationsTableData.config,
            defaultKeys: recommendationsTableData.keys,
            tableSettings,
            isStaticCR: isCapitalRequest || match.params.tab === "linked-cr-recommendations",
            capitalRequestLabel,
            dynamicCR: isCapitalRequest,
            recommendationCustomFields: recommendationsReducer?.dynamicFields?.recommendation_custom_fields || {},
            priorityElements: recommendationsReducer.priorityElementsDropDownResponse?.priority_elements || [],
            displayUnit: project.display_unit,
            showEnergyBand: !!project.show_energy_band,
            energyFields: energy_fields,
            showWaterBand: !!project.show_water_band,
            waterFields: water_fields,
            entity: entities.RECOMMENDATIONS
        });

        const savedFilter = !isCapitalRequest && Array.isArray(this.state.appliedTableView) && this.state.appliedTableView[0]?.filter;

        const finalKeys = savedFilter?.keys && savedFilter.keys.length > 0 ? savedFilter.keys : computedKeys;
        let finalConfig = savedFilter?.config && Object.keys(savedFilter.config).length > 0 ? savedFilter.config : computedConfig;

        // Keep runtime dropdown metadata fresh while preserving saved view display settings.
        if (savedFilter?.config && Object.keys(savedFilter.config).length > 0) {
            finalConfig = Object.fromEntries(
                Object.entries(finalConfig).map(([key, col]) => {
                    const computedColumn = computedConfig[key];
                    if (!computedColumn) return [key, col];

                    const mergedColumn = computedColumn?.isDynamicField
                        ? {
                              ...col,
                              label: computedColumn.label,
                              type: computedColumn.type,
                              hasLineEdit: computedColumn.hasLineEdit,
                              isDropdownLineEdit: computedColumn.isDropdownLineEdit,
                              isDynamicField: computedColumn.isDynamicField,
                              isMemoField: computedColumn.isMemoField,
                              rules: computedColumn.rules,
                              band: computedColumn.band,
                              options: computedColumn.options,
                              hasCommonSearch: computedColumn.hasCommonSearch,
                              getListTable: computedColumn.getListTable,
                              commonSearchKey: computedColumn.commonSearchKey,
                              commonSearchObjectKey: computedColumn.commonSearchObjectKey
                          }
                        : { ...col, label: computedColumn.label };

                    return [key, mergedColumn];
                })
            );
        }

        if (finalConfig.infrastructure_request) {
            finalConfig = {
                ...finalConfig,
                infrastructure_request: {
                    ...finalConfig.infrastructure_request,
                    label: capitalRequestLabel
                }
            };
        }

        if (finalConfig.source) {
            const misc = project.miscellaneous;
            finalConfig = {
                ...finalConfig,
                source: {
                    ...finalConfig.source,
                    accessor: rowData => formatCapitalRequestSourceValue(rowData?.source, misc),
                    miscellaneous: misc
                }
            };
        }

        this.masterTableConfig = computedConfig;

        await this.setState({
            tableData: {
                ...this.state.tableData,
                keys: finalKeys,
                config: finalConfig
            },
            paneViewEnabled
        });
        await this.updateEntityParams();
    };

    createAssetRecommendation = async () => {
        this.setState({ isLoading: true });
        await this.props.createAssetRecommendationAction({ asset_id: this.props.match.params.id });
        const {
            success,
            recommendation_id,
            message,
            error = "Oops..! Recommendation creation failed"
        } = this.props.recommendationsReducer.createAssetRecommendationResponse || {};
        this.setState({ isLoading: false });
        if (success) {
            await this.props.syncProjectCost({ recommendation_ids: [recommendation_id] });
            this.refreshRecommendationsList();
            this.setState({ alertMessage: message }, () => this.showAlert());
        } else {
            this.setState({ alertMessage: message || error }, () => this.showAlert());
        }
    };

    renderFiltersPopup = () => {
        const {
            showFiltersPopup,
            myFilters,
            summaryRowData: { year_totals = {} },
            dashboardFilterParams
        } = this.state;
        const {
            match: {
                params: { section, tab }
            }
        } = this.props;
        if (!showFiltersPopup) return null;
        const yearValues = Object.keys(year_totals);
        let filterCount = 0;
        let dashboardFilterCount = getAppliedFiltersCount(dashboardFilterParams);
        let myFiltersCount = getAppliedFiltersCount(myFilters);
        filterCount += dashboardFilterCount + myFiltersCount;
        return (
            <Portal
                body={
                    <MyFilters
                        dashboardFilterParams={myFilters}
                        yearValues={yearValues}
                        onCancel={() => this.toggleFiltersPopup()}
                        submitMasterFilter={this.submitMasterFilter}
                        getListParams={{ ...this.getListParams() }}
                        isRecommendationTable
                        openAppliedFiltersPopup={() => this.setState({ showAppliedFilters: true })}
                        filterCount={filterCount}
                        queries={this.state.queries}
                        saveFilterSubmit={this.saveFilterSubmit}
                        isCR={(section === "recommendationsinfo" && tab === "linked-cr-recommendations") || this.props.isCapitalRequest}
                    />
                }
                onCancel={() => this.toggleFiltersPopup()}
            />
        );
    };

    saveFilterSubmit = async filterData => {
        await this.props.saveFilterQuery(filterData);
        if (this.props?.dashboardReducer?.saveQueryResponse?.success) {
            this.setState({ alertMessage: "Filter saved successfully" }, () => this.showLongAlert());
        }
    };

    renderAppliedFilters = () => {
        const { showAppliedFilters, myFilters, params } = this.state;
        const {
            match: {
                params: { section, tab }
            },
            isCapitalRequest
        } = this.props;
        if (!showAppliedFilters) return null;
        return (
            <Portal
                body={
                    <AppliedFilters
                        myFilters={myFilters}
                        filterValues={params}
                        tableConfig={this.state.tableData?.config}
                        openFiltersPopup={() => this.setState({ showFiltersPopup: true })}
                        showFiltersIcon={!this.state.showFiltersPopup}
                        onCancel={() => this.setState({ showAppliedFilters: false })}
                        source={"recommendation"}
                        extraFilterTags={this.gaugeFilterTags}
                        extraFilterTagsHeading="From Geo Hierarchy"
                        extraFilterTagsAsSection={true}
                        localQueries={this.state.queries}
                        isCR={(section === "recommendationsinfo" && tab === "linked-cr-recommendations") || isCapitalRequest}
                    />
                }
                onCancel={() => this.setState({ showAppliedFilters: false })}
            />
        );
    };

    toggleAppliedFiltersPopup = () => {
        this.setState({ showAppliedFilters: !this.state.showAppliedFilters });
    };

    getFindFilterKey = field => {
        if (!field) return null;
        if (field.startsWith("dynamic_fields.")) return field;

        const columnConfig = this.state.tableData?.config?.[field] || {};
        return columnConfig?.searchKey || field;
    };

    getFindFilterKeys = fields => (fields ?? []).map(field => this.getFindFilterKey(field)).filter(Boolean);

    applyFindParamsToRecommendationParams = params => {
        const findParams = params?.findParams;
        const { find, replace_fields = [] } = findParams || {};
        const nextParams = { ...params };
        delete nextParams.findParams;

        if (!find || !replace_fields?.length) return nextParams;

        let filterKey = "contains";
        if (findParams?.match_case && findParams?.match_entire_cell) {
            filterKey = "string_equals";
        } else if (findParams?.match_case) {
            filterKey = "match_case";
        } else if (findParams?.match_entire_cell) {
            filterKey = "match_entire_cell";
        }

        this.getFindFilterKeys(replace_fields).forEach(key => {
            nextParams.filters = {
                ...(nextParams.filters ?? {}),
                [key]: { filters: [filterKey], key: find }
            };
        });

        const searchOperator = findParams?.search_operator === "AND" ? "AND" : "OR";
        return {
            ...nextParams,
            search_operator: searchOperator
        };
    };

    getSearchAndReplaceParams = (data, isCount = false) => {
        const baseParams = this.getListParams(null, false);
        const replaceFields = this.getFindFilterKeys(data?.replace_fields);
        const selectedIds = (this.state.selectedRecomIds ?? []).map(elem => elem?.id ?? elem).filter(Boolean);
        const params = {
            ...baseParams,
            ...data,
            replace_fields: replaceFields,
            ...(selectedIds?.length ? { recommendation_ids: selectedIds } : {}),
            ...(isCount ? { check_count: true } : {})
        };

        return this.applyFindParamsToRecommendationParams({
            ...params,
            findParams: {
                find: data?.search,
                replace_fields: replaceFields,
                match_case: data?.match_case,
                match_entire_cell: data?.match_entire_cell,
                search_operator: data?.search_operator
            }
        });
    };

    toggleSearchAndReplaceModal = () => {
        this.setState({ showSearchAndReplaceModal: !this.state.showSearchAndReplaceModal });
    };

    getListBackgroundTaskId = () => this.props.recommendationsReducer?.getAllRecommendationsResponse?.task?.id ?? null;

    getActiveBackgroundTaskId = () => this.state.searchReplaceTaskIds?.[0] ?? this.getListBackgroundTaskId();

    trackBackgroundTaskFromList = () => {
        const listTaskId = this.getListBackgroundTaskId();
        if (!listTaskId || this.state.searchReplaceTaskIds?.length || listTaskId === this.trackedBackgroundTaskId) return;
        this.trackedBackgroundTaskId = listTaskId;
        this.props.getRecomGroupEditProgress(listTaskId);
    };

    handleBackgroundTaskProgressResponse = () => {
        const backgroundTaskProgressResponse = this.props.recommendationsReducer?.getGroupEditProgressResponse;
        const { searchReplaceTaskIds, pendingFindParams } = this.state;
        const searchReplaceTaskId = searchReplaceTaskIds?.[0] ?? null;

        const { id: progressTaskId, status, result } = backgroundTaskProgressResponse?.data ?? {};
        const isTaskDone = [3, 4].includes(status) || Number(result?.data_update_percent ?? 0) >= 100;
        if (searchReplaceTaskId && progressTaskId === searchReplaceTaskId && isTaskDone) {
            if (status === 4) {
                this.setState({ alertMessage: "Search and replace failed for some of the recommendations" }, () => this.showAlert());
            }
            const remainingTaskIds = searchReplaceTaskIds.slice(1);
            this.setState({ searchReplaceTaskIds: remainingTaskIds }, () => {
                if (remainingTaskIds?.length) this.props.getRecomGroupEditProgress(remainingTaskIds[0]);
                else this.applyFindParamsAfterReplace(pendingFindParams?.findParams ?? null);
            });
        }

        clearInterval(this.backgroundTaskProgressInterval);
        this.backgroundTaskProgressInterval = null;
        if (Number(status) === 4) return;
        this.backgroundTaskProgressInterval = setInterval(() => {
            const progressResponse = this.props.recommendationsReducer?.getGroupEditProgressResponse;
            const progress = progressResponse?.data?.result?.data_update_percent ?? 0;
            const taskId = this.getActiveBackgroundTaskId();
            if (Number(progress) < 100 && progressResponse?.success && Number(progressResponse?.data?.status) !== 4) {
                if (taskId) this.props.getRecomGroupEditProgress(taskId);
            } else {
                clearInterval(this.backgroundTaskProgressInterval);
                this.backgroundTaskProgressInterval = null;
            }
        }, 10000);
    };

    applyFindParamsAfterReplace = nextFindParams => {
        const { params } = this.state;
        if (params?.findParams || nextFindParams) {
            this.setState(
                { pendingFindParams: null, selectedRecomIds: [], params: { ...params, recommendation_ids: null, findParams: nextFindParams } },
                async () => {
                    await this.updateEntityParams();
                    this.refreshRecommendationsList();
                }
            );
        } else {
            this.setState({ pendingFindParams: null, selectedRecomIds: [] }, async () => {
                await this.updateEntityParams();
                this.refreshRecommendationsList();
            });
        }
    };

    renderProgressBarModal = () => {
        const { progressBarModal } = this.state;
        if (!progressBarModal) return null;
        const backgroundTaskProgressResponse = this.props.recommendationsReducer?.getGroupEditProgressResponse;
        const activeTaskId = this.getActiveBackgroundTaskId();
        return (
            <Portal
                body={
                    <ProgressBarModal
                        onClose={() => this.setState({ progressBarModal: false })}
                        data={
                            activeTaskId
                                ? backgroundTaskProgressResponse?.data?.id === activeTaskId
                                    ? backgroundTaskProgressResponse
                                    : {}
                                : backgroundTaskProgressResponse
                        }
                        refresh={() => {
                            if (activeTaskId) this.props.getRecomGroupEditProgress(activeTaskId);
                        }}
                        refreshTableData={() => {
                            const taskType = backgroundTaskProgressResponse?.data?.type ?? backgroundTaskProgressResponse?.data?.task_type;
                            if (taskType !== "search_and_replace") this.refreshRecommendationsList();
                        }}
                        taskId={activeTaskId}
                    />
                }
                onCancel={() => this.setState({ progressBarModal: false })}
            />
        );
    };

    renderSearchAndReplaceModal = () => {
        const { showSearchAndReplaceModal, params, tableData } = this.state;
        const {
            searchAndReplaceRecommendationLoading,
            findRecommendationBeforeReplacingLoading,
            findRecommendationBeforeReplacingResponse,
            searchAndReplaceRecommendationResponse
        } = this.props.recommendationsReducer;

        if (!showSearchAndReplaceModal) return null;

        const unsupportedTypes = [
            DYNAMIC_FIELD_TYPES.SELECT,
            DYNAMIC_FIELD_TYPES.BOOLEAN,
            DYNAMIC_FIELD_TYPES.NUMBER,
            DYNAMIC_FIELD_TYPES.DATE,
            DYNAMIC_FIELD_TYPES.DATE_TIME,
            DYNAMIC_FIELD_TYPES.COLOR,
            DYNAMIC_FIELD_TYPES.CURRENCY
        ];
        const formattedFields = (tableData?.keys ?? [])
            ?.filter(field => {
                const fieldConfig = tableData?.config?.[field] || {};
                return (
                    fieldConfig?.label &&
                    !unsupportedTypes.includes(fieldConfig?.type) &&
                    !fieldConfig?.isReadOnly &&
                    !fieldConfig?.rules?.read_only &&
                    !SEARCH_AND_REPLACE_REMOVED_FIELDS.includes(field) &&
                    !fieldConfig?.isYear &&
                    !fieldConfig?.isPriorityElement
                );
            })
            ?.map(key => {
                const config = tableData?.config?.[key] || {};
                const value = this.getFindFilterKey(config?.isDynamicField ? `dynamic_fields.${key}` : key);
                return {
                    label: config?.label,
                    value
                };
            })
            .sort((a, b) => a.label.localeCompare(b.label));

        const onSave = (data, isDelete) => {
            const tempParams = this.getSearchAndReplaceParams(data);
            const nextFindParams = isDelete
                ? null
                : {
                      ...(params?.findParams ?? {}),
                      find: data?.replace,
                      replace_fields: this.getFindFilterKeys(data?.replace_fields),
                      search_operator: data?.search_operator,
                      findType: "review"
                  };
            this.props.searchAndReplaceRecommendation(tempParams, response => {
                const taskIds = [response?.task_id] ?? [];
                if (taskIds?.length) {
                    this.setState({ pendingFindParams: { findParams: nextFindParams }, searchReplaceTaskIds: taskIds }, () => {
                        this.props.getRecomGroupEditProgress(taskIds[0]);
                    });
                } else this.applyFindParamsAfterReplace(nextFindParams);
            });
        };

        const findBeforeReplace = (data, cb) => {
            const tempParams = this.getSearchAndReplaceParams(data, true);
            this.props.findRecommendationsBeforeReplace(tempParams, cb);
        };
        const {
            location: { search },
        } = this.props;

        const query = qs.parse(search);
        const isCapitalRequest = this.props?.isCapitalRequest || query?.is_cr === "true";
        const crLabel = this.getCrLabel();

        return (
            <Portal
                body={
                    <SearchAndReplace
                        onCancel={() => this.setState({ showSearchAndReplaceModal: false })}
                        tableFields={formattedFields}
                        handleSave={onSave}
                        loading={searchAndReplaceRecommendationLoading || findRecommendationBeforeReplacingLoading}
                        tableSearch={
                            params?.findParams
                                ? { ...params.findParams, replace_fields: this.getFindFilterKeys(params.findParams.replace_fields) }
                                : null
                        }
                        setFindParams={updater =>
                            this.setState(
                                prevState => ({
                                    params: { ...(typeof updater === "function" ? updater(prevState.params) : updater), recommendation_ids: null },
                                    selectedRecomIds: []
                                }),
                                async () => {
                                    await this.updateEntityParams();
                                    this.refreshRecommendationsList();
                                }
                            )
                        }
                        findBeforeReplace={findBeforeReplace}
                        replaceCountResponse={findRecommendationBeforeReplacingResponse}
                        replaceSuccessResponse={searchAndReplaceRecommendationResponse}
                        setAlertMessage={alertMessage => this.setState({ alertMessage }, () => this.showAlert())}
                        entityLabel={isCapitalRequest ? crLabel : "Recommendation"}
                        entityPluralLabel={isCapitalRequest ? crLabel : "Recommendations"}
                        isBgTask={true}
                    />
                }
                onCancel={() => this.setState({ showSearchAndReplaceModal: false })}
            />
        );
    };

    applyCurrentFindParamsToRecommendationParams = params =>
        this.applyFindParamsToRecommendationParams({
            ...(params || {}),
            findParams: this.state.params?.findParams
        });

    getListParams = (source, includeFindParams = true) => {
        const { dashboardFilterParams = {}, myFilters, queries } = this.state;
        const { limit, offset, order, ...rest } = this.state.params;

        const result = AppliedQueryFilters(myFilters, queries);
        let clonedQueryFilters = _.cloneDeep(result);
        let params = _.merge({}, rest, dashboardFilterParams, clonedQueryFilters);
        if (params?.list) {
            Object.keys(params.list).forEach(key => {
                if (key.startsWith("dynamic_fields.")) {
                    let newKey = `recommendation_dynamic_field__${key.split("dynamic_fields.")[1]}`;
                    params[newKey] = params.list[key];
                    delete params.list[key];
                }
            });
        }
        const {
            match: {
                params: { section, tab }
            },
            isSurveyView = false
        } = this.props;

        const projectId =
            this.props.projectIdDashboard ||
            this.props?.projectIdForSmartChart ||
            (this.isCrLinkedTab() ? "" : this.props.match.params.id);
        if (section === "initiativeInfo" && this.state.params?.view !== "assigned") {
            const {
                location: { search }
            } = this.props;
            const query = qs.parse(search);
            params.project_id = query.pid;
        } else if (section !== "imageInfo" && section !== "initiativeInfo" && section !== "assetInfo") {
            params.project_id = projectId;
        }
        if (section === "initiativeInfo" && this.state.params?.view === "assigned") {
            params.initiative_id = this.props.match.params.id || null;
        }
        if (this.props?.isCrLinkPicker) {
            const { smartChartFilters = {} } = this.props;
            params = { ...params, ...smartChartFilters };
        } else if (section === "buildinginfo") {
            params.building_id = this.props.match.params.id;
        } else if (section === "siteinfo") {
            params.site_id = this.props.match.params.id;
        } else if (section === "regioninfo") {
            params.region_id = this.props.match.params.id;
        } else if (section === "imageInfo") {
            params.image_id = this.props.match.params.id;
        } else if (section === "assetInfo") {
            params.asset_id = this.props.match.params.id;
        } else if (section === "recommendationsinfo" && tab === "linked-recommendations") {
            params.capital_request_id = this.props.match.params.id;
        } else if (section === "recommendationsinfo" && tab === "linked-cr-recommendations") {
            params.recommendation_id = this.props.match.params.id;
            params.is_cr = true;
        } else if (this.props?.isCapitalRequest) {
            params.is_cr = true;
        } else if (tab === "mr-recommendations") {
            params.survey_recommendation_id = this.props.match.params.mrId;
        } else if (this.props?.isSmartChartView || isSurveyView) {
            const { smartChartFilters = {} } = this.props;
            params = { ...params, ...smartChartFilters };
            if (this?.props?.surveyFilters) {
                const surveyFilters = this.props.surveyFilters;
                params = {
                    ...params,
                    ...(surveyFilters?.region?.length && { region_ids: surveyFilters.region }),
                    ...(surveyFilters?.site?.length && { site_ids: surveyFilters.site }),
                    ...(surveyFilters?.building?.length && { building_ids: surveyFilters.building }),
                    ...(surveyFilters?.floor?.length && { floor_ids: surveyFilters.floor }),
                    ...(surveyFilters?.addition?.length && { addition_ids: surveyFilters.addition }),
                    ...(this.props?.projectId && { project_id: this.props?.projectId })
                };
            }
        } else if (this.props.match.params.subTab === "assigned-recommendations" && this.props?.isAssignRecomView) {
            const {
                location: { search }
            } = this.props;
            const query = qs.parse(search);
            params = { ...params, project_id: query?.pid, survey_recommendation_project_id: this.props?.survey_recommendation_project_id };
        }
        delete params.findParams;
        return includeFindParams ? this.applyCurrentFindParamsToRecommendationParams(params) : params;
    };

    submitMasterFilter = filterData => {
        this.setState({ myFilters: filterData }, async () => this.refreshRecommendationsList());
    };

    toggleFiltersPopup = () => {
        this.setState({ showFiltersPopup: !this.state.showFiltersPopup });
    };

    toggleShiftCspModal = () => {
        this.setState({ showShiftCspModal: !this.state.showShiftCspModal });
    };

    renderShiftCspModal = () => {
        const { showShiftCspModal, selectedRecomIds } = this.state;
        if (!showShiftCspModal) return null;
        const recommendationIds = selectedRecomIds.map(elem => elem.id);
        return (
            <Portal
                body={
                    <ShiftCspModal
                        onShiftCspYear={this.onShiftCspYear}
                        maintenance_years={this.state.maintenance_years}
                        recommendationIds={recommendationIds}
                        onCancel={this.toggleShiftCspModal}
                    />
                }
                onCancel={this.toggleShiftCspModal}
            />
        );
    };

    onShiftCspYear = async data => {
        this.setState({ isLoading: true });
        const query = qs.parse(this.props.location.search);
        const { selectedRecomIds } = this.state;
        const project_id = query.pid || this.props.match.params.id;
        await this.props.shiftCspYears(
            {
                ...data,
                recommendation_ids: selectedRecomIds.map(elem => elem.id)
            },
            project_id
        );
        const { message, success, error } = this.props.recommendationsReducer?.shiftCspYearResponse || {};
        if (!success) {
            await this.setState({
                alertMessage: message || error
            });
            this.showLongAlert();
        } else {
            this.toggleShiftCspModal();
            await this.props.syncProjectCost({ project_id: this.getProjectId(), recommendation_ids: selectedRecomIds.map(elem => elem.id) });
            await this.refreshRecommendationsList();
            this.setState(
                {
                    alertMessage: message
                },
                () => this.showLongAlert()
            );
        }
        this.setState({ isLoading: false });
    };

    buildCrLinkDefaultList = () => {
        const { recommendationDetails } = this.props;
        const list = {};
        if (recommendationDetails?.region?.name) list["recommendations.region_name"] = [recommendationDetails.region.name];
        if (recommendationDetails?.site?.name) list["recommendations.site_name"] = [recommendationDetails.site.name];
        if (recommendationDetails?.building?.name) list["buildings.name"] = [recommendationDetails.building.name];
        if (recommendationDetails?.trade?.name) list["recommendations.trade_name"] = [recommendationDetails.trade.name];
        return list;
    };

    toggleLinkRecommendationModal = () => {
        this.setState({
            showLinkRecommendationModal: !this.state.showLinkRecommendationModal,
            crLinkSelectedRecoms: []
        });
    };

    handleCrLinkSelection = selectedIds => {
        this.setState({ crLinkSelectedRecoms: selectedIds || [] });
    };

    onLinkRecommendationsToCr = async () => {
        const recommendation_ids = this.state.crLinkSelectedRecoms;
        if (!recommendation_ids.length) return;
        this.setState({ linkRecommendationLoader: true });
        const response = await this.props.linkRecommendationsToCapitalRequest({
            capital_request_id: this.props.match.params.id,
            recommendation_ids
        });
        const { success, message, errors, data } = response || {};
        this.setState({ linkRecommendationLoader: false });
        if (!success) {
            this.setState({ alertMessage: message || errors?.join(", ") || ERROR_COPY.GENERIC }, () => this.showLongAlert());
            return;
        }
        const { linked = [], skipped = [] } = data || {};
        const skippedNote = skipped.length ? ` ${skipped.map(item => `${item.code}: ${item.reason}`).join("; ")}` : "";
        this.setState(
            {
                showLinkRecommendationModal: false,
                crLinkSelectedRecoms: [],
                alertMessage: `${message || `${linked.length} recommendation(s) linked.`}${skippedNote}`
            },
            () => this.showLongAlert()
        );
        await this.refreshRecommendationsList();
    };

    unlinkSelectedRecommendations = () => {
        if (!this.state.selectedRecomIds.length) return;
        this.setState({ showCrUnlinkConfirmModal: true });
    };

    onUnlinkRecommendationsFromCr = async () => {
        // Server decides: the client only holds one page, so it cannot tell linked from converted.
        const recommendation_ids = this.state.selectedRecomIds.map(elem => elem.id);
        this.setState({ showCrUnlinkConfirmModal: false });
        if (!recommendation_ids.length) return;
        this.setState({ isLoading: true });
        const response = await this.props.unlinkRecommendationsFromCapitalRequest({
            capital_request_id: this.props.match.params.id,
            recommendation_ids
        });
        const { success, message, errors, data } = response || {};
        this.setState({ isLoading: false });
        if (!success) {
            this.setState({ alertMessage: message || errors?.join(", ") || ERROR_COPY.GENERIC }, () => this.showLongAlert());
            return;
        }
        const { unlinked = [], skipped = [] } = data || {};
        const skippedNote = skipped.length ? ` ${skipped.map(item => `${item.code}: ${item.reason}`).join("; ")}` : "";
        await this.setState({
            selectedRecomIds: [],
            alertMessage: `${message || `${unlinked.length} recommendation(s) unlinked.`}${skippedNote}`
        });
        // Must persist before the refresh, which re-reads the selection from entityParams.
        await this.updateEntityParams();
        this.showLongAlert();
        await this.refreshRecommendationsList();
    };

    renderCrUnlinkConfirmModal = () => {
        if (!this.state.showCrUnlinkConfirmModal) return null;
        const count = this.state.selectedRecomIds.length;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={`Do you want to unlink ${count} recommendation(s) from this ${this.getCrLabel()}?`}
                        message={"Recommendations created by converting this record cannot be unlinked and will be skipped."}
                        onNo={() => this.setState({ showCrUnlinkConfirmModal: false })}
                        onYes={this.onUnlinkRecommendationsFromCr}
                    />
                }
                onCancel={() => this.setState({ showCrUnlinkConfirmModal: false })}
            />
        );
    };

    renderLinkRecommendationModal = () => {
        const { showLinkRecommendationModal, crLinkSelectedRecoms, linkRecommendationLoader } = this.state;
        if (!showLinkRecommendationModal) return null;
        return (
            <Portal
                body={
                    <LinkRecommendationToCRModal
                        onCancel={this.toggleLinkRecommendationModal}
                        onLink={this.onLinkRecommendationsToCr}
                        linkLoader={linkRecommendationLoader}
                        selectedCount={crLinkSelectedRecoms.length}
                        handleLinkSelection={this.handleCrLinkSelection}
                        defaultFilters={{ is_cr: false }}
                        defaultList={this.buildCrLinkDefaultList()}
                        projectId={this.props.recommendationDetails?.project?.id || this.props?.projectIdForSmartChart || ""}
                    />
                }
                onCancel={this.toggleLinkRecommendationModal}
            />
        );
    };

    showLongAlert = () => showAlertUtil(this.state.alertMessage, true);

    createRecommendationFromCr = CrDetailPrope => {
        if (this.tableRef?.current?.scrollLeft) {
            this.props.setRecommendationScrollPosition(this.tableRef?.current?.scrollLeft);
        }
        this.setState({
            selectedRecommendations: null
        });
        const { history, recommendationDetails } = this.props;
        const { id, project, client } = recommendationDetails || CrDetailPrope || {};
        if (id && project?.id && client?.id) {
            sessionStorage.setItem("currentRecommendationData", JSON.stringify(recommendationDetails || CrDetailPrope));
            let newParams = {
                p_id: project?.id || "",
                c_id: client?.id || "",
                capital_request_id: id,
                type: RECOMMENDATION_SOURCE_TYPES.CAPITAL_REQUEST
            };

            const newPath = `/recommendations/add?${qs.stringify(newParams)}`;
            addToBreadCrumpData({
                key: "add",
                name: "Converting to Recommendation",
                path: newPath
            });
            history.push(newPath);
        } else {
            this.setState({ alertMessage: ERROR_COPY.GENERIC }, () => {
                this.showAlert();
            });
        }
    };
    handleNormalRecomGrouping = async (is_excel, exportParam) => {
        this.setState({ isNormalRecomGroupingLoading: true });
        const {
            match: {
                params: { id, section, tab }
            },
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        const projectId =
            this.props.projectIdDashboard ||
            this.props?.projectIdForSmartChart ||
            query.pid ||
            this.props?.projectIdMobile ||
            this.props.match.params.id ||
            "";

        let normalRecomGroupingData = this.state.normalRecomGrouping;
        if (!normalRecomGroupingData?.settingsId) {
            await this.props.getExportSettingsForSmartChartRecom({
                project_id: projectId,
                client_id: this.props.projectReducer?.getProjectByIdResponse?.client?.id,
                user_id: localStorage.getItem("userId")
            });
            const { id: settingsId, config } = this.props.smartChartReducer.exportSettingsData?.data || {};
            normalRecomGroupingData = {
                settingsId,
                grouping: config?.grouping,
                is_merge_narrative: config?.is_merge_narrative,
                sl_no_config: config?.sl_no_config
            };
            this.setState({
                normalRecomGrouping: normalRecomGroupingData
            });
        }
        const { myFilters, dashboardFilterParams, queries } = this.state;
        const result = AppliedQueryFilters(myFilters, queries, "for_export");
        let clonedQueryFilters = _.cloneDeep(result);
        const userId = localStorage.getItem("userId");
        const user_name = localStorage.getItem("user");
        const scope = section.substring(0, section.length - 4);
        const exportSettingsData = this.props.smartChartReducer.exportSettingsData || {};
        const normal_recom_grouping = {
            normal_recom: {
                band1: {
                    settings_id: normalRecomGroupingData?.settingsId || "",
                    grouping: normalRecomGroupingData?.grouping || "",
                    sl_no_config: normalRecomGroupingData?.sl_no_config || null,
                    config_filter: {
                        ...this.state?.params,
                        ...getUpdatedCommonFilters(
                            this.state?.tableDataExportFilters || {},
                            this.state?.params?.list,
                            Object.entries(this.props.recommendationsReducer.entityParams[this.props.match.params.section]?.tableConfig || {})
                        ),
                        wildcard_filters: {
                            ...getUpdatedWildCardFilters(
                                this.state.params?.filters || {},
                                Object.entries(this.props.recommendationsReducer.entityParams[this.props.match.params.section]?.tableConfig || {}),
                                this.props.recommendationsReducer.priorityElementsDropDownResponse,
                                exportSettingsData
                            )
                        },
                        global_search: this?.state?.params?.search || "",
                        sort_by_order: {
                            ...getUpdatedSortFilters(
                                this.state?.params?.order || {},
                                Object.entries(this.props.recommendationsReducer.entityParams[this.props.match.params.section]?.tableConfig || {}),
                                this.state?.params,
                                exportSettingsData
                            )
                        },
                        ...(this?.state?.params?.priority_elements ? { priority_elements: this?.state?.params?.priority_elements } : {}),
                        list: this.state.params.list,
                        order: this.state.params.order,
                        capital_type: this.state.capital_type,
                        start_year: this.state.start_year || null,
                        end_year: this.state.end_year || null,
                        infrastructure_requests: this.state.infrastructure_requests || null,
                        year: this.state.year,
                        dashboard: this.state.dashboard,
                        recommendation_ids: this.state?.selectedRecomIds?.map(item => item.id)
                    },
                    config_filter_names: {
                        list: this.state?.params?.list || null,
                        filters: this.state?.params?.filters,
                        tableDataExportFilters: this.state?.tableDataExportFilters,
                        order: this.state?.params?.order || null,
                        maintenance_year: this.state?.params?.maintenance_year || []
                    },
                    mfilter: (() => {
                        const base = {
                            ..._.merge({}, reverseDynamicFieldParams(dashboardFilterParams), clonedQueryFilters),
                            client_ids: [this.props.projectReducer?.getProjectByIdResponse?.client?.id],
                            project_ids: [projectId],
                            ...(section === "regioninfo" && { region_ids: [id] }),
                            ...(section === "siteinfo" && { site_ids: [id] }),
                            ...(section === "buildinginfo" && { building_ids: [id] }),
                            ...(section === "recommendationsinfo" &&
                                tab === "linked-recommendations" && {
                                    capital_request_id: id
                                }),
                            ...(section === "recommendationsinfo" &&
                                tab === "linked-cr-recommendations" && {
                                    child_cr_recommendation_id: id,
                                    is_cr: true
                                }),
                            ...(tab === "mr-recommendations" && { survey_recommendation_id: this.props.match.params.mrId }),
                            ...(this.props.isCapitalRequest && { is_cr: true }),
                            recommendations: this.state?.selectedRecomIds?.map(item => item.id)
                        };

                        const { masterFilterList } = this.props.dashboardReducer;
                        if (base?.building_types?.length) {
                            const building_type_ids =
                                masterFilterList?.building_types
                                    ?.filter(item => base.building_types.some(elm => elm === item.name))
                                    .map(item => item.id) || [];
                            if (building_type_ids.length) {
                                base.building_types = building_type_ids;
                            }
                        }
                        return this.applyCurrentFindParamsToRecommendationParams(base);
                    })(),
                    number_of_recom: this.state?.selectedRecomIds?.length || this.state?.paginationParams.totalCount,
                    is_soft_cost: exportParam?.includeSoftCost
                }
            }
        };
        // Returned (not just alerted) so Otto can say whether the file downloaded or went to Export History.
        const outcome = await this.props?.normalRecomGrouping(
            this.applyCurrentFindParamsToRecommendationParams({
                ...normal_recom_grouping,
                project_ids: [projectId],
                is_excel: is_excel === "excel",
                ...(this.props?.isAssignRecomView ? { survey_recommendation_project_id: this.props?.survey_recommendation_project_id } : {}),
                ...(tab === "mr-recommendations"
                    ? {
                          survey_recommendation_id: this.props.match.params.mrId
                      }
                    : {}),
                number_of_recom: this.state?.selectedRecomIds?.length || this.state?.paginationParams.totalCount,
                is_soft_cost: exportParam?.includeSoftCost,
                export_from: scope,
                user_id: userId,
                user_name
            })
        );
        if (this.props?.recommendationsReducer?.getNormalRecomDownloadResponse?.success) {
            this.setState({ normalRecomGrouping: {} });
        }
        const { error, message_status } = this.props.recommendationsReducer.getNormalRecomDownloadResponse;
        if (message_status || error) {
            this.setState({ alertMessage: message_status || error }, () => this.showLongAlert());
        }
        this.setState({ isNormalRecomGroupingLoading: false });
        return outcome;
    };

    handleDownloadRegularExcel = async exportParamValue => {
        this.setState({ tableLoading: true });
        const { params, myFilters, dashboardFilterParams, queries, paginationParams } = this.state;
        const {
            match: {
                params: { id, section, tab }
            },
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        const projectId =
            this.props.projectIdDashboard ||
            this.props?.projectIdForSmartChart ||
            query.pid ||
            this.props?.projectIdMobile ||
            this.props.match.params.id ||
            "";
        let normalRecomGroupingData = this.state.normalRecomGrouping;
        if (!normalRecomGroupingData?.settingsId) {
            await this.props.getExportSettingsForSmartChartRecom({
                project_id: projectId,
                client_id: this.props.projectReducer?.getProjectByIdResponse?.client?.id,
                user_id: localStorage.getItem("userId"),
                ...(section === "recommendationsinfo" &&
                    tab === "linked-cr-recommendations" && {
                        is_cr: true
                    }),
                ...(this.props.isCapitalRequest && { is_cr: true })
            });
            const { id: settingsId, config } = this.props.smartChartReducer.exportSettingsData?.data || {};
            normalRecomGroupingData = {
                settingsId,
                grouping: config?.grouping,
                is_merge_narrative: config?.is_merge_narrative,
                sl_no_config: config?.sl_no_config
            };
            this.setState({
                normalRecomGrouping: normalRecomGroupingData
            });
        }
        const userId = localStorage.getItem("userId");
        const userName = localStorage.getItem("user");
        const scope = section.substring(0, section.length - 4);
        const result = AppliedQueryFilters(myFilters, queries, "for_export");
        let clonedQueryFilters = _.cloneDeep(result);

        const {
            tableData: { keys = [], config }
        } = this.state;
        let tableSettings = [];

        keys.filter(key => config?.[key]?.label).forEach((keyItem, i) => {
            const {
                isVisible = false,
                label = "",
                isDynamicField = false,
                smartChartWildCardFilterKey = "",
                isPriorityElement = false,
                keyId = "",
                isYear = false,
                isWaterEnergy = false,
                commonSearchObjectKey,
                isCustomField = false
            } = config?.[keyItem] || {};
            tableSettings.push({
                key: isPriorityElement
                    ? keyId
                    : isYear
                      ? parseInt(label)
                      : isWaterEnergy
                        ? commonSearchObjectKey
                        : smartChartWildCardFilterKey || keyItem,
                heading: label?.toString()?.toUpperCase(),
                is_active: isVisible,
                ...(!isYear && !isPriorityElement && !isDynamicField && !isCustomField ? { is_static_field: true } : {}),
                ...(isDynamicField ? { is_dynamic_field: isDynamicField } : {}),
                ...(isPriorityElement ? { is_priority_element: isPriorityElement } : {}),
                ...(isYear ? { is_year: isYear } : {}),
                ...(isCustomField ? { is_custom_field: isCustomField } : {})
            });
        });

        const baseOrder = params.order || {};
        const sortOrder =
            dashboardFilterParams?.dashboard && !baseOrder["recommendations.project_total"] && !(this?.state?.params?.priority_elements ?? [])?.length
                ? { ...baseOrder, "recommendations.project_total": "desc" }
                : baseOrder;
        const exportSettingsData = this.props.smartChartReducer.exportSettingsData || {};
        const exportParams = {
            normal_recom: {
                band1: {
                    table_settings: tableSettings,
                    config_filter: {
                        ...this.state?.params,
                        ...getUpdatedCommonFilters(
                            this.state?.tableDataExportFilters || {},
                            this.state?.params?.list,
                            Object.entries(this.props.recommendationsReducer.entityParams[this.props.match.params.section]?.tableConfig || {})
                        ),
                        wildcard_filters: {
                            ...getUpdatedWildCardFilters(
                                this.state.params?.filters || {},
                                Object.entries(this.props.recommendationsReducer.entityParams[this.props.match.params.section]?.tableConfig || {}),
                                this.props.recommendationsReducer.priorityElementsDropDownResponse,
                                exportSettingsData
                            )
                        },
                        global_search: this?.state?.params?.search || "",
                        sort_by_order: {
                            ...getUpdatedSortFilters(
                                sortOrder || {},
                                Object.entries(this.props.recommendationsReducer.entityParams[this.props.match.params.section]?.tableConfig || {}),
                                this.state?.params,
                                exportSettingsData
                            )
                        },
                        ...(this?.state?.params?.priority_elements ? { priority_elements: this?.state?.params?.priority_elements } : {}),
                        list: this.state.params.list,
                        order: sortOrder,
                        capital_type: this.state.capital_type,
                        start_year: this.state.start_year || null,
                        end_year: this.state.end_year || null,
                        infrastructure_requests: this.state.infrastructure_requests || null,
                        year: this.state.year,
                        dashboard: this.state.dashboard,
                        recommendation_ids: this.state?.selectedRecomIds?.map(item => item.id)
                    },
                    config_filter_names: {
                        list: this.state?.params?.list || null,
                        filters: this.state?.params?.filters,
                        tableDataExportFilters: this.state?.tableDataExportFilters,
                        order: this.state?.params?.order || null,
                        maintenance_year: this.state?.params?.maintenance_year || []
                    },
                    mfilter: (() => {
                        const base = {
                            ..._.merge({}, reverseDynamicFieldParams(dashboardFilterParams), clonedQueryFilters),
                            ...(section === "projectinfo" && { project_ids: [id] }),
                            ...(section === "regioninfo" && { region_ids: [id] }),
                            ...(section === "siteinfo" && { site_ids: [id] }),
                            ...(section === "buildinginfo" && { building_ids: [id] }),
                            ...(section === "recommendationsinfo" &&
                                tab === "linked-recommendations" && {
                                    capital_request_id: id
                                }),
                            ...(section === "recommendationsinfo" &&
                                tab === "linked-cr-recommendations" && {
                                    child_cr_recommendation_id: id,
                                    is_cr: true
                                }),
                            ...(tab === "mr-recommendations" && { survey_recommendation_id: this.props.match.params.mrId }),
                            ...(this.props.isCapitalRequest && { is_cr: true }),

                            recommendations: this.state?.selectedRecomIds?.map(item => item.id)
                        };
                        const { masterFilterList } = this.props.dashboardReducer;
                        if (base?.building_types?.length) {
                            const building_type_ids =
                                masterFilterList?.building_types
                                    ?.filter(item => base.building_types.some(elm => elm === item.name))
                                    .map(item => item.id) || [];
                            if (building_type_ids.length) {
                                base.building_types = building_type_ids;
                            }
                        }
                        return this.applyCurrentFindParamsToRecommendationParams(base);
                    })(),
                    number_of_recom: this.state?.selectedRecomIds?.length || paginationParams.totalCount
                }
            },
            project_ids: [projectId],
            is_excel: true,
            number_of_recom: this.state?.selectedRecomIds?.length || paginationParams.totalCount,
            export_from: scope,
            user_id: userId,
            user_name: userName,
            is_soft_cost: exportParamValue?.includeSoftCost,
            ...(this.props?.isAssignRecomView ? { survey_recommendation_project_id: this.props?.survey_recommendation_project_id } : {}),
            ...(tab === "mr-recommendations"
                ? {
                      survey_recommendation_id: this.props.match.params.mrId
                  }
                : {})
        };
        const outcome = await this.props.exportRecommendations(this.applyCurrentFindParamsToRecommendationParams(exportParams));
        const { error, message_status } = this.props.recommendationsReducer.recommendationExportResponse;
        if (message_status || error) {
            this.setState({ alertMessage: message_status || error }, () => this.showLongAlert());
        }
        this.setState({ tableLoading: false });
        // Returned (not just alerted) so Otto can say whether the file downloaded or went to Export History.
        return outcome;
    };

    saveUserTableConfig = async (config, isReset) => {
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        const entity = this.props.isCapitalRequest || query?.is_cr === "true" ? entities.CAPITAL_REQUESTS : entities.RECOMMENDATIONS;
        await saveTableConfig({
            user_id: localStorage.getItem("userId"),
            project_id: this.props.projectIdDashboard || this.props.match.params.id,
            client_id: this.props.projectReducer?.getProjectByIdResponse?.client?.id,
            table_type: entity,
            table_settings: isReset
                ? null
                : { keys: this.state.tableData.keys, config: config || this.state.tableData.config, paneViewEnabled: this.state.paneViewEnabled }
        });
        this.setState({ tableConfigChanged: isReset ? false : true });
    };

    resetAllTableConfig = async () => {
        this.setState({ isTableResetting: true, isLoading: true });
        if (this.state.appliedTableView?.length) {
            this.setState({ appliedTableView: [] });
        } else {
            if (!this.props?.isSmartChartView) {
                await this.saveUserTableConfig(null, true);
            }
        }
        await this.setTableDataConfigBasedOnProject();
        await this.setDynamicJoinParam();
        this.setState({ isTableResetting: false });
        this.refreshRecommendationsList();
    };
    renderRecommendationLog = () => {
        const { openRecommendationLog, tableData } = this.state;
        if (!openRecommendationLog) return null;
        let updatedParams = this.getListParams();
        return (
            <Portal
                body={
                    <RecommendationLog
                        updatedParams={updatedParams}
                        onCancel={() => this.setState({ openRecommendationLog: false })}
                        columnConfig={tableData.config}
                    />
                }
                onCancel={() => this.setState({ openRecommendationLog: false })}
            />
        );
    };
    toggleQueriesModal = () => {
        this.setState({ showQueriesModal: !this.state.showQueriesModal });
    };

    renderQueriesModal = filteredCount => {
        const { showQueriesModal } = this.state;
        if (!showQueriesModal) return null;

        return (
            <Portal
                body={
                    <QueriesModal
                        onCancel={this.toggleQueriesModal}
                        submitMasterFilter={query => this.handleUpdateQuery(query)}
                        handleResetQuery={query => this.handleResetQuery(query)}
                        resetAllQueryFilters={query => this.resetAllQueryFilters(query)}
                        filteredCount={filteredCount}
                        queries={this.state.queries}
                        queryType="filter"
                    />
                }
                onCancel={this.toggleQueriesModal}
            />
        );
    };

    handleUpdateQuery = query => {
        this.setState({ queries: [...this.state.queries, query] }, () => this.refreshRecommendationsList());
    };

    handleResetQuery = query => {
        this.setState({ queries: this.state.queries?.filter(item => item.id !== query.id) }, () => this.refreshRecommendationsList());
    };

    resetAllQueryFilters = () => {
        this.setState({ queries: [] }, () => this.refreshRecommendationsList());
    };
    toggleSavedViewsModal = () => {
        this.setState({ showSavedViews: !this.state.showSavedViews });
    };

    saveTableView = async columnConfig => {
        await this.props.saveFilterQuery(columnConfig);
        if (this.props?.dashboardReducer?.saveQueryResponse?.success) {
            this.setState({ alertMessage: "View saved successfully" }, () => this.showLongAlert());
        }
    };

    renderSavedViewsModal = filteredCount => {
        const { showSavedViews } = this.state;
        if (!showSavedViews) return null;

        return (
            <Portal
                body={
                    <QueriesModal
                        onCancel={this.toggleSavedViewsModal}
                        submitMasterFilter={query => this.handleUpdateSavedView(query)}
                        handleResetQuery={query => this.handleResetSavedView(query)}
                        resetAllQueryFilters={query => this.resetAllSavedView(query)}
                        filteredCount={filteredCount}
                        queries={this.state.appliedTableView}
                        isSavedViews
                        queryType="table_view"
                    />
                }
                onCancel={this.toggleSavedViewsModal}
            />
        );
    };

    handleUpdateSavedView = async query => {
        this.setState({ appliedTableView: [query] });
        this.handleHideColumn(query.filter, "temp");
    };

    handleResetSavedView = async () => {
        await this.setState({ appliedTableView: [], isTableResetting: true, isLoading: true, tableConfigChanged: false });
        await this.setTableDataConfigBasedOnProject();
        await this.setDynamicJoinParam();
        this.setState({ isTableResetting: false });
        await this.refreshRecommendationsList();
    };

    resetAllSavedView = async () => {
        await this.setState({ appliedTableView: [], isTableResetting: true, isLoading: true, tableConfigChanged: false });
        await this.setTableDataConfigBasedOnProject();
        await this.setDynamicJoinParam();
        this.setState({ isTableResetting: false });
        await this.refreshRecommendationsList();
    };

    handleGoToColumn = async gotoKey => {
        if (gotoKey) {
            this.setState({
                setSearchField: gotoKey,
                setHighlightSearchField: gotoKey
            });
        }
    };

    // Otto (table_view) integration. Builds a STABLE tableController (cached) binding the page's real table
    // handlers + live state to the uniform interface Otto's executor drives.
    getOttoTableController = () => {
        if (this._ottoTableController) return this._ottoTableController;
        this._ottoTableController = createTableController({
            getTableData: () => this.state.tableData || {},
            getSort: () => (this.state.params && this.state.params.order) || null,
            getPagination: () => this.state.paginationParams || null,
            sortColumn: key => this.updateTableSortFilters(key),
            hideColumn: tableConfig => this.handleHideColumn(tableConfig),
            pinColumn: key => this.handleColumnPin(key),
            unpinAll: () => this.unPinAllColumn(),
            setPageSize: n => this.handlePerPageChange({ target: { value: String(n) } }),
            resetSort: () => this.resetSort(),
            resetLocalFilters: () => this.resetAllFilters(),
            resetTableConfig: () => this.resetAllTableConfig(),
            // This page is one of the few that OVERRIDES the table_view default (simple Excel only): it
            // declares the ExportPopup's ACTUAL entries (see tableProposal.resolveExport):
            //   simple   -> the "Simple Excel Export" the ExportPopup's first Download File runs.
            //   variants -> the popup's other cards, individually runnable (getOttoExportVariants mirrors
            //               ExportPopup.jsx â€” Normal Grouping / CrossWalk / Criticality-Based), so "export
            //               grouped by building as Word" runs directly instead of hand-off to the popup.
            //   advanced -> the ExportPopup itself, for configuring an export (its settings modals).
            // `formats` stays what the SIMPLE export builds (Excel only) â€” Word lives on the variants â€” so a
            // bare "export to word" grounds to the variants that build Word, never silently to Excel.
            // A FUNCTION because the controller is cached but the export permission (and the project-level
            // crosswalk gate) is read live â€” Otto must not offer what the toolbar doesn't.
            exportCapability: () => ({
                enabled: this.hasOttoExportPermission(),
                formats: ["excel"],
                advanced: true,
                variants: this.getOttoExportVariants()
            }),
            exportTable: (format, opts) => this.ottoExportTable(format, opts),
            exportVariant: (key, opts) => this.ottoExportVariant(key, opts),
            openAdvancedExport: () => this.openOttoAdvancedExport()
        });
        return this._ottoTableController;
    };

    // The SAME permission that gates this page's own export toolbar (`hasExport` in render) â€” entity resolved
    // identically (Capital Requests reuse this container under a different entity).
    hasOttoExportPermission = () => {
        const query = qs.parse(this.props.location.search);
        const entity = this.props.isCapitalRequest || query?.is_cr === "true" ? entities.CAPITAL_REQUESTS : entities.RECOMMENDATIONS;
        return checkPermission("forms", entity, "export");
    };

    // Otto's SIMPLE export = the page's own Simple Excel Export (`/fca/recommendation/simple_excel/`), i.e.
    // exactly what the ExportPopup's "Simple Excel Export â†’ Download File" button does. Returns the outcome
    // so Otto can report an inline download vs a queued background job.
    ottoExportTable = (format, opts) => this.handleDownloadRegularExcel({ includeSoftCost: !!(opts && opts.includeSoftCost) });

    // Otto's view of the ExportPopup's OTHER cards â€” the variant list MIRRORS ExportPopup.jsx (labels,
    // formats, breakdown radios, defaults); change one there and this list must follow (registered in
    // otto-sync's watchlist for exactly that reason). `key` dispatches in ottoExportVariant below;
    // `synonyms` are how a user names the variant in chat. CrossWalk follows the same project-level gate
    // that shows/hides its card in the popup, read LIVE (the exportCapability thunk re-runs per send).
    getOttoExportVariants = () => {
        const entityLabel = this.props.isCapitalRequest ? this.getCrLabel() : "Recommendation";
        const { show_crosswalk_export } = this.props.projectReducer?.getProjectByIdResponse?.miscellaneous || {};
        return [
            {
                key: "grouping",
                label: `Normal ${entityLabel} Grouping`,
                formats: ["excel", "word"],
                synonyms: ["grouping", "grouped", "normal grouping", "normal export", "grouping export"]
            },
            ...(show_crosswalk_export
                ? [
                      {
                          key: "crosswalk",
                          label: "CrossWalk Excel Export",
                          formats: ["excel"],
                          synonyms: ["crosswalk", "cross walk", "crosswalk export"]
                      }
                  ]
                : []),
            {
                key: "criticality",
                label: "Criticality-Based Export",
                formats: ["excel", "word"],
                breakdowns: ["building", "addition", "responsibility"], // first = the popup's default radio
                synonyms: ["criticality", "criticality based", "by criticality", "sorted", "sorted export"]
            }
        ];
    };

    // Run ONE ExportPopup card directly â€” the same container handlers its Download File buttons call, so an
    // Otto-run variant is indistinguishable from a popup-run one. opts arrives resolved by the proposal
    // ({ format, breakdown, includeSoftCost }, defaults = the popup's own). Each handler returns its
    // outcome ({ status: "downloaded" | "queued" | "error" }) so Otto reports what actually happened.
    ottoExportVariant = (key, opts = {}) => {
        const soft = { includeSoftCost: !!opts.includeSoftCost };
        if (key === "grouping") return this.handleNormalRecomGrouping(opts.format === "word" ? "word" : "excel", soft);
        if (key === "crosswalk") return this.exportCrossWalkExcel(soft);
        if (key === "criticality") {
            const breakdown = opts.breakdown || "building";
            return opts.format === "word" ? this.exportToWord(breakdown, soft) : this.exportToExcel(breakdown, soft);
        }
        // Unknown key (a stale declaration) â€” open the chooser rather than dropping the request silently.
        this.openOttoAdvancedExport();
        return { status: "opened" };
    };

    // Open the page's native export CHOOSER for Otto's "Advanced Export". Reuses the same trigger prop
    // TableTopIcons already watches (`openExportToWordModalTrigger`) that the route-based deep link uses, so
    // Otto opens the identical ExportPopup â€” no duplicate modal, no DOM clicking.
    openOttoAdvancedExport = () => {
        this.setState(prevState => ({ openRecommendationExportTrigger: (prevState.openRecommendationExportTrigger || 0) + 1 }));
    };

    // Mount Otto only on the STANDALONE recommendations list — never the add/edit/info forms or the embedded
    // chart / asset / smart-chart / CR views (which reuse this container).
    renderOttoAssistant = () => {
        const { match, isChartView, isAssetView, isSmartChartView, isCapitalRequest, projectId } = this.props;
        if (!canUseOtto()) return null; // super_admin-only gate — central policy in filterAssistant/core/ottoAccess
        const section = match && match.params && match.params.section;
        const isFormView = section === "add" || section === "edit" || section === "recommendationsinfo";
        const isEmbedded = isChartView || isAssetView || isSmartChartView || isCapitalRequest;
        if (isFormView || isEmbedded || projectId == null) return null;
        return (
            <RecommendationsOtto
                projectId={projectId}
                projectIds={projectId != null ? [projectId] : undefined}
                tableController={this.getOttoTableController()}
                myFilters={this.state.myFilters || {}}
                onSetLocalFilters={this.submitMasterFilter}
                onSeedLabels={this.props.seedAiFilterLabels}
            />
        );
    };

    // getTableDataWithStickyColumnLeft spreads a fresh config object, so calling it inline in render gave
    // Table a new config identity every time and made it re-run the expensive work guarded in its
    // componentDidUpdate. tableData comes from state, so its identity is a safe cache key.
    stickyColumnTableDataCache = { tableData: null, result: null };

    getStickyColumnTableData = tableData => {
        const cache = this.stickyColumnTableDataCache;
        if (cache.tableData === tableData) return cache.result;
        const result = getTableDataWithStickyColumnLeft(tableData, "cr_status");
        this.stickyColumnTableDataCache = { tableData, result };
        return result;
    };

    render() {
        const {
            showWildCardFilter,
            paginationParams,
            currentViewAllUsers,
            showViewModal,
            showViewModalExport,
            showAssignConsultancyUsers,
            showAssignClientUsers,
            clients,
            consultancy_users,
            tableData,
            selectedRecommendations,
            selectedRowId,
            summaryRowData,
            logData,
            historyPaginationParams,
            historyParams,
            // permissions,
            logPermission,
            imageResponse,
            multiExportPdfLoader,
            multiExportWordLoader,
            exportWordLoading,
            tableDataExportFilters,
            isInputMode,
            lineEditingEnabled,
            myFilters,
            dashboardFilterParams,
            selectedPreviewId,
            showLineEditView,
            lineEditViewTableData
        } = this.state;
        const {
            match: {
                params: { section, tab }
            },
            location: { search },
            viewOnly = false,
            isSurveyView = false,
            handleSurveyAssign,
            isAssignRecomView = false
        } = this.props;
        let tempIds = localStorage.getItem("recommendationIds") ? JSON.parse(localStorage.getItem("recommendationIds")) : [];
        let priorityElementsData = this.props.recommendationsReducer.priorityElementsDropDownResponse?.priority_elements || [];
        let selectedRecomIds = this.state.selectedRecomIds.map(elem => elem.id);
        let filteredCount = Object.entries(myFilters)?.filter(([key, value]) => value.length)?.length;
        if (myFilters?.start_year || myFilters?.end_year) {
            filteredCount += 1;
        }
        const query = qs.parse(search);
        const entity = this.props.isCapitalRequest || query?.is_cr === "true" ? permissions.CR_RECOMMENDATIONS : permissions.RECOMMENDATIONS;
        const isVerificationRecom = query?.verification === "true";
        const projectId =
            this.props.projectIdDashboard ||
            this.props?.projectIdForSmartChart ||
            query.pid ||
            this.props?.projectIdMobile ||
            this.props.match.params.id ||
            "";

        const tableWrapperClass = lineEditingEnabled ? "fullscreen-table" : "normal-table-container";
        const isAssignedRecom = qs.parse(search)?.is_assignedRecom === "true" && qs.parse(search)?.is_mr !== "true";
        const isCrLinkTab = tab === "linked-recommendations" || tab === "linked-cr-recommendations";
        const tableDataWithStickyColumnLeft = this.getStickyColumnTableData(tableData);
        return (
            <LoadingOverlay active={this.props.parentLoading || this.state.isLoading} spinner={<Loader />} fadeSpeed={10}>
                {(section === "add" || section === "edit") && !isSurveyView ? (
                    <Form
                        key={(this.props.match.params.id || "add") + this.props.location.search}
                        projectId={this.props.projectId}
                        projectIdMobile={this.props?.projectIdMobile}
                        selectedRecommendations={selectedRecommendations}
                        refreshRecommendationsList={this.refreshRecommendationsList}
                        handleAddRecommendations={this.handleAddRecommendations}
                        handleUpdateRecommendations={this.handleUpdateRecommendations}
                        getSiteListBasedOnRegion={this.getSiteListBasedOnRegion}
                        getRegionListBasedOnClient={this.getRegionListBasedOnClient}
                        consultancy_users1={consultancy_users}
                        getDataById={this.getDataById}
                        isChartView={this.props.isChartView}
                        isMobileRequest={this.props?.isMobileRequest || false}
                    />
                ) : section === "recommendationsinfo" &&
                  !this.props?.isCrLinkedRecommendations &&
                  !this.props.isCapitalRequest &&
                  !this.props?.isCrLinkPicker ? (
                    <RecommendationsInfo
                        keys={tableData.keys}
                        config={tableData.config}
                        tableData={getTableSliderData()}
                        getQaQcData={this.getQaQcData}
                        qaqcPendingStatus={this.qaqcPendingStatus()}
                        isProjectReviewer={this.isProjectReviewer}
                        getDataById={this.getDataById}
                        handleUpdateData={this.handleUpdateRecommendations}
                        uploadImages={this.uploadImages}
                        getAllImageList={this.getAllImageList}
                        deleteImages={this.deleteImages}
                        showInfoPage={this.showInfoPage}
                        showDeleteBox={this.openDeleteBox}
                        isChartView={this.props.isChartView}
                        isBuildingLocked={this.props.isBuildingLocked}
                        data={this.props.isBuildingEFCI}
                        updateRecommendationImageComment={this.updateRecommendationImageComment}
                        showRestoreBox={this.openRestoreBox}
                        getAllSettingsLogs={this.getLogData}
                        handlePerPageChangeHistory={this.handlePerPageChangeHistory}
                        handlePageClickHistory={this.handlePageClickHistory}
                        handleGlobalSearchHistory={this.handleGlobalSearchHistory}
                        globalSearchKeyHistory={this.state.historyParams && this.state.historyParams.search ? this.state.historyParams.search : ""}
                        logData={logData}
                        handleDeleteLog={this.handleDeleteLog}
                        historyPaginationParams={historyPaginationParams}
                        handleRestoreLog={this.HandleRestoreRegionLog}
                        historyParams={historyParams}
                        updateLogSortFilters={this.updateLogSortFilters}
                        permissions={{}}
                        logPermission={logPermission}
                        imageResponse={imageResponse}
                        handleSelect={this.props.handleSelect}
                        handleSelectAll={this.props.handleSelectAll}
                        assignProjectModal={this.props.assignProjectModal}
                        recomentationIds={this.props.recomentationIds}
                        hasEdit={
                            checkPermission("forms", entity, "edit") &&
                            !isSurveyView &&
                            !isAssignRecomView &&
                            !isVerificationRecom &&
                            !isAssignedRecom
                        }
                        hasExport={checkPermission("forms", entity, "export")}
                        hasDelete={
                            !this.props.isAssetView &&
                            checkPermission("forms", entity, "delete") &&
                            !isSurveyView &&
                            !isAssignRecomView &&
                            !isVerificationRecom &&
                            !isAssignedRecom
                        }
                        hasLogView={checkPermission("logs", entity, "view")}
                        hasLogDelete={checkPermission("logs", entity, "delete")}
                        hasLogRestore={checkPermission("logs", entity, "restore")}
                        hasInfoPage={checkPermission("forms", entity, "view")}
                        hasCreate={
                            checkPermission("forms", entity, "create") &&
                            !isSurveyView &&
                            !isAssignRecomView &&
                            !isVerificationRecom &&
                            !isAssignedRecom
                        }
                        downloadPdfReport={this.downloadPdfReport}
                        entity={entity}
                        assignImagesToRecom={this.assignImagesToRecom}
                        updateRecommendationImageSort={this.props.updateRecommendationImageSort}
                        updateBudget={this.props.updateBudgetPriority}
                        updateFMP={this.props.updateFMP}
                        updateIR={this.props.updateIR}
                        updateRL={this.props.updateRL}
                        updateContinuousFCA={this.props.updateContinuousFCA}
                        updateSelectedRow={this.updateSelectedRow}
                        getPriorityElementDropDownData={this.getPriorityElementDropDownData}
                        postExport={this.postExport}
                        exportLoader={this.state.exportLoader}
                        lockRecommendation={this.lockRecommendation}
                        getDynamicFields={this.props.getDynamicFields}
                        createRecommendationFromCr={this.createRecommendationFromCr}
                        getProjectById={this.props.getProjectById}
                    />
                ) : (
                    <RecommendationsMain
                        getOpinionsFilterResponse={this.props.recommendationsReducer.getOpinionsFilterResponse?.list}
                        filterByOpinions_cost={this.filterByOpinions_cost}
                        showWildCardFilter={showWildCardFilter}
                        paginationParams={paginationParams}
                        currentViewAllUsers={currentViewAllUsers}
                        showViewModal={this.showViewModal}
                        showViewModalExport={this.showViewModalExport}
                        tableData={tableDataWithStickyColumnLeft}
                        handleGlobalSearch={this.handleGlobalSearch}
                        globalSearchKey={this.state.params.search}
                        updateSelectedRow={this.updateSelectedRow}
                        selectedRowId={selectedRowId}
                        toggleWildCardFilter={this.toggleWildCardFilter}
                        updateCurrentViewAllUsers={this.updateCurrentViewAllUsers}
                        handleDeleteRecommendations={this.handleDeleteRecommendations}
                        showEditPage={this.showEditPage}
                        handlePerPageChange={this.handlePerPageChange}
                        handlePageClick={this.handlePageClick}
                        showAddForm={this.showAddForm}
                        showInfoPage={this.showInfoPage}
                        updateWildCardFilter={this.updateWildCardFilter}
                        wildCardFilter={this.state.params.filters}
                        handleHideColumn={this.handleHideColumn}
                        getListForCommonFilterRecommendation={this.getListForCommonFilter}
                        updateCommonFilter={this.updateCommonFilter}
                        commonFilter={this.state.params.list}
                        resetAllFilters={this.resetAllFilters}
                        updateTableSortFilters={this.updateTableSortFilters}
                        updateLastSortFilter={this.updateLastSortFilter}
                        resetSort={this.resetSort}
                        tableParams={this.state.params}
                        isImageView={this.props.isImageView}
                        isBuildingLocked={this.props.isBuildingLocked}
                        summaryRowData={summaryRowData}
                        exportTableXl={this.exportTableXl}
                        tableLoading={this.state.tableLoading}
                        exportExcelAllTrades={this.exportAllTrades}
                        exportAllTradesLoading={this.state.exportAllTradesLoading}
                        showRestoreModal={this.showRestoreModal}
                        selectFilterHandler={this.selectFilterHandler}
                        selectFilterHandlerInitiative={this.selectFilterHandlerInitiative}
                        selectedDropdown={this.state.selectedDropdown}
                        selectedDropdownInitiaive={this.state.selectedDropdownInitiaive}
                        // permissions={{}}
                        logPermission={logPermission}
                        handleSelect={this.props.handleSelect}
                        handleSelectAll={this.props.handleSelectAll}
                        assignProjectModal={this.assignInitiative}
                        recomentationIds={this.props.recomentationIds}
                        enableButton={selectedRecomIds?.length}
                        idCount={tempIds.length}
                        unAassignContent={this.unAassignContent}
                        hasExport={checkPermission("forms", entity, "export")}
                        showAddButton={!lineEditingEnabled && checkPermission("forms", entity, "create") && !isSurveyView && !isAssignRecomView}
                        hasEdit={
                            !this.props.isImageView &&
                            !this.props.isAssetView &&
                            checkPermission("forms", entity, "edit") &&
                            !isSurveyView &&
                            !isAssignRecomView &&
                            !isCrLinkTab
                        }
                        hasDelete={
                            !this.props.isAssetView &&
                            checkPermission("forms", entity, "delete") &&
                            !isSurveyView &&
                            !isAssignRecomView &&
                            !isCrLinkTab
                        }
                        hasInfoPage={!this.props.isSmartChartView && checkPermission("forms", entity, "view") && !isSurveyView}
                        entity={entity}
                        handleSelectRecom={this.handleSelectRecom}
                        handleSelectAllRecom={this.handleSelectAllRecom}
                        selectedRecomIds={selectedRecomIds}
                        isBudgetPriority={this.props.isBudgetPriority}
                        isFullscreen={this.props.isFullscreen}
                        handleFullView={this.props.handleFullView}
                        toggleSecondChartView={this.props.toggleSecondChartView}
                        tableRef={this.tableRef}
                        hasNewlyCreated={true}
                        hasNewlyEdited={true}
                        hasViewMyRecommendation={true}
                        hasViewExportModal={true}
                        hasFilterByImages={true}
                        hasFilterByMyQa={!this.props.isSmartChartView}
                        hasFilterByQaStatus={!this.props.isSmartChartView}
                        filterBySurveyor={this.filterBySurveyor}
                        filterByImages={this.filterByImages}
                        filterByReviews={this.filterByReviews}
                        filterByQaStatus={this.filterByQaStatus}
                        filterByAnyKey={this.filterByAnyKey}
                        resetAll={this.resetAll}
                        isColunmVisibleChanged={this.isColunmVisibleChanged}
                        hasMultiAction={!this.props.isBudgetPriority && !this.props.isImageView && !this.props.isAssetView && !isAssignRecomView}
                        isAssetView={this.props.isAssetView}
                        handleEditMultiSelectedData={this.toggleMultiSelectEditForm}
                        showSelectedRecom={this.showSelectedRecom}
                        clearSelection={this.clearSelection}
                        onBulkQaCompleted={this.handleBulkQaCompleted}
                        everyItemCheckedPerPage={tableData?.data?.every(item => selectedRecomIds.includes(item.id))}
                        selectWholeRecommendation={this.selectWholeRecommendation}
                        hasIrRecommendation={true}
                        priorityElementsData={priorityElementsData}
                        exportSelectedRecom={this.exportSelectedRecom}
                        multiExportPdfLoader={multiExportPdfLoader}
                        multiExportWordLoader={multiExportWordLoader}
                        exportToWordFile={this.exportToWord}
                        exportToExcelFiles={this.exportToExcel}
                        exportWordLoading={exportWordLoading}
                        tableDataExportFilters={tableDataExportFilters}
                        isInputMode={isInputMode}
                        handleCellFocus={this.handleCellFocus}
                        handleCellValueChange={this.handleCellValueChange}
                        lineEditingEnabled={lineEditingEnabled}
                        toggleLineEditing={this.toggleLineEditing}
                        handleColumnPin={this.handleColumnPin}
                        updateColumnWidthInConfig={this.props.isSmartChartView ? false : this.updateColumnWidthInConfig}
                        pinnedColumnsRef={this.pinnedColumnsRef}
                        isSmartChartView={this.props.isSmartChartView}
                        unPinAllColumn={this.unPinAllColumn}
                        createAssetRecommendation={this.createAssetRecommendation}
                        openFiltersPopup={this.toggleFiltersPopup}
                        filteredCount={filteredCount}
                        toggleShiftCspModal={this.toggleShiftCspModal}
                        dashboardFilterParams={dashboardFilterParams}
                        myFilters={myFilters}
                        toggleAppliedFiltersPopup={this.toggleAppliedFiltersPopup}
                        isCapitalRequest={this.props.isCapitalRequest}
                        isCrLinkedRecommendations={this.props?.isCrLinkedRecommendations}
                        createRecommendationFromCr={this.createRecommendationFromCr}
                        toggleLinkRecommendationModal={this.toggleLinkRecommendationModal}
                        unlinkSelectedRecommendations={this.unlinkSelectedRecommendations}
                        isTableResetting={this.state.isTableResetting}
                        handleNormalRecomGrouping={this.handleNormalRecomGrouping}
                        isNormalRecomGroupingLoading={this.state?.isNormalRecomGroupingLoading}
                        lineEditDropdownValue={this.state.lineEditDropdownValue}
                        lineEditSuggestionValue={this.state.lineEditSuggestionValue}
                        hasPrefixSuggestionMatch={isVerbValidationEnabled()}
                        isDropdownLoading={this.state?.isDropdownLoading}
                        resetAllTableConfig={this.resetAllTableConfig}
                        openRecommendationLog={() => this.setState({ openRecommendationLog: true })}
                        isMobileRequest={this.props?.isMobileRequest || false}
                        showRecommendationAddBtn={this.props?.showRecommendationAddBtn || false}
                        toggleQueriesModal={this.toggleQueriesModal}
                        toggleSavedViewsModal={this.toggleSavedViewsModal}
                        onRefreshRecommendationsTable={() => this.refreshRecommendationsList()}
                        queries={this.state.queries}
                        appliedTableView={this.state.appliedTableView}
                        imageResponse={imageResponse}
                        selectedPreviewId={selectedPreviewId}
                        getAllImageList={this.getAllImageList}
                        onPreviewCancel={this.onPaneViewClose}
                        OnPaneViewClick={this.onPaneViewClick}
                        paneViewEnabled={this.state?.paneViewEnabled}
                        deleteImage={this.deleteImage}
                        updateImage={this.updateImage}
                        viewOnly={viewOnly}
                        tableWrapperClass={tableWrapperClass}
                        parentLoading={this.props.parentLoading || this.state.isLoading}
                        assignedRecoms={this.props?.assignedRecoms}
                        hasSurveyAssign={isSurveyView}
                        handleSurveyAssign={handleSurveyAssign}
                        isCrLinkPicker={this.props?.isCrLinkPicker}
                        isAssignRecomView={isAssignRecomView}
                        searchField={this.state?.setSearchField}
                        setSearchField={() => {
                            this.setState({ setSearchField: null });
                        }}
                        setHighlightSearchField={this.state?.setHighlightSearchField}
                        hasGoToFunctionality={true}
                        hasSearchAndReplace={checkPermission(
                            "forms",
                            this.props.isCapitalRequest || query?.is_cr === "true"
                                ? permissions.CR_RECOMMENDATIONS_SEARCH_AND_REPLACE
                                : permissions.RECOMMENDATIONS_SEARCH_AND_REPLACE,
                            "edit"
                        )}
                        toggleSearchAndReplaceModal={this.toggleSearchAndReplaceModal}
                        isFound={this.state.params?.findParams}
                        openExportToWordModalTrigger={this.state.openRecommendationExportTrigger}
                        groupEditProgressClick={() => this.setState({ progressBarModal: true })}
                        showMultiEditPorgress={
                            this.getActiveBackgroundTaskId() &&
                            this.props.recommendationsReducer?.getGroupEditProgressResponse?.data?.status !== 3 &&
                            this.props.recommendationsReducer?.getGroupEditProgressResponse?.data?.id
                        }
                        progressFailed={Number(this.props.recommendationsReducer?.getGroupEditProgressResponse?.data?.status) === 4}
                    />
                )}

                {this.renderOttoAssistant()}

                {this.renderConfirmationModal()}
                {this.renderRestoreConfirmationModal()}
                {this.renderConfirmationModalLog()}
                {this.renderConfirmationModalUnassign()}
                {this.renderMultiSelectEditForm()}
                {this.renderHardDeleteConfirmationModal()}
                {this.renderFiltersPopup()}
                {this.renderShiftCspModal()}
                {this.renderLinkRecommendationModal()}
                {this.renderCrUnlinkConfirmModal()}
                {this.renderAppliedFilters()}
                {this.renderAssingConfirmationModal()}
                {this.renderRecommendationLog()}
                {this.renderQueriesModal()}
                {this.renderSavedViewsModal()}
                {this.renderForceUpdateConfirmationModal()}
                {this.renderSearchAndReplaceModal()}
                {this.renderProgressBarModal()}

                {showViewModal ? (
                    <Portal
                        body={
                            <DynamicColumnModal
                                tableData={tableData}
                                handleHideColumn={this.handleHideColumn}
                                onCancel={() => {
                                    this.setState({ showViewModal: false });
                                    this.props?.isDraggable && this.props?.isDraggable(false);
                                }}
                                isDraggable={this.props?.isDraggable}
                                hasSaveViews
                                saveTableView={this.saveTableView}
                                handleGoToColumn={this.handleGoToColumn}
                            />
                        }
                        onCancel={() => {
                            this.setState({ showViewModal: false });
                            this.props?.isDraggable && this.props?.isDraggable(false);
                        }}
                    />
                ) : null}
                {showViewModalExport?.show ? (
                    <Portal
                        body={
                            <ViewExportModal
                                keys={tableData.keys}
                                config={tableData.config}
                                tableData={tableData}
                                handleHideColumn={this.handleHideColumn}
                                onCancel={() => {
                                    this.setState({ showViewModalExport: { show: false, type: "" } });
                                    this.props?.isDraggable && this.props?.isDraggable(false);
                                }}
                                projectIdForSmartChart={projectId}
                                isSmartChartView={this.props?.isSmartChartView || showViewModalExport?.type === "normalRecomGrouping"}
                                isSmartchartRecommendation={
                                    this.props?.isSmartChartView || showViewModalExport?.type === "normalRecomGrouping" || false
                                }
                                clientIdForSmartChart={
                                    showViewModalExport?.type === "normalRecomGrouping" || showViewModalExport?.type === "sortedRecommendation"
                                        ? this.props.projectReducer?.getProjectByIdResponse?.client?.id
                                        : this.props?.clientIdForSmartChart
                                }
                                setNormalRecomData={
                                    showViewModalExport?.type === "normalRecomGrouping"
                                        ? ({ settingsId, groupingData, mergeNarrative, slNoConfig }) =>
                                              this.setState({
                                                  normalRecomGrouping: {
                                                      settingsId,
                                                      grouping: groupingData,
                                                      is_merge_narrative: mergeNarrative,
                                                      sl_no_config: slNoConfig
                                                  }
                                              })
                                        : this.props?.setNormalRecomData
                                }
                                smartChartTileConfig={this.props?.smartChartTileConfig}
                                isDraggable={this.props?.isDraggable}
                                grouping={this.props?.isSmartChartView || showViewModalExport?.type === "normalRecomGrouping"}
                                viewOnly={viewOnly}
                                isCR={(section === "recommendationsinfo" && tab === "linked-cr-recommendations") || this.props.isCapitalRequest}
                                hasMergeNarrativeCheckbox={this.props?.isSmartChartView && !this.props.isExcelExport}
                                normalRecomConfig={showViewModalExport?.type === "normalRecomGrouping" ? this.state?.normalRecomGrouping : null}
                                isRegularTableView={showViewModalExport?.type === "normalRecomGrouping"}
                            />
                        }
                        onCancel={() => {
                            this.setState({ showViewModalExport: { show: false, type: "" } });
                            this.props?.isDraggable && this.props?.isDraggable(false);
                        }}
                    />
                ) : null}

                {showAssignConsultancyUsers ? (
                    <Portal
                        body={
                            <AssignConsultancyUserModal
                                onCancel={() => this.setState({ showAssignConsultancyUsers: false })}
                                userList={consultancy_users}
                            />
                        }
                        onCancel={() => this.setState({ showAssignConsultancyUsers: false })}
                    />
                ) : null}
                {showAssignClientUsers ? (
                    <Portal
                        body={<AssignClientUserModal onCancel={() => this.setState({ showAssignClientUsers: false })} userList={clients} />}
                        onCancel={() => this.setState({ showAssignClientUsers: false })}
                    />
                ) : null}
            </LoadingOverlay>
        );
    }
}

const mapStateToProps = state => {
    const {
        recommendationsReducer,
        initativeReducer,
        siteReducer,
        buildingReducer,
        commonReducer,
        regionReducer,
        projectReducer,
        dashboardReducer,
        smartChartReducer,
        recommendationStatusReducer,
        imageReducer,
        assetReducer
    } = state;
    return {
        recommendationsReducer,
        initativeReducer,
        siteReducer,
        buildingReducer,
        commonReducer,
        regionReducer,
        projectReducer,
        dashboardReducer,
        smartChartReducer,
        recommendationStatusReducer,
        imageReducer,
        assetDropdownList: assetReducer.dropDownList
    };
};

export default withRouter(
    connect(mapStateToProps, {
        ...recommendationsActions,
        ...siteActions,
        ...buildingActions,
        ...CommonActions,
        ...regionActions,
        ...projectAction,
        ...initativeAction,
        ...smartChartAction,
        ...statusAction,
        ...imageAction,
        syncProjectCost: softCostActions.syncProjectCost,
        getDropdownList: assetActions.getDropdownList,
        saveFilterQuery: dashboardActions.SaveFilterQuery,
        seedAiFilterLabels: dashboardActions.seedAiFilterLabels
    })(index)
);
